import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import { Button ,Popup, ScrollView} from 'devextreme-react';
import FormField from '../../../../dynamicFormBuilder/FormField'
import data from "../../../../assets/apiRoutes.json";
import axios from "axios";
import { custom } from 'devextreme/ui/dialog';

import ValidationSummary from 'devextreme-react/validation-summary';
import DropDownButton from 'devextreme-react/drop-down-button';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { alert, confirm } from 'devextreme/ui/dialog';
import ShowNegativeValueForShipment from './ShowNegativeValueForShipment';
import Toolbar, { Item } from "devextreme-react/toolbar";
import PalletTrackingTab from './PalletTrackingTab';
import TransactionChargesTab from './TransactionChargesTab';
import RFAuditGrid from "./RFAuditGrid";
import AdditionalTab from './AdditionalTab';
import TransportationTab from './TransportationTab';
import SchedulingTab from './SchedulingTab';
import { GetFormatedDateWithTime, downloadReportFile } from '../../../../common/Utils'
import { ERROR_SEVERITY, formatErrorList } from '../../../../common/apiErrors'
import { CONCURRENCY_HANDLED, getApiErrorMessage } from '../../../../common/concurrency'
import UserDefinedTab from "./UserDefinedTab";
import LaborTrackingTab from "./LaborTrackingTab";
import APIMessagesTab from "./APIMessagesTab";
import InspectionTab from "./InspectionTab";
import CancelledDetailsTab from "./CancelledDetailsTab";
import DetailsTab from "./DetailsTab";
import PopupShippingForm from './PopupShippingForm';
import CustomerCredit from "../../../../id/common/customer/CustomerCredit";
import SummaryTab from "../../../../id/common/customer/SummaryTab";
import ShowCrateAllocationForm from "../../crate/ShowCrateAllocationForm";
import ItemRateScheduleDialog from "./ItemRateScheduleDialog";
import BlankLocationsGrid from "./BlankLocationsGrid";
import EntityInfoBar from "../../../../common/EntityInfoBar";
import routes from "../../../../assets/apiRoutes.json";
import {Enum, EMPTY_GUID, TransactionStage,Options, TransactionStageEnum, TransactionStageShortLabels, Generic, LocationStatus, ShipmentsOnNegativeAvailable, TransactionStatus, TransactionTypes, ReportFilterOperator, Statuses, ReportTypes, ReportFieldTypes, TransportationModes, ReplicateLotBasis, PrintFlags, EdiTransmitFlags, ReplicateSourceTableName, RecordTypes, YesNo, AllowItemDetails} from "../../../../enum/Enum";
import { MESSAGES } from "../../../../common/Messages";
import CommitTransactionsPrintErrors from "../commitTransactions/WMTransactionsPrintErrors";
import  GenerateItemTaskForm  from "./headerOperations/generateItemTasks/Form"
import FMTransHeader from '../../../../fm/transaction/component/FMTransHeader';
import Contacts from "./headerOperations/showContacts/Contacts";
import BillToCharges from "./headerOperations/itemTransactionChargesBillTo/BillToCharges";
import CreateRepackShipments from "./headerOperations/createRepackShipments/CreateRepackShipments";
import CreateTransactionCharges from "./headerOperations/createTransactionCharges/CreateTransactionCharges";
import ProShipShipment from "./headerOperations/proShipShipment/ProShipShipment";
import SignatureCapture from "./headerOperations/captureSignature/SignatureCapture";
import ShowSignature from "./headerOperations/showSignature/ShowSignature";
import TransactionSignatures from "./headerOperations/transactionSignatures/TransactionSignatures";
import Replicate from "./headerOperations/replicate/Replicate";
import ReplicateTransactions from "./headerOperations/replicateTransactions/ReplicateTransactions";
import ReplicateShipmentAutoLot from "./headerOperations/replicateTransactions/ReplicateShipmentAutoLot";
import ReplicateShipmentManualLot from "./headerOperations/replicateTransactions/ReplicateShipmentManualLot";
import DefaultShipmentItems from "./headerOperations/defaultShipmentItems/DefaultShipmentItems";
import AdjustAvailableUnAvailableStatus from "../../locationtracking/AdjustAvailableUnAvailableStatus";
import AdjustAvailableUnAvailableStatusMainPopup from "../../common/AdjustAvailableUnAvailableStatusMainPopup";
import Invoices from "./headerOperations/showInvoices/Invoices";

const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "R_PROFILE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Profile",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "R_CUSTOMER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Customer",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSACTIONTYPE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Type",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TRANSACTIONNUMBER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Transaction #",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "STAGE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Stage",
                "type": "select",
                "options": [],
                "apiUrl": null,
                "grid": null,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
                
            },
            {
                "name": "R_SHIPPER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_CONSIGNEE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consignee",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "STATUS",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Status",
                "type": "select",
                "options": [],
                "apiUrl": null,
                "grid": null,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "HOLDREASON",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Hold Reason",
                "type": "select",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "TRANSACTIONDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Order Date",
                "type": "datetime",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": true,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "ACTUALRECEIVEDSHIPPEDDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Recv/Ship Date",
                "type": "datetime",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "SHIPPERBOLNUMBER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper's Number",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REFERENCE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "PO/Reference",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_RATESCHEDULE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Rate Schedule",
                "type": "select",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "TRANSACTIONGROUP",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Trans Group",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "COMMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Comment",
                "type": "textarea",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]

var skipDataLoading = false;
/** WMTRANSACTIONHEADER.STAGE code -> its one-word label, for the header info bar. Zipped from the
 *  existing enums so the codes are never restated here. The full TransactionStageDescriptions ran the
 *  bar under the toolbar buttons, and they belong to the Stage dropdowns, so the short labels live
 *  beside them in Enum.js rather than being derived by trimming. */
const WM_STAGE_TEXT = Object.fromEntries(
    Object.entries(TransactionStageEnum).map(([key, code]) => [code, TransactionStageShortLabels[key]])
);
/** Grace period after a Date Validation dialog resolves, covering DevExtreme's hide animation and the
 *  focus restore it performs on the way out. See checkDateWindow. */
const DATE_WINDOW_DIALOG_SETTLE_MS = 250;

function WMTransactionDataEntryForm(props) {
    const history = useHistory();
    const location = useLocation();
    var accessToken = props.oidc.user.access_token;
    const buttonDropDownOptions = { width: 430, height: 700 };
    const profileDataRef = useRef(null);
    // Choices returned by the WMD0113 Replicate Transactions dialog, consumed by the
    // replicate-on-save step (WMD0002.qeWMTransactionHeaderAfterCommit).
    const replicateParamsRef = useRef(null);
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [isTransactionDisabled, setIsTransactionDisabled] = useState(true);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [disableGridsForRFTransactions, setDisableGridsForRFTransactions] = useState(false);
    const [isLineItemExist, setIsLineItemExist] = useState(null);
    const isLineItemExistRef = useRef(isLineItemExist);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [isCommittedTransaction, setIsCommittedTransaction] = useState(false);
    const [showNegativePopup, setShowNegativePopup] = useState({ visible: false, data: [] });
    /** Which top-level tab is open. Only read to decide whether the header info bar shows; the
     *  TabPanel below stays uncontrolled (no selectedIndex prop), so nothing else changes. */
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [showShippingForm, setShowShippingForm] = useState(false);
    const [showCustomerCreditForm, setShowCustomerCreditForm] = useState(false);
    const [showSummaryForm, setShowSummaryForm] = useState(false);
    const [showCrateAllocationForm, setShowCrateAllocationForm] = useState(false);
    const [showItemRateScheduleDialog, setShowItemRateScheduleDialog] = useState(false);
    // stageTo / stageFrom state removed: they existed only to carry the pending stage into
    // ItemRateScheduleDialog so it could move the stage on the way out. The stage now moves before that
    // dialog opens, so nothing needs to hold it. See itemRateScheduleSideTrip.
    const [emptyLocations, setEmptyLocations] = useState([]);
    const [showBlankLocations, setShowBlankLocations] = useState(false);
    const [ShowAdjustAvailableUnavailableStatusPopup,setShowAdjustAvailableUnavailableStatusPopup] = useState({id:null,visible:false});
    const initialTotals = {
        items: 0.00,
        ordered: 0.00,
        netWeight: 0.00,
        actual: 0.00,
        grossWeight: 0.00,
        inventory: 0.00,
        amount: 0.00,
    }
    const [selectedTotals, setSelectedTotals] = useState(initialTotals);
    useEffect(() => {
        isLineItemExistRef.current = isLineItemExist;
      }, [isLineItemExist]);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});

    /** Resolve a live DevExtreme widget from formRefs.
     *  devextreme-react rebuilds an editor's imperative handle on every update, so a truthy
     *  `.instance` is NOT proof the widget is reachable — `instance()` returns undefined while
     *  React is still committing. Never call `.instance().option(...)` without going through this. */
    const getFieldInstance = (name) => {
        const field = formRefs.current?.[name];
        const instance = typeof field?.instance === 'function' ? field.instance() : undefined;
        return typeof instance?.option === 'function' ? instance : undefined;
    };

    const detailsTabGrid = useRef(null);
    const transactionChargesTabGrid = useRef(null);
    const detailTransactionChargesTabGrid = useRef(null);
    const canceledItemsTabGrid = useRef(null);
    const subLotdataGrid = useRef(null);
    const locationDataGrid = useRef(null);
    const [shippingFormData, setShippingFormData] = useState({
        quote: '',
        route: '',
        originCarrier: '',
        originJunction: '',
        secondCarrier: '',
        secondJunction: '',
        thirdCarrier: '',
        thirdJunction: '',
        fourthCarrier: '',
        fourthJunction: '',
        fifthCarrier: '',
        fifthJunction: '',
        sixthCarrier: '',
        sixthJunction: '',
        comment: '',
        Customer: '',
        Shipper: '',
        Consignee: '',
        Carrier: '',
    });
    const handleFormSubmit = async (e) => {
        
        try {
            e.preventDefault();
           const isEmptyLocations = await CheckEmptyLocations();
            if (!isEmptyLocations) return;

           const isValid= await handleTransferToFM();
           if(isValid===false) return;
           setLoadPanelVisible(true);
           setIsFormSubmitted(true);
            // IgnoreWarnings: false is what makes this a *pre-flight*. The API defaults it to true so an
            // ordinary save only reports blocking errors; this call deliberately asks for the warnings too,
            // so the confirm() below has something to show. The save calls that follow send the bare
            // formFields and therefore keep the suppressing default.
            var res = await axios.post
                (
                    `${window._env_.REACT_APP_APIS}/wm/Transaction/ValidateTransaction`,
                    { ...formFields, IgnoreWarnings: false },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                );

            if (res.data.issuccess) {
                if (formFields.ROWID == "00000000-0000-0000-0000-000000000000") {
                    await postTransaction();
                }
                else {
                    await updateTransaction();
                }

            }
            else if (res.data.iswarning) {
                const errorList = formatErrorList(res.data.errors, ERROR_SEVERITY.WARNING);
                let result = confirm("<i>" + errorList + "</i>", "Warning");
                result.then(async (dialogResult) => {
                    if (dialogResult) {
                        if (formFields.ROWID == "00000000-0000-0000-0000-000000000000") {
                            await postTransaction();
                        }
                        else {
                            await updateTransaction();
                        }
                        if(res.data.message){
                            alert(res.data.message, "Info");
                        }
                    }
                    else {
                        setIsFormSubmitted(false);
                        if(res.data.message){
                            alert(res.data.message, "Info");
                        }
                    }
                });

            }
            else {
                // Filtering to ERROR is load-bearing, not tidiness: when a blocking error is present the
                // server forces iswarning back to false while leaving any WARNING entries in the array, so
                // without the filter the error dialog would also list warnings the user cannot act on.
                const errorList = formatErrorList(res.data.errors, ERROR_SEVERITY.ERROR);
                alert(errorList, "Error");
                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            // A refusal now arrives as a real 4xx, so it lands here instead of in the else branch above.
            // This catch used to only console.error, which meant a refused save showed the user nothing.
            if (!error?.[CONCURRENCY_HANDLED]) {
                notify({ message: formatErrorList(error?.response?.data?.errors, ERROR_SEVERITY.ERROR)
                    || getApiErrorMessage(error, MESSAGES.ERROR), width: 600 }, 'error', 3000);
            }
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const changeTotals = async () => {
        try {
            if (formFields.ROWID === "00000000-0000-0000-0000-000000000000") {
                setSelectedTotals(initialTotals);
            }
            else {
                const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.Transaction.GetTotals}`
                    , {
                        params: {
                            headerRowId: formFields.ROWID,
                        },
                        headers: {
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        }
                    });
                // Guarded: GetTotals used to answer Success = true with result: null when the calculation
                // failed, and setting that blanked every total on the form. It now answers 500, but keep the
                // guard so a null can never reach the form's state.
                if (response.data?.result && isMountedRef.current) {
                    setSelectedTotals(response.data.result);
                }
            }

        } catch (error) {
            console.error('Error fetching totals:', error);
        }
        // Deliberately does NOT touch the load panel. This never raises it, so it must not lower it:
        // it used to end in `finally { setTimeout(hideLoadPanel, 1000) }`, and a useEffect on
        // formFields.ROWID runs it as the page mounts - so opening a transaction armed a one-second
        // timer that pulled the panel down on whatever else was still in flight, GetHeaderInfoById
        // included. Every other caller (the Details/Sub-lot grids, Enter Weights) drives its own
        // indicator via the grid's begin/endCustomLoading and never expected this one to hide it.
    };
    const postTransaction = async () => {
        try {
            const url = "wm/Transaction/PostTransaction";
/*             setformFields(prevFields => ({
                ...prevFields,
                DELIVERYPICKUPDEPARTDATETIME: GetFormatedDateWithTime(formFields.DELIVERYPICKUPDEPARTDATETIME),
                DELIVEREDDATETIME: GetFormatedDateWithTime(formFields.DELIVEREDDATETIME),
                SHIPMENTPLANNEDDATETIMETO:GetFormatedDateWithTime(formFields.SHIPMENTPLANNEDDATETIMETO),
                SHIPMENTPLANNEDDATETIMEFROM: GetFormatedDateWithTime(formFields.SHIPMENTPLANNEDDATETIMEFROM),
                CODCOLLECTIONDATETIME: GetFormatedDateWithTime(formFields.CODCOLLECTIONDATETIME),
                TRANSPORTATIONYARDLEAVEDATE: GetFormatedDateWithTime(formFields.TRANSPORTATIONYARDLEAVEDATE),
                TRUCKARRIVALDATETIME: GetFormatedDateWithTime(formFields.TRUCKARRIVALDATETIME),
                TRUCKDEPARTDATETIME: GetFormatedDateWithTime(formFields.TRUCKDEPARTDATETIME),
                TRANSACTIONDATE: GetFormatedDateWithTime(formFields.TRANSACTIONDATE),
                ACTUALRECEIVEDSHIPPEDDATETIME: GetFormatedDateWithTime(formFields.ACTUALRECEIVEDSHIPPEDDATETIME),
                PLANNEDRECEIVEDSHIPPEDDATETIME: GetFormatedDateWithTime(formFields.PLANNEDRECEIVEDSHIPPEDDATETIME),
                USERDEFINEDDATE_1: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_1),
                USERDEFINEDDATE_2: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_2),
                USERDEFINEDDATE_3: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_3),
                USERDEFINEDDATE_4: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_4),
                USERDEFINEDDATE_5: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_5),
                USERDEFINEDDATE_6: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_6),
                USERDEFINEDDATE_7: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_7),
                USERDEFINEDDATE_8: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_8),
                USERDEFINEDDATE_9: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_9),
                USERDEFINEDDATE_10: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_10),
                USERDEFINEDDATE_11: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_11),
                USERDEFINEDDATE_12: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_12),
                USERDEFINEDDATE_13: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_13),
                USERDEFINEDDATE_14: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_14),
                USERDEFINEDDATE_15: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_15),
                USERDEFINEDDATE_16: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_16),
                USERDEFINEDDATE_17: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_17),
                USERDEFINEDDATE_18: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_18),
                USERDEFINEDDATE_19: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_19),
                USERDEFINEDDATE_20: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_20),
                DELIVERYPICKUPPLANNEDDATETIME: GetFormatedDateWithTime(formFields.DELIVERYPICKUPPLANNEDDATETIME),
                DELIVERYPICKUPARRIVEDATETIME: GetFormatedDateWithTime(formFields.DELIVERYPICKUPARRIVEDATETIME),
                PLANRESOURCESHOURS: GetFormatedDateWithTime(formFields.PLANRESOURCESHOURS),
                STAGINGSTARTDATE: GetFormatedDateWithTime(formFields.STAGINGSTARTDATE),
                STAGINGENDDATE: GetFormatedDateWithTime(formFields.STAGINGENDDATE),
                UNLOADPICKBYPLANDATE: GetFormatedDateWithTime(formFields.UNLOADPICKBYPLANDATE),
                PUTAWAYBYPLANDATE: GetFormatedDateWithTime(formFields.PUTAWAYBYPLANDATE),
                CHECKBYPLANDATE: GetFormatedDateWithTime(formFields.CHECKBYPLANDATE),
                LOADBYPLANDATE: GetFormatedDateWithTime(formFields.LOADBYPLANDATE),
                PICKBYPLANDATE: GetFormatedDateWithTime(formFields.PICKBYPLANDATE),
            })); */
            let fields=formFields;
            
            fields.TRANSACTIONDATE = GetFormatedDateWithTime(formFields.TRANSACTIONDATE);
            fields.DELIVERYPICKUPDEPARTDATETIME= GetFormatedDateWithTime(formFields.DELIVERYPICKUPDEPARTDATETIME);
            fields.DELIVEREDDATETIME= GetFormatedDateWithTime(formFields.DELIVEREDDATETIME);
            fields.SHIPMENTPLANNEDDATETIMETO=GetFormatedDateWithTime(formFields.SHIPMENTPLANNEDDATETIMETO);
            fields.SHIPMENTPLANNEDDATETIMEFROM= GetFormatedDateWithTime(formFields.SHIPMENTPLANNEDDATETIMEFROM);
            fields.CODCOLLECTIONDATETIME= GetFormatedDateWithTime(formFields.CODCOLLECTIONDATETIME);
            fields.TRANSPORTATIONYARDLEAVEDATE= GetFormatedDateWithTime(formFields.TRANSPORTATIONYARDLEAVEDATE);
            fields.TRUCKARRIVALDATETIME= GetFormatedDateWithTime(formFields.TRUCKARRIVALDATETIME);
            fields.TRUCKDEPARTDATETIME= GetFormatedDateWithTime(formFields.TRUCKDEPARTDATETIME);
            fields.TRANSACTIONDATE= GetFormatedDateWithTime(formFields.TRANSACTIONDATE);
            fields.ACTUALRECEIVEDSHIPPEDDATETIME= GetFormatedDateWithTime(formFields.ACTUALRECEIVEDSHIPPEDDATETIME);
            fields.PLANNEDRECEIVEDSHIPPEDDATETIME= GetFormatedDateWithTime(formFields.PLANNEDRECEIVEDSHIPPEDDATETIME);
            fields.USERDEFINEDDATE_1= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_1);
            fields.USERDEFINEDDATE_2= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_2);
            fields.USERDEFINEDDATE_3= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_3);
            fields.USERDEFINEDDATE_4= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_4);
            fields.USERDEFINEDDATE_5= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_5);
            fields.USERDEFINEDDATE_6= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_6);
            fields.USERDEFINEDDATE_7= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_7);
            fields.USERDEFINEDDATE_8= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_8);
            fields.USERDEFINEDDATE_9= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_9);
            fields.USERDEFINEDDATE_10= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_10);
            fields.USERDEFINEDDATE_11= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_11);
            fields.USERDEFINEDDATE_12= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_12);
            fields.USERDEFINEDDATE_13= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_13);
            fields.USERDEFINEDDATE_14= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_14);
            fields.USERDEFINEDDATE_15= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_15);
            fields.USERDEFINEDDATE_16= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_16);
            fields.USERDEFINEDDATE_17= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_17);
            fields.USERDEFINEDDATE_18= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_18);
            fields.USERDEFINEDDATE_19= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_19);
            fields.USERDEFINEDDATE_20= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_20);
            fields.DELIVERYPICKUPPLANNEDDATETIME= GetFormatedDateWithTime(formFields.DELIVERYPICKUPPLANNEDDATETIME);
            fields.DELIVERYPICKUPARRIVEDATETIME= GetFormatedDateWithTime(formFields.DELIVERYPICKUPARRIVEDATETIME);
            fields.PLANRESOURCESHOURS= GetFormatedDateWithTime(formFields.PLANRESOURCESHOURS);
            fields.STAGINGSTARTDATE= GetFormatedDateWithTime(formFields.STAGINGSTARTDATE);
            fields.STAGINGENDDATE= GetFormatedDateWithTime(formFields.STAGINGENDDATE);
            fields.UNLOADPICKBYPLANDATE= GetFormatedDateWithTime(formFields.UNLOADPICKBYPLANDATE);
            fields.PUTAWAYBYPLANDATE= GetFormatedDateWithTime(formFields.PUTAWAYBYPLANDATE);
            fields.CHECKBYPLANDATE= GetFormatedDateWithTime(formFields.CHECKBYPLANDATE);
            fields.LOADBYPLANDATE= GetFormatedDateWithTime(formFields.LOADBYPLANDATE);
            fields.PICKBYPLANDATE= GetFormatedDateWithTime(formFields.PICKBYPLANDATE);
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.data.issuccess) {

                setformFields(prevFields => ({
                    ...prevFields,
                    ROWID: response.data.rowid,
                    RECORDNO: response.data.recordno,
                    TRANSACTIONNUMBER: response.data.transactionno,
                    DELIVERYPICKUPPLANNEDDATETIME: response.data?.deliverypickupplanneddatetime,
                    PLANNEDRECEIVEDSHIPPEDDATETIME: response.data?.plannedreceivedshippeddatetime,
                    STAGINGSTARTDATE: response.data?.stagingstartdate,
                    STAGINGENDDATE: response.data?.stagingenddate,
                }));
                setIsTransactionDisabled(response.data.isTransactionDisabled);
                if (formRefs.current["STAGE"]) {
                    formRefs.current["STAGE"].instance().option('disabled', true);
                }
                if(response.data.isTransactionDisabled){
                    if (formRefs.current["TRANSACTIONNUMBER"]) {
                        formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', true);
                    }
                }else{
                    if (formRefs.current["TRANSACTIONNUMBER"]) {
                        formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', false);
                    }
                }
                if(response.data.actualreceivedshippeddatetime){
                    if (formRefs.current["ACTUALRECEIVEDSHIPPEDDATETIME"]) {
                        formRefs.current["ACTUALRECEIVEDSHIPPEDDATETIME"].instance().option('value', response.data.actualreceivedshippeddatetime);
                        setformFields(prevFields => ({
                            ...prevFields,
                            ACTUALRECEIVEDSHIPPEDDATETIME: response.data.actualreceivedshippeddatetime
                        }));
                    }
                } 
                notify(
                    {
                        message: "Transaction Created",
                        width: 600,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);

                // Delphi replicates the details from the after-commit event, so this runs only once
                // the new header actually exists and has a row id to hang them off.
                // Read before replicateDetailsAfterSave consumes it: Delphi skips WMD0110 for any header
                // the Replicate button produced (FReplicateFlag), whatever was chosen in that dialog.
                const cameFromReplicate = replicateParamsRef.current != null;
                await replicateDetailsAfterSave(response.data.rowid);
                // A replicate arms exactly one save. Header-only leaves the ref set, which would make the
                // next new record on this screen look replicated too.
                replicateParamsRef.current = null;
                if (!cameFromReplicate) {
                    await openDefaultShipmentItems(response.data.rowid);
                }
            } else {
                notify(
                    {
                        message: response.data.message,
                        width: 100,
                    },
                    'error',
                    3000,
                );
                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            // A refusal now arrives as a real 4xx, so it lands here instead of in the else branch above.
            // This catch used to only console.error, which meant a refused save showed the user nothing.
            if (!error?.[CONCURRENCY_HANDLED]) {
                notify({ message: formatErrorList(error?.response?.data?.errors, ERROR_SEVERITY.ERROR)
                    || getApiErrorMessage(error, MESSAGES.ERROR), width: 600 }, 'error', 3000);
            }
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const updateTransaction = async () => {
        
        try {
            const url = "wm/Transaction/PutTransaction";
            /*
            setformFields(prevFields => ({
                ...prevFields,
                DELIVERYPICKUPDEPARTDATETIME: GetFormatedDateWithTime(formFields.DELIVERYPICKUPDEPARTDATETIME),
                DELIVEREDDATETIME: GetFormatedDateWithTime(formFields.DELIVEREDDATETIME),
                SHIPMENTPLANNEDDATETIMETO:GetFormatedDateWithTime(formFields.SHIPMENTPLANNEDDATETIMETO),
                SHIPMENTPLANNEDDATETIMEFROM: GetFormatedDateWithTime(formFields.SHIPMENTPLANNEDDATETIMEFROM),
                CODCOLLECTIONDATETIME: GetFormatedDateWithTime(formFields.CODCOLLECTIONDATETIME),
                TRANSPORTATIONYARDLEAVEDATE: GetFormatedDateWithTime(formFields.TRANSPORTATIONYARDLEAVEDATE),
                TRUCKARRIVALDATETIME: GetFormatedDateWithTime(formFields.TRUCKARRIVALDATETIME),
                TRUCKDEPARTDATETIME: GetFormatedDateWithTime(formFields.TRUCKDEPARTDATETIME),
                TRANSACTIONDATE: GetFormatedDateWithTime(formFields.TRANSACTIONDATE),
                ACTUALRECEIVEDSHIPPEDDATETIME: GetFormatedDateWithTime(formFields.ACTUALRECEIVEDSHIPPEDDATETIME),
                PLANNEDRECEIVEDSHIPPEDDATETIME: GetFormatedDateWithTime(formFields.PLANNEDRECEIVEDSHIPPEDDATETIME),
                USERDEFINEDDATE_1: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_1),
                USERDEFINEDDATE_2: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_2),
                USERDEFINEDDATE_3: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_3),
                USERDEFINEDDATE_4: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_4),
                USERDEFINEDDATE_5: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_5),
                USERDEFINEDDATE_6: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_6),
                USERDEFINEDDATE_7: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_7),
                USERDEFINEDDATE_8: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_8),
                USERDEFINEDDATE_9: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_9),
                USERDEFINEDDATE_10: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_10),
                USERDEFINEDDATE_11: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_11),
                USERDEFINEDDATE_12: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_12),
                USERDEFINEDDATE_13: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_13),
                USERDEFINEDDATE_14: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_14),
                USERDEFINEDDATE_15: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_15),
                USERDEFINEDDATE_16: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_16),
                USERDEFINEDDATE_17: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_17),
                USERDEFINEDDATE_18: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_18),
                USERDEFINEDDATE_19: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_19),
                USERDEFINEDDATE_20: GetFormatedDateWithTime(formFields.USERDEFINEDDATE_20),
                DELIVERYPICKUPPLANNEDDATETIME: GetFormatedDateWithTime(formFields.DELIVERYPICKUPPLANNEDDATETIME),
                DELIVERYPICKUPARRIVEDATETIME: GetFormatedDateWithTime(formFields.DELIVERYPICKUPARRIVEDATETIME),
                PLANRESOURCESHOURS: GetFormatedDateWithTime(formFields.PLANRESOURCESHOURS),
                STAGINGSTARTDATE: GetFormatedDateWithTime(formFields.STAGINGSTARTDATE),
                STAGINGENDDATE: GetFormatedDateWithTime(formFields.STAGINGENDDATE),
                UNLOADPICKBYPLANDATE: GetFormatedDateWithTime(formFields.UNLOADPICKBYPLANDATE),
                PUTAWAYBYPLANDATE: GetFormatedDateWithTime(formFields.PUTAWAYBYPLANDATE),
                CHECKBYPLANDATE: GetFormatedDateWithTime(formFields.CHECKBYPLANDATE),
                LOADBYPLANDATE: GetFormatedDateWithTime(formFields.LOADBYPLANDATE),
                PICKBYPLANDATE: GetFormatedDateWithTime(formFields.PICKBYPLANDATE),
 
            }));*/
            let fields=formFields;
            fields.TRANSACTIONDATE = GetFormatedDateWithTime(formFields.TRANSACTIONDATE);
            fields.DELIVERYPICKUPDEPARTDATETIME= GetFormatedDateWithTime(formFields.DELIVERYPICKUPDEPARTDATETIME);
            fields.DELIVEREDDATETIME= GetFormatedDateWithTime(formFields.DELIVEREDDATETIME);
            fields.SHIPMENTPLANNEDDATETIMETO=GetFormatedDateWithTime(formFields.SHIPMENTPLANNEDDATETIMETO);
            fields.SHIPMENTPLANNEDDATETIMEFROM= GetFormatedDateWithTime(formFields.SHIPMENTPLANNEDDATETIMEFROM);
            fields.CODCOLLECTIONDATETIME= GetFormatedDateWithTime(formFields.CODCOLLECTIONDATETIME);
            fields.TRANSPORTATIONYARDLEAVEDATE= GetFormatedDateWithTime(formFields.TRANSPORTATIONYARDLEAVEDATE);
            fields.TRUCKARRIVALDATETIME= GetFormatedDateWithTime(formFields.TRUCKARRIVALDATETIME);
            fields.TRUCKDEPARTDATETIME= GetFormatedDateWithTime(formFields.TRUCKDEPARTDATETIME);
            fields.TRANSACTIONDATE= GetFormatedDateWithTime(formFields.TRANSACTIONDATE);
            fields.ACTUALRECEIVEDSHIPPEDDATETIME= GetFormatedDateWithTime(formFields.ACTUALRECEIVEDSHIPPEDDATETIME);
            fields.PLANNEDRECEIVEDSHIPPEDDATETIME= GetFormatedDateWithTime(formFields.PLANNEDRECEIVEDSHIPPEDDATETIME);
            fields.USERDEFINEDDATE_1= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_1);
            fields.USERDEFINEDDATE_2= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_2);
            fields.USERDEFINEDDATE_3= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_3);
            fields.USERDEFINEDDATE_4= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_4);
            fields.USERDEFINEDDATE_5= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_5);
            fields.USERDEFINEDDATE_6= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_6);
            fields.USERDEFINEDDATE_7= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_7);
            fields.USERDEFINEDDATE_8= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_8);
            fields.USERDEFINEDDATE_9= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_9);
            fields.USERDEFINEDDATE_10= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_10);
            fields.USERDEFINEDDATE_11= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_11);
            fields.USERDEFINEDDATE_12= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_12);
            fields.USERDEFINEDDATE_13= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_13);
            fields.USERDEFINEDDATE_14= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_14);
            fields.USERDEFINEDDATE_15= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_15);
            fields.USERDEFINEDDATE_16= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_16);
            fields.USERDEFINEDDATE_17= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_17);
            fields.USERDEFINEDDATE_18= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_18);
            fields.USERDEFINEDDATE_19= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_19);
            fields.USERDEFINEDDATE_20= GetFormatedDateWithTime(formFields.USERDEFINEDDATE_20);
            fields.DELIVERYPICKUPPLANNEDDATETIME= GetFormatedDateWithTime(formFields.DELIVERYPICKUPPLANNEDDATETIME);
            fields.DELIVERYPICKUPARRIVEDATETIME= GetFormatedDateWithTime(formFields.DELIVERYPICKUPARRIVEDATETIME);
            fields.PLANRESOURCESHOURS= GetFormatedDateWithTime(formFields.PLANRESOURCESHOURS);
            fields.STAGINGSTARTDATE= GetFormatedDateWithTime(formFields.STAGINGSTARTDATE);
            fields.STAGINGENDDATE= GetFormatedDateWithTime(formFields.STAGINGENDDATE);
            fields.UNLOADPICKBYPLANDATE= GetFormatedDateWithTime(formFields.UNLOADPICKBYPLANDATE);
            fields.PUTAWAYBYPLANDATE= GetFormatedDateWithTime(formFields.PUTAWAYBYPLANDATE);
            fields.CHECKBYPLANDATE= GetFormatedDateWithTime(formFields.CHECKBYPLANDATE);
            fields.LOADBYPLANDATE= GetFormatedDateWithTime(formFields.LOADBYPLANDATE);
            fields.PICKBYPLANDATE= GetFormatedDateWithTime(formFields.PICKBYPLANDATE);
            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.data.issuccess) {
                setformFields(prevFields => ({
                    ...prevFields,
                    DELIVERYPICKUPPLANNEDDATETIME: response.data?.deliverypickupplanneddatetime,
                    PLANNEDRECEIVEDSHIPPEDDATETIME: response.data?.plannedreceivedshippeddatetime,
                    STAGINGSTARTDATE: response.data?.stagingstartdate,
                    STAGINGENDDATE: response.data?.stagingenddate,
                }));
                if(formFields.RFGROUP == 'IN USE'){
                    setDisableGridsForRFTransactions(true);
                }
                if(response.data.actualreceivedshippeddatetime){
                    if (formRefs.current["ACTUALRECEIVEDSHIPPEDDATETIME"]) {
                        formRefs.current["ACTUALRECEIVEDSHIPPEDDATETIME"].instance().option('value', response.data.actualreceivedshippeddatetime);
                        setformFields(prevFields => ({
                            ...prevFields,
                            ACTUALRECEIVEDSHIPPEDDATETIME: response.data.actualreceivedshippeddatetime
                        }));
                    }
                } 
                notify(
                    {
                        message: "Transaction Updated",
                        width: 600,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } else {
                notify(
                    {
                        message: response.data.message,
                        width: 100,
                    },
                    'error',
                    3000,
                );
                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            // A refusal now arrives as a real 4xx, so it lands here instead of in the else branch above.
            // This catch used to only console.error, which meant a refused save showed the user nothing.
            if (!error?.[CONCURRENCY_HANDLED]) {
                notify({ message: formatErrorList(error?.response?.data?.errors, ERROR_SEVERITY.ERROR)
                    || getApiErrorMessage(error, MESSAGES.ERROR), width: 600 }, 'error', 3000);
            }
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const loadLookupClient = (name, data) => {

        try {
            const newOptions = data.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            if (formRefs && formRefs.current && formRefs.current[name]) {
                const ref = formRefs.current[name];
                if (typeof ref.instance === 'function') {
                    const instance = ref.instance();
                    if (instance && typeof instance.option === 'function') {
                        instance.option('dataSource', newOptions);
                        instance.option('valueExpr', 'id');
                        instance.option('displayExpr', 'name');
                    }
                }
            }

        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
        }
    };

    const loadLookupFromDataSource = (name, dataSource) => {
        if (formRefs && formRefs.current && formRefs.current[name]) {
            const ref = formRefs.current[name];
            if (typeof ref.instance === 'function') {
                const instance = ref.instance();
                if (instance && typeof instance.option === 'function') {
                    instance.option('dataSource', dataSource);
                    instance.option('valueExpr', 'id');
                    instance.option('displayExpr', 'name');
                }
            }
        }
        else {
            console.log('not found control:', name);
        }
    };


    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        KEYSEQUENCE: 1,
        RECORDNO: '',
        CREATIONDATETIME: new Date(),
        CREATIONUSERID: '',
        CREATIONDATETIME: new Date(),
        CREATIONUSERID: '',
        LASTUPDATEDATETIME: new Date(),
        LASTUPDATEUSERID: '',
        COMPANYID: '',
        MODULE: '',
        RECORDTYPE: props.recordType || 'R',
        TRANSACTIONNUMBER: '',
        R_PROFILE: '',
        R_CUSTOMER: '',
        CUSTOMER_NAME: '',
        STAGE: 'R',
        TRANSACTIONTYPE: 'R',
        STATUS: 'O',
        R_SHIPPER: '',
        R_CONSIGNEE: '',
        HOLDREASON: '',
        TRANSACTIONDATE: new Date(),
        ACTUALRECEIVEDSHIPPEDDATETIME: null,
        PLANNEDRECEIVEDSHIPPEDDATETIME: null,
        SHIPPERBOLNUMBER: '',
        REFERENCE: '',
        R_RATESCHEDULE: '',
        TRANSACTIONGROUP: '',
        COMMENT: '',
        EQUIPMENTINTERCHANGEREPORT: '',
        R_CARRIER: '',
        R_DRIVER: '',
        CONTAINER: '',
        TRANSPORTATIONMODE: 'T',
        R_AGENT: '',
        TRUCKREFERENCE: '',
        TRUCKARRIVALDATETIME: null,
        TRUCKDEPARTDATETIME: null,
        DELIVERYPICKUPFLAG: 'N',
        DELIVERYPICKUPPLANNEDDATETIME: null,
        DELIVERYPICKUPARRIVEDATETIME: null,
        DELIVERYPICKUPDEPARTDATETIME: null,
        DELIVERYPICKUPCOMMENT: '',
        DISPATCHORDERNUMBER: '',
        THIRDPARTYBILLTYPE: 'P',
        R_THIRDPARTYCUSTOMER: '',
        R_THIRDPARTYFREIGHTBILLTO: '',
        R_FREIGHTBILLNUMBER: '',
        CONSOLIDATEINVOICEFLAG: '',
        R_STAGINGWAREHOUSE: '',
        R_STAGINGAREA: '',
        PICKSTATUS: '1',
        FREIGHTCHARGETYPE: 'N',
        R_FREIGHTBILLTO: '',
        FREIGHTAMOUNT: '',
        R_CODPAYOR: '',
        R_CODPAYEE: '',
        CODAMOUNT: '',
        CODAMOUNTCOLLECTED: '',
        CODCOMMENT: '',
        CODCOLLECTIONDATETIME: null,
        CODPAYMETHOD: 'N',
        R_TAXCODE: '',
        TAXBASIS: '',
        TAXRATE: '',
        TAXAMOUNT: '',
        PRINTRECEIPT: 'Y',
        PRINTBOL: 'Y',
        PRINTLABEL: '',
        SENDFAX: 'Y',
        R_AROPENITEMHEADER: '',
        USERDEFINEDCODE_1: '',
        USERDEFINEDCODE_2: '',
        USERDEFINEDCODE_3: '',
        USERDEFINEDCODE_4: '',
        USERDEFINEDCODE_5: '',
        USERDEFINEDCODE_6: '',
        USERDEFINEDCODE_7: '',
        USERDEFINEDCODE_8: '',
        USERDEFINEDCODE_9: '',
        USERDEFINEDCODE_10: '',
        USERDEFINEDREFERENCE_1: '',
        USERDEFINEDREFERENCE_2: '',
        USERDEFINEDREFERENCE_3: '',
        USERDEFINEDREFERENCE_4: '',
        USERDEFINEDREFERENCE_5: '',
        USERDEFINEDREFERENCE_6: '',
        USERDEFINEDREFERENCE_7: '',
        USERDEFINEDREFERENCE_8: '',
        USERDEFINEDREFERENCE_9: '',
        USERDEFINEDREFERENCE_10: '',
        USERDEFINEDDATE_1: null,
        USERDEFINEDDATE_2: null,
        USERDEFINEDDATE_3: null,
        USERDEFINEDDATE_4: null,
        USERDEFINEDDATE_5: null,
        USERDEFINEDDATE_6: null,
        USERDEFINEDDATE_7: null,
        USERDEFINEDDATE_8: null,
        USERDEFINEDDATE_9: null,
        USERDEFINEDDATE_10: null,
        USERDEFINEDCOMMENT: '',
        USERDEFINEDQUANTITY_1: null,
        USERDEFINEDQUANTITY_2: null,
        USERDEFINEDQUANTITY_3: null,
        USERDEFINEDQUANTITY_4: null,
        USERDEFINEDQUANTITY_5: null,
        USERDEFINEDQUANTITY_6: null,
        USERDEFINEDQUANTITY_7: null,
        USERDEFINEDQUANTITY_8: null,
        USERDEFINEDQUANTITY_9: null,
        USERDEFINEDQUANTITY_10: null,
        FISCALYEAR: '',
        FISCALPERIOD: '',
        COMMITDATE: null,
        CONSOLIDATEDINVOICE: 'N',
        TRANSFERTODISPATCH: 'N',
        R_EQUIPMENT: '',
        R_BATCH: '',
        STAGINGSTARTDATE: null,
        R_UNLOADPICKBY: '',
        R_CHECKBY: '',
        R_PUTAWAYBY: '',
        UNLOADPICKBYPLANDATE: null,
        CHECKBYPLANDATE: null,
        PUTAWAYBYPLANDATE: null,
        UNLOADPICKBYHOURS: '',
        CHECKBYHOURS: '',
        PUTAWAYBYHOURS: '',
        R_PLANWAREHOUSE: '',
        R_PLANLOCATION: '',
        PLANRESOURCESCODE: '',
        PLANREFERENCE: '',
        PLANRESOURCESHOURS: null,
        TRANSPORTATIONYARDLEAVEDATE: null,
        R_TRANSPORTATIONWAREHOUSE: '',
        R_TRANSPORTATIONLOCATION: '',
        STAGINGENDDATE: null,
        EDITRANSMITFLAG: '',
        PLANCOMMENT: '',
        PRINTPICKINGSLIP: 'Y',
        PRINTSERIALNUMBERMANIFEST: 'Y',
        PRINTRECEIPTPUTAWAY: 'Y',
        R_FMTRANSACTIONPROFILE: '',
        R_TRANSPORTCARRIER: '',
        EQUIPMENTTYPE: '',
        EMBARCTRANSMITFLAG: '',
        R_GLDEPARTMENT: '',
        R_CAJOB: '',
        R_GLFUND: '',
        RFTRANSACTION: 'N',
        TRANSCURRENCYTYPE: 'H',
        R_TRANSCURRENCYCODE: '',
        PAYCURRENCYTYPE: 'H',
        R_PAYCURRENCYCODE: '',
        RATETIMING: 'I',
        PRESETRATE: '',
        FMTRUCKREFERENCE: '',
        FMDRIVERREFERENCE: '',
        R_TRAILER: '',
        FMTRAILERRREFERENCE: '',
        PAPINETTRANSMISSIONFLAG: 'N',
        R_SMCHARGESPROFILE: '',
        EDITRANSMIT_CUSTOMER: 'N',
        EDITRANSMIT_CONSIGNEE: 'N',
        EDITRANSMIT_SHIPPER: 'N',
        EDITRANSMIT_CARRIER: 'N',
        SOURCETABLENAME: '',
        R_SOURCEID: '',
        R_REPLENISHMENTBATCH: '',
        R_LOADBY: '',
        R_PICKBY: '',
        LOADBYPLANDATE: null,
        PICKBYPLANDATE: null,
        LOADBYHOURS: '',
        PICKBYHOURS: '',
        RFGROUP: '',
        CALCTRANSCHARGES: 'N',
        USERDEFINEDCOMMENT_2: '',
        USERDEFINEDCOMMENT_3: '',
        SHIPMENTPLANNEDDATETIMETO: null,
        SHIPMENTPLANNEDDATETIMEFROM: null,
        DELIVEREDDATETIME: null,
        USERDEFINEDCODE_11: '',
        USERDEFINEDCODE_12: '',
        USERDEFINEDCODE_13: '',
        USERDEFINEDCODE_14: '',
        USERDEFINEDCODE_15: '',
        USERDEFINEDCODE_16: '',
        USERDEFINEDCODE_17: '',
        USERDEFINEDCODE_18: '',
        USERDEFINEDCODE_19: '',
        USERDEFINEDCODE_20: '',
        USERDEFINEDDATE_11: null,
        USERDEFINEDDATE_12: null,
        USERDEFINEDDATE_13: null,
        USERDEFINEDDATE_14: null,
        USERDEFINEDDATE_15: null,
        USERDEFINEDDATE_16: null,
        USERDEFINEDDATE_17: null,
        USERDEFINEDDATE_18: null,
        USERDEFINEDDATE_19: null,
        USERDEFINEDDATE_20: null,
        USERDEFINEDQUANTITY_11: null,
        USERDEFINEDQUANTITY_12: null,
        USERDEFINEDQUANTITY_13: null,
        USERDEFINEDQUANTITY_14: null,
        USERDEFINEDQUANTITY_15: null,
        USERDEFINEDQUANTITY_16: null,
        USERDEFINEDQUANTITY_17: null,
        USERDEFINEDQUANTITY_18: null,
        USERDEFINEDQUANTITY_19: null,
        USERDEFINEDQUANTITY_20: null,
        USERDEFINEDREFERENCE_11: '',
        USERDEFINEDREFERENCE_12: '',
        USERDEFINEDREFERENCE_13: '',
        USERDEFINEDREFERENCE_14: '',
        USERDEFINEDREFERENCE_15: '',
        USERDEFINEDREFERENCE_16: '',
        USERDEFINEDREFERENCE_17: '',
        USERDEFINEDREFERENCE_18: '',
        USERDEFINEDREFERENCE_19: '',
        USERDEFINEDREFERENCE_20: '',
        RECSHIPDATETIMEAPPROVALSTATUS: '',
        RECEIPTPUTONHOLD: '',
        AVAILABLEREASONCODE: '',
        HOLDREASONCODE: '',
        HOLDDAYSCOUNT: '',
        ShipmentTrackingNumber: '',
        UNLOADHOURS: null,
        UNLOADMINUTES: null,
        PUTAWAYHOURS: null,
        PUTAWAYMINUTES: null,
        CHECKHOURS: null,
        CHECKMINUTES: null,
        LOADHOURS: null,
        LOADMINUTES: null,
        PICKHOURS: null,
        PICKMINUTES: null,
        Profile:null,
        Carrier:null,
        Profile:null,
    };


    const [formFields, setformFields] = useState(initialFormFields);
    /** Always-current mirror of formFields. handleFieldChange/ApplyProfileSettings run from
     *  useCallback([]) closures, so formFields there is the first render's value. */
    const formFieldsRef = useRef(formFields);
    formFieldsRef.current = formFields;
    /** Date-window prompts already shown for the record on screen, keyed field|date. Consulted only
     *  by the on-open pass - see checkDateWindow; cleared when a different record is loaded. */
    const dateWindowPromptsRef = useRef(new Set());
    /** True while a date-window dialog is up. Closing it shuffles focus, and that churn would
     *  otherwise re-enter through the focusout listener and ask again immediately. */
    const dateWindowPromptInFlightRef = useRef(false);
    /** Root element, for the delegated focusout that stands in for Delphi's OnExit. */
    const formContainerRef = useRef(null);
    /** False once this form has unmounted. Several loaders here are started from mount effects and
     *  set state when their request comes back; navigating away before that lands (clicking straight
     *  through from the transactions list, say) would otherwise update an unmounted component. */
    const isMountedRef = useRef(true);
    useEffect(() => () => { isMountedRef.current = false; }, []);
    const [showCommitErrorsPopup,setShowCommitErrorsPopup] = useState(false);
    const [showGenerateItemTasksRecordsPopup,setShowGenerateItemTasksRecordsPopup] = useState(false);
    const [showFMTransHeader,setShowFMTransHeader] = useState(false);
    const [transactionCommitErrors,setTransactionCommitErrors] = useState(null);
    const [dropDownItems, setdDropDownItems] = useState(null);
    const [IsChargesTabVisible, setIsChargesTabVisible] = useState(true);
    const [showContactsPopup, setShowContactsPopup] = useState(false);
    const [showBilltoChargesPopup, setShowBilltoChargesPopup] = useState(false);
    const [showCreateRepackShipmentsPopup, setShowCreateRepackShipmentsPopup] = useState(false);
    const [showCreateTransactionChargesPopup, setShowCreateTransactionChargesPopup] = useState(false);
    const [showProShipShipmentPopup, setShowProShipShipmentPopup] = useState(false);
    const [showInvoicesPopup, setShowInvoicesPopup] = useState(false);
    const [showSignatureCapturePopup, setShowSignatureCapturePopup] = useState(false);
    const [showSignaturePopup, setShowSignaturePopup] = useState(false);
    const [showTransactionSignaturesPopup, setShowTransactionSignaturesPopup] = useState(false);
    const [showReplicatePopup, setShowReplicatePopup] = useState(false);
    const [showReplicateTransactionsPopup, setShowReplicateTransactionsPopup] = useState(false);
    const [showAutoLotPopup, setShowAutoLotPopup] = useState(false);
    const [showManualLotPopup, setShowManualLotPopup] = useState(false);
    const [autoLotItems, setAutoLotItems] = useState([]);
    // Header the WMD0115 details will be created on, held while its dialog is open.
    const autoLotHeaderRef = useRef(null);
    // WMD0110 Default Shipment Item Details: what the server offered for the header just saved, and
    // that header, held while the dialog is open.
    const [showDefaultShipmentItemsPopup, setShowDefaultShipmentItemsPopup] = useState(false);
    const [defaultShipmentItems, setDefaultShipmentItems] = useState(null);
    const defaultShipmentHeaderRef = useRef(null);
    const [setupData, setSetupData] = useState(null);
    
    // Fetch setup data to check CREATETRANSACTIONCHARGES field
    const fetchSetupData = useCallback(async () => {
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/wm/Setup/GetSetupDataByRowId`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });
            if (response.data && isMountedRef.current) {
                setSetupData(response.data);
            }
        } catch (error) {
            console.error('Error fetching setup data:', error);
        }
    }, [accessToken]);
    
    const handleShowRepackShipmentRecord = async () => {
        if (!formFields.ROWID || formFields.ROWID === "00000000-0000-0000-0000-000000000000") {
            alert(MESSAGES.PLEASE_SELECT_TRANSACTION, MESSAGES.INFORMATION);
            return;
        }

        setLoadPanelVisible(true);
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/wm/TransactionHeaderOperations/GetRepackShipmentRecordRowId`,
                {
                    params: {
                        sourceTransactionHeaderRowId: formFields.ROWID
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );

            if (response.data && response.data.success && response.data.rowId) {
                // Navigate to edit transaction page with the repack shipment row ID
                // Use React Router navigation to avoid page refresh (same as CreateRepackShipments.js)
                history.push(`/wm/transactiondataentry/edit-transaction?id=${response.data.rowId}`);
            } else {
                alert(response.data?.message || MESSAGES.REPACK_SHIPMENT_RECORD_NOT_FOUND, MESSAGES.INFORMATION);
            }
        } catch (error) {
            console.error('Error getting repack shipment record:', error);
            alert(error.response?.data?.message || error.message || MESSAGES.ERROR_GETTING_REPACK_SHIPMENT_RECORD, MESSAGES.ERROR);
        } finally {
            setTimeout(() => {
                setLoadPanelVisible(false);
            }, 500);
        }
    };

    const handleReset = async () => {
        const isEmptyLocations = await CheckEmptyLocations();
            if (!isEmptyLocations) return;
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else
        {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableControlsForNewRecord();
        }
        
    };

    const GetTransactionDataFromProfile = async (profileId, url) => {
        if (profileId === null)
            return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${url}?transactionType=&profileId=${profileId}&returnProfileDataOnly=true`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.hasOwnProperty("data") && response.data != null && response.data != undefined && response.data != "") {
                if (response.data.transaction) {
                  
                    setformFields(prevFields => ({
                        ...prevFields,
                        R_CUSTOMER: response.data.transaction.RCustomer,
                        TRANSACTIONTYPE: response.data.transaction.Transactiontype,
                        STAGE: response.data.transaction.Stage,
                        R_SHIPPER: response.data.transaction.RShipper != null ? response.data.transaction.RShipper : formFields.R_SHIPPER,
                        R_CONSIGNEE: response.data.transaction.RConsignee != null ? response.data.transaction.RConsignee : formFields.R_CONSIGNEE,
                        STATUS: response.data.transaction.Status,
                        HOLDREASON: response.data.transaction.Holdreason != null && response.data.transaction.Holdreason != '' ? response.data.transaction.Holdreason : formFields.HOLDREASON,
                        TRANSACTIONDATE: formFields.TRANSACTIONDATE == null || formFields.TRANSACTIONDATE == '' ? new Date() : formFields.TRANSACTIONDATE,
                        ACTUALRECEIVEDSHIPPEDDATETIME: response.data.transaction.Actualreceivedshippeddatetime != null ? response.data.transaction.Actualreceivedshippeddatetime : formFields.ACTUALRECEIVEDSHIPPEDDATETIME,
                        PLANNEDRECEIVEDSHIPPEDDATETIME: response.data.transaction.Plannedreceivedshippeddatetime != null ? response.data.transaction.Plannedreceivedshippeddatetime : formFields.PLANNEDRECEIVEDSHIPPEDDATETIME,
                        SHIPPERBOLNUMBER: response.data.transaction.Shipperbolnumber != null && response.data.transaction.Shipperbolnumber != '' ? response.data.transaction.Shipperbolnumber : formFields.SHIPPERBOLNUMBER,
                        REFERENCE: response.data.transaction.Reference != null && response.data.transaction.Reference != '' ? response.data.transaction.Reference : formFields.REFERENCE,
                        R_RATESCHEDULE: response.data.transaction.RRateschedule != null ? response.data.transaction.RRateschedule : formFields.R_RATESCHEDULE,
                        TRANSACTIONGROUP: response.data.transaction.Transactiongroup != null && response.data.transaction.Transactiongroup != '' ? response.data.transaction.Transactiongroup : formFields.TRANSACTIONGROUP,
                        COMMENT: response.data.transaction.Comment != null && response.data.transaction.Comment != '' ? response.data.transaction.Comment : formFields.COMMENT,
                        EQUIPMENTINTERCHANGEREPORT: response.data.transaction.Equipmentinterchangereport != null && response.data.transaction.Equipmentinterchangereport != '' ? response.data.transaction.Equipmentinterchangereport : formFields.EQUIPMENTINTERCHANGEREPORT,
                        R_CARRIER: response.data.transaction.RCarrier != null && response.data.transaction.RCarrier != '' ? response.data.transaction.RCarrier : formFields.R_CARRIER,
                        R_DRIVER: response.data.transaction.RDriver != null && response.data.transaction.RDriver != '' ? response.data.transaction.RDriver : formFields.R_DRIVER,
                        CONTAINER: response.data.transaction.Container != null && response.data.transaction.Container != '' ? response.data.transaction.Container : formFields.CONTAINER,
                        TRANSPORTATIONMODE: response.data.transaction.Transportationmode != null && response.data.transaction.Transportationmode != '' ? response.data.transaction.Transportationmode : formFields.TRANSPORTATIONMODE,
                        R_AGENT: response.data.transaction.RAgent != null && response.data.transaction.RAgent != '' ? response.data.transaction.RAgent : formFields.R_AGENT,
                        TRUCKREFERENCE: response.data.transaction.Truckreference != null && response.data.transaction.Truckreference != '' ? response.data.transaction.Truckreference : formFields.TRUCKREFERENCE,
                        TRUCKARRIVALDATETIME: response.data.transaction.Truckarrivaldatetime != null && response.data.transaction.Truckarrivaldatetime != '' ? response.data.transaction.Truckarrivaldatetime : formFields.TRUCKARRIVALDATETIME,
                        TRUCKDEPARTDATETIME: response.data.transaction.Truckdepartdatetime != null && response.data.transaction.Truckdepartdatetime != '' ? response.data.transaction.Truckdepartdatetime : formFields.TRUCKDEPARTDATETIME,
                        DELIVERYPICKUPFLAG: response.data.transaction.Deliverypickupflag != null && response.data.transaction.Deliverypickupflag != '' ? response.data.transaction.Deliverypickupflag : formFields.DELIVERYPICKUPFLAG,
                        DELIVERYPICKUPPLANNEDDATETIME: response.data.transaction.Deliverypickupplanneddatetime != null && response.data.transaction.Deliverypickupplanneddatetime != '' ? response.data.transaction.Deliverypickupplanneddatetime : formFields.DELIVERYPICKUPPLANNEDDATETIME,
                        DELIVERYPICKUPARRIVEDATETIME: response.data.transaction.Deliverypickuparrivedatetime != null && response.data.transaction.Deliverypickuparrivedatetime != '' ? response.data.transaction.Deliverypickuparrivedatetime : formFields.DELIVERYPICKUPARRIVEDATETIME,
                        DELIVERYPICKUPDEPARTDATETIME: response.data.transaction.Deliverypickupdepartdatetime != null && response.data.transaction.Deliverypickupdepartdatetime != '' ? response.data.transaction.Deliverypickupdepartdatetime : formFields.DELIVERYPICKUPDEPARTDATETIME,
                        DELIVERYPICKUPCOMMENT: response.data.transaction.Deliverypickupcomment != null && response.data.transaction.Deliverypickupcomment != '' ? response.data.transaction.Deliverypickupcomment : formFields.DELIVERYPICKUPCOMMENT,
                        DISPATCHORDERNUMBER: response.data.transaction.Dispatchordernumber != null && response.data.transaction.Dispatchordernumber != '' ? response.data.transaction.Dispatchordernumber : formFields.DISPATCHORDERNUMBER,
                        THIRDPARTYBILLTYPE: response.data.transaction.Thirdpartybilltype != null && response.data.transaction.Thirdpartybilltype != '' ? response.data.transaction.Thirdpartybilltype : formFields.THIRDPARTYBILLTYPE,
                        R_THIRDPARTYCUSTOMER: response.data.transaction.RThirdpartycustomer != null && response.data.transaction.RThirdpartycustomer != '' ? response.data.transaction.RThirdpartycustomer : formFields.R_THIRDPARTYCUSTOMER,
                        R_THIRDPARTYFREIGHTBILLTO: response.data.transaction.RThirdpartyfreightbillto != null && response.data.transaction.RThirdpartyfreightbillto != '' ? response.data.transaction.RThirdpartyfreightbillto : formFields.R_THIRDPARTYFREIGHTBILLTO,
                        R_FREIGHTBILLNUMBER: response.data.transaction.RFreightbillnumber != null && response.data.transaction.RFreightbillnumber != '' ? response.data.transaction.RFreightbillnumber : formFields.R_FREIGHTBILLNUMBER,
                        CONSOLIDATEINVOICEFLAG: response.data.transaction.Consolidateinvoiceflag != null && response.data.transaction.Consolidateinvoiceflag != '' ? response.data.transaction.Consolidateinvoiceflag : formFields.CONSOLIDATEINVOICEFLAG,
                        R_STAGINGWAREHOUSE: response.data.transaction.RStagingwarehouse != null && response.data.transaction.RStagingwarehouse != '' ? response.data.transaction.RStagingwarehouse : formFields.R_STAGINGWAREHOUSE,
                        R_STAGINGAREA: response.data.transaction.RStagingarea != null && response.data.transaction.RStagingarea != '' ? response.data.transaction.RStagingarea : formFields.R_STAGINGAREA,
                        PICKSTATUS: response.data.transaction.Pickstatus != null && response.data.transaction.Pickstatus != '' ? response.data.transaction.Pickstatus : formFields.PICKSTATUS,
                        FREIGHTCHARGETYPE: response.data.transaction.Freightchargetype != null && response.data.transaction.Freightchargetype != '' ? response.data.transaction.Freightchargetype : formFields.FREIGHTCHARGETYPE,
                        R_FREIGHTBILLTO: response.data.transaction.RFreightbillto != null && response.data.transaction.RFreightbillto != '' ? response.data.transaction.RFreightbillto : formFields.R_FREIGHTBILLTO,
                        FREIGHTAMOUNT: response.data.transaction.Freightamount != null && response.data.transaction.Freightamount != '' ? response.data.transaction.Freightamount : formFields.FREIGHTAMOUNT,
                        R_CODPAYOR: response.data.transaction.RCodpayor != null && response.data.transaction.RCodpayor != '' ? response.data.transaction.RCodpayor : formFields.R_CODPAYOR,
                        R_CODPAYEE: response.data.transaction.RCodpayee != null && response.data.transaction.RCodpayee != '' ? response.data.transaction.RCodpayee : formFields.R_CODPAYEE,
                        CODAMOUNT: response.data.transaction.Codamount != null && response.data.transaction.Codamount != '' ? response.data.transaction.Codamount : formFields.CODAMOUNT,
                        CODAMOUNTCOLLECTED: response.data.transaction.Codamountcollected != null && response.data.transaction.Codamountcollected != '' ? response.data.transaction.Codamountcollected : formFields.CODAMOUNTCOLLECTED,
                        CODCOMMENT: response.data.transaction.Codcomment != null && response.data.transaction.Codcomment != '' ? response.data.transaction.Codcomment : formFields.CODCOMMENT,
                        CODCOLLECTIONDATETIME: response.data.transaction.Codcollectiondatetime != null && response.data.transaction.Codcollectiondatetime != '' ? response.data.transaction.Codcollectiondatetime : formFields.CODCOLLECTIONDATETIME,
                        CODPAYMETHOD: response.data.transaction.Codpaymethod != null && response.data.transaction.Codpaymethod != '' ? response.data.transaction.Codpaymethod : formFields.CODPAYMETHOD,
                        R_TAXCODE: response.data.transaction.RTaxcode != null && response.data.transaction.RTaxcode != '' ? response.data.transaction.RTaxcode : formFields.R_TAXCODE,
                        TAXBASIS: response.data.transaction.Taxbasis != null && response.data.transaction.Taxbasis != '' ? response.data.transaction.Taxbasis : formFields.TAXBASIS,
                        TAXRATE: response.data.transaction.Taxrate != null && response.data.transaction.Taxrate != '' ? response.data.transaction.Taxrate : formFields.TAXRATE,
                        TAXAMOUNT: response.data.transaction.Taxamount != null && response.data.transaction.Taxamount != '' ? response.data.transaction.Taxamount : formFields.TAXAMOUNT,
                        PRINTRECEIPT: response.data.transaction.Printreceipt != null && response.data.transaction.Printreceipt != '' ? response.data.transaction.Printreceipt : formFields.PRINTRECEIPT,
                        PRINTBOL: response.data.transaction.Printbol != null && response.data.transaction.Printbol != '' ? response.data.transaction.Printbol : formFields.PRINTBOL,
                        PRINTLABEL: response.data.transaction.Printlabel != null && response.data.transaction.Printlabel != '' ? response.data.transaction.Printlabel : formFields.PRINTLABEL,
                        SENDFAX: response.data.transaction.Sendfax != null && response.data.transaction.Sendfax != '' ? response.data.transaction.Sendfax : formFields.SENDFAX,
                        R_AROPENITEMHEADER: response.data.transaction.RAropenitemheader != null && response.data.transaction.RAropenitemheader != '' ? response.data.transaction.RAropenitemheader : formFields.R_AROPENITEMHEADER,
                        USERDEFINEDCODE_1: response.data.transaction.Userdefinedcode1 != null && response.data.transaction.Userdefinedcode1 != '' ? response.data.transaction.Userdefinedcode1 : formFields.USERDEFINEDCODE_1,
                        USERDEFINEDCODE_2: response.data.transaction.Userdefinedcode2 != null && response.data.transaction.Userdefinedcode2 != '' ? response.data.transaction.Userdefinedcode2 : formFields.USERDEFINEDCODE_2,
                        USERDEFINEDCODE_3: response.data.transaction.Userdefinedcode3 != null && response.data.transaction.Userdefinedcode3 != '' ? response.data.transaction.Userdefinedcode3 : formFields.USERDEFINEDCODE_3,
                        USERDEFINEDCODE_4: response.data.transaction.Userdefinedcode4 != null && response.data.transaction.Userdefinedcode4 != '' ? response.data.transaction.Userdefinedcode4 : formFields.USERDEFINEDCODE_4,
                        USERDEFINEDCODE_5: response.data.transaction.Userdefinedcode5 != null && response.data.transaction.Userdefinedcode5 != '' ? response.data.transaction.Userdefinedcode5 : formFields.USERDEFINEDCODE_5,
                        USERDEFINEDCODE_6: response.data.transaction.Userdefinedcode6 != null && response.data.transaction.Userdefinedcode6 != '' ? response.data.transaction.Userdefinedcode6 : formFields.USERDEFINEDCODE_6,
                        USERDEFINEDCODE_7: response.data.transaction.Userdefinedcode7 != null && response.data.transaction.Userdefinedcode7 != '' ? response.data.transaction.Userdefinedcode7 : formFields.USERDEFINEDCODE_7,
                        USERDEFINEDCODE_8: response.data.transaction.Userdefinedcode8 != null && response.data.transaction.Userdefinedcode8 != '' ? response.data.transaction.Userdefinedcode8 : formFields.USERDEFINEDCODE_8,
                        USERDEFINEDCODE_9: response.data.transaction.Userdefinedcode9 != null && response.data.transaction.Userdefinedcode9 != '' ? response.data.transaction.Userdefinedcode9 : formFields.USERDEFINEDCODE_9,
                        USERDEFINEDCODE_10: response.data.transaction.Userdefinedcode10 != null && response.data.transaction.Userdefinedcode10 != '' ? response.data.transaction.Userdefinedcode10 : formFields.USERDEFINEDCODE_10,
                        USERDEFINEDREFERENCE_1: response.data.transaction.Userdefinedreference1 != null && response.data.transaction.Userdefinedreference1 != '' ? response.data.transaction.Userdefinedreference1 : formFields.USERDEFINEDREFERENCE_1,
                        USERDEFINEDREFERENCE_2: response.data.transaction.Userdefinedreference2 != null && response.data.transaction.Userdefinedreference2 != '' ? response.data.transaction.Userdefinedreference2 : formFields.USERDEFINEDREFERENCE_2,
                        USERDEFINEDREFERENCE_3: response.data.transaction.Userdefinedreference3 != null && response.data.transaction.Userdefinedreference3 != '' ? response.data.transaction.Userdefinedreference3 : formFields.USERDEFINEDREFERENCE_3,
                        USERDEFINEDREFERENCE_4: response.data.transaction.Userdefinedreference4 != null && response.data.transaction.Userdefinedreference4 != '' ? response.data.transaction.Userdefinedreference4 : formFields.USERDEFINEDREFERENCE_4,
                        USERDEFINEDREFERENCE_5: response.data.transaction.Userdefinedreference5 != null && response.data.transaction.Userdefinedreference5 != '' ? response.data.transaction.Userdefinedreference5 : formFields.USERDEFINEDREFERENCE_5,
                        USERDEFINEDREFERENCE_6: response.data.transaction.Userdefinedreference6 != null && response.data.transaction.Userdefinedreference6 != '' ? response.data.transaction.Userdefinedreference6 : formFields.USERDEFINEDREFERENCE_6,
                        USERDEFINEDREFERENCE_7: response.data.transaction.Userdefinedreference7 != null && response.data.transaction.Userdefinedreference7 != '' ? response.data.transaction.Userdefinedreference7 : formFields.USERDEFINEDREFERENCE_7,
                        USERDEFINEDREFERENCE_8: response.data.transaction.Userdefinedreference8 != null && response.data.transaction.Userdefinedreference8 != '' ? response.data.transaction.Userdefinedreference8 : formFields.USERDEFINEDREFERENCE_8,
                        USERDEFINEDREFERENCE_9: response.data.transaction.Userdefinedreference9 != null && response.data.transaction.Userdefinedreference9 != '' ? response.data.transaction.Userdefinedreference9 : formFields.USERDEFINEDREFERENCE_9,
                        USERDEFINEDREFERENCE_10: response.data.transaction.Userdefinedreference10 != null && response.data.transaction.Userdefinedreference10 != '' ? response.data.transaction.Userdefinedreference10 : formFields.USERDEFINEDREFERENCE_10,
                        USERDEFINEDDATE_1: response.data.transaction.Userdefineddate1 != null && response.data.transaction.Userdefineddate1 != '' ? response.data.transaction.Userdefineddate1 : formFields.USERDEFINEDDATE_1,
                        USERDEFINEDDATE_2: response.data.transaction.Userdefineddate2 != null && response.data.transaction.Userdefineddate2 != '' ? response.data.transaction.Userdefineddate2 : formFields.USERDEFINEDDATE_2,
                        USERDEFINEDDATE_3: response.data.transaction.Userdefineddate3 != null && response.data.transaction.Userdefineddate3 != '' ? response.data.transaction.Userdefineddate3 : formFields.USERDEFINEDDATE_3,
                        USERDEFINEDDATE_4: response.data.transaction.Userdefineddate4 != null && response.data.transaction.Userdefineddate4 != '' ? response.data.transaction.Userdefineddate4 : formFields.USERDEFINEDDATE_4,
                        USERDEFINEDDATE_5: response.data.transaction.Userdefineddate5 != null && response.data.transaction.Userdefineddate5 != '' ? response.data.transaction.Userdefineddate5 : formFields.USERDEFINEDDATE_5,
                        USERDEFINEDDATE_6: response.data.transaction.Userdefineddate6 != null && response.data.transaction.Userdefineddate6 != '' ? response.data.transaction.Userdefineddate6 : formFields.USERDEFINEDDATE_6,
                        USERDEFINEDDATE_7: response.data.transaction.Userdefineddate7 != null && response.data.transaction.Userdefineddate7 != '' ? response.data.transaction.Userdefineddate7 : formFields.USERDEFINEDDATE_7,
                        USERDEFINEDDATE_8: response.data.transaction.Userdefineddate8 != null && response.data.transaction.Userdefineddate8 != '' ? response.data.transaction.Userdefineddate8 : formFields.USERDEFINEDDATE_8,
                        USERDEFINEDDATE_9: response.data.transaction.Userdefineddate9 != null && response.data.transaction.Userdefineddate9 != '' ? response.data.transaction.Userdefineddate9 : formFields.USERDEFINEDDATE_9,
                        USERDEFINEDDATE_10: response.data.transaction.Userdefineddate10 != null && response.data.transaction.Userdefineddate10 != '' ? response.data.transaction.Userdefineddate10 : formFields.USERDEFINEDDATE_10,
                        USERDEFINEDCOMMENT: response.data.transaction.Userdefinedcomment != null && response.data.transaction.Userdefinedcomment != '' ? response.data.transaction.Userdefinedcomment : formFields.USERDEFINEDCOMMENT,
                        USERDEFINEDQUANTITY_1: response.data.transaction.Userdefinedquantity1 != null && response.data.transaction.Userdefinedquantity1 != '' ? response.data.transaction.Userdefinedquantity1 : formFields.USERDEFINEDQUANTITY_1,
                        USERDEFINEDQUANTITY_2: response.data.transaction.Userdefinedquantity2 != null && response.data.transaction.Userdefinedquantity2 != '' ? response.data.transaction.Userdefinedquantity2 : formFields.USERDEFINEDQUANTITY_2,
                        USERDEFINEDQUANTITY_3: response.data.transaction.Userdefinedquantity3 != null && response.data.transaction.Userdefinedquantity3 != '' ? response.data.transaction.Userdefinedquantity3 : formFields.USERDEFINEDQUANTITY_3,
                        USERDEFINEDQUANTITY_4: response.data.transaction.Userdefinedquantity4 != null && response.data.transaction.Userdefinedquantity4 != '' ? response.data.transaction.Userdefinedquantity4 : formFields.USERDEFINEDQUANTITY_4,
                        USERDEFINEDQUANTITY_5: response.data.transaction.Userdefinedquantity5 != null && response.data.transaction.Userdefinedquantity5 != '' ? response.data.transaction.Userdefinedquantity5 : formFields.USERDEFINEDQUANTITY_5,
                        USERDEFINEDQUANTITY_6: response.data.transaction.Userdefinedquantity6 != null && response.data.transaction.Userdefinedquantity6 != '' ? response.data.transaction.Userdefinedquantity6 : formFields.USERDEFINEDQUANTITY_6,
                        USERDEFINEDQUANTITY_7: response.data.transaction.Userdefinedquantity7 != null && response.data.transaction.Userdefinedquantity7 != '' ? response.data.transaction.Userdefinedquantity7 : formFields.USERDEFINEDQUANTITY_7,
                        USERDEFINEDQUANTITY_8: response.data.transaction.Userdefinedquantity8 != null && response.data.transaction.Userdefinedquantity8 != '' ? response.data.transaction.Userdefinedquantity8 : formFields.USERDEFINEDQUANTITY_8,
                        USERDEFINEDQUANTITY_9: response.data.transaction.Userdefinedquantity9 != null && response.data.transaction.Userdefinedquantity9 != '' ? response.data.transaction.Userdefinedquantity9 : formFields.USERDEFINEDQUANTITY_9,
                        USERDEFINEDQUANTITY_10: response.data.transaction.Userdefinedquantity10 != null && response.data.transaction.Userdefinedquantity10 != '' ? response.data.transaction.Userdefinedquantity10 : formFields.USERDEFINEDQUANTITY_10,
                        FISCALYEAR: response.data.transaction.Fiscalyear != null && response.data.transaction.Fiscalyear != '' ? response.data.transaction.Fiscalyear : formFields.FISCALYEAR,
                        FISCALPERIOD: response.data.transaction.Fiscalperiod != null && response.data.transaction.Fiscalperiod != '' ? response.data.transaction.Fiscalperiod : formFields.FISCALPERIOD,
                        COMMITDATE: response.data.transaction.Commitdate != null && response.data.transaction.Commitdate != '' ? response.data.transaction.Commitdate : formFields.COMMITDATE,
                        CONSOLIDATEDINVOICE: response.data.transaction.Consolidatedinvoice != null && response.data.transaction.Consolidatedinvoice != '' ? response.data.transaction.Consolidatedinvoice : formFields.CONSOLIDATEDINVOICE,
                        TRANSFERTODISPATCH: response.data.transaction.Transfertodispatch != null && response.data.transaction.Transfertodispatch != '' ? response.data.transaction.Transfertodispatch : formFields.TRANSFERTODISPATCH,
                        R_EQUIPMENT: response.data.transaction.REquipment != null && response.data.transaction.REquipment != '' ? response.data.transaction.REquipment : formFields.R_EQUIPMENT,
                        R_BATCH: response.data.transaction.RBatch != null && response.data.transaction.RBatch != '' ? response.data.transaction.RBatch : formFields.R_BATCH,
                        STAGINGSTARTDATE: response.data.transaction.Stagingstartdate != null && response.data.transaction.Stagingstartdate != '' ? response.data.transaction.Stagingstartdate : formFields.STAGINGSTARTDATE,
                        R_UNLOADPICKBY: response.data.transaction.RUnloadpickby != null && response.data.transaction.RUnloadpickby != '' ? response.data.transaction.RUnloadpickby : formFields.R_UNLOADPICKBY,
                        R_CHECKBY: response.data.transaction.RCheckby != null && response.data.transaction.RCheckby != '' ? response.data.transaction.RCheckby : formFields.R_CHECKBY,
                        R_PUTAWAYBY: response.data.transaction.RPutawayby != null && response.data.transaction.RPutawayby != '' ? response.data.transaction.RPutawayby : formFields.R_PUTAWAYBY,
                        UNLOADPICKBYPLANDATE: response.data.transaction.Unloadpickbyplandate != null && response.data.transaction.Unloadpickbyplandate != '' ? response.data.transaction.Unloadpickbyplandate : formFields.UNLOADPICKBYPLANDATE,
                        CHECKBYPLANDATE: response.data.transaction.Checkbyplandate != null && response.data.transaction.Checkbyplandate != '' ? response.data.transaction.Checkbyplandate : formFields.CHECKBYPLANDATE,
                        PUTAWAYBYPLANDATE: response.data.transaction.Putawaybyplandate != null && response.data.transaction.Putawaybyplandate != '' ? response.data.transaction.Putawaybyplandate : formFields.PUTAWAYBYPLANDATE,
                        UNLOADPICKBYHOURS: response.data.transaction.Unloadpickbyhours != null && response.data.transaction.Unloadpickbyhours != '' ? response.data.transaction.Unloadpickbyhours : formFields.UNLOADPICKBYHOURS,
                        CHECKBYHOURS: response.data.transaction.Checkbyhours != null && response.data.transaction.Checkbyhours != '' ? response.data.transaction.Checkbyhours : formFields.CHECKBYHOURS,
                        PUTAWAYBYHOURS: response.data.transaction.Putawaybyhours != null && response.data.transaction.Putawaybyhours != '' ? response.data.transaction.Putawaybyhours : formFields.PUTAWAYBYHOURS,
                        R_PLANWAREHOUSE: response.data.transaction.RPlanwarehouse != null && response.data.transaction.RPlanwarehouse != '' ? response.data.transaction.RPlanwarehouse : formFields.R_PLANWAREHOUSE,
                        R_PLANLOCATION: response.data.transaction.RPlanlocation != null && response.data.transaction.RPlanlocation != '' ? response.data.transaction.RPlanlocation : formFields.R_PLANLOCATION,
                        PLANRESOURCESCODE: response.data.transaction.Planresourcescode != null && response.data.transaction.Planresourcescode != '' ? response.data.transaction.Planresourcescode : formFields.PLANRESOURCESCODE,
                        PLANREFERENCE: response.data.transaction.Planreference != null && response.data.transaction.Planreference != '' ? response.data.transaction.Planreference : formFields.PLANREFERENCE,
                        PLANRESOURCESHOURS: response.data.transaction.Planresourceshours != null && response.data.transaction.Planresourceshours != '' ? response.data.transaction.Planresourceshours : formFields.PLANRESOURCESHOURS,
                        TRANSPORTATIONYARDLEAVEDATE: response.data.transaction.Transportationyardleavedate != null && response.data.transaction.Transportationyardleavedate != '' ? response.data.transaction.Transportationyardleavedate : formFields.TRANSPORTATIONYARDLEAVEDATE,
                        R_TRANSPORTATIONWAREHOUSE: response.data.transaction.RTransportationwarehouse != null && response.data.transaction.RTransportationwarehouse != '' ? response.data.transaction.RTransportationwarehouse : formFields.R_TRANSPORTATIONWAREHOUSE,
                        R_TRANSPORTATIONLOCATION: response.data.transaction.RTransportationlocation != null && response.data.transaction.RTransportationlocation != '' ? response.data.transaction.RTransportationlocation : formFields.R_TRANSPORTATIONLOCATION,
                        STAGINGENDDATE: response.data.transaction.Stagingenddate != null && response.data.transaction.Stagingenddate != '' ? response.data.transaction.Stagingenddate : formFields.STAGINGENDDATE,
                        EDITRANSMITFLAG: response.data.transaction.Editransmitflag != null && response.data.transaction.Editransmitflag != '' ? response.data.transaction.Editransmitflag : formFields.EDITRANSMITFLAG,
                        PLANCOMMENT: response.data.transaction.Plancomment != null && response.data.transaction.Plancomment != '' ? response.data.transaction.Plancomment : formFields.PLANCOMMENT,
                        PRINTPICKINGSLIP: response.data.transaction.Printpickingslip != null && response.data.transaction.Printpickingslip != '' ? response.data.transaction.Printpickingslip : formFields.PRINTPICKINGSLIP,
                        PRINTSERIALNUMBERMANIFEST: response.data.transaction.Printserialnumbermanifest != null && response.data.transaction.Printserialnumbermanifest != '' ? response.data.transaction.Printserialnumbermanifest : formFields.PRINTSERIALNUMBERMANIFEST,
                        PRINTRECEIPTPUTAWAY: response.data.transaction.Printreceiptputaway != null && response.data.transaction.Printreceiptputaway != '' ? response.data.transaction.Printreceiptputaway : formFields.PRINTRECEIPTPUTAWAY,
                        R_FMTRANSACTIONPROFILE: response.data.transaction.RFmtransactionprofile != null && response.data.transaction.RFmtransactionprofile != '' ? response.data.transaction.RFmtransactionprofile : formFields.R_FMTRANSACTIONPROFILE,
                        R_TRANSPORTCARRIER: response.data.transaction.RTransportcarrier != null && response.data.transaction.RTransportcarrier != '' ? response.data.transaction.RTransportcarrier : formFields.R_TRANSPORTCARRIER,
                        EQUIPMENTTYPE: response.data.transaction.Equipmenttype != null && response.data.transaction.Equipmenttype != '' ? response.data.transaction.Equipmenttype : formFields.EQUIPMENTTYPE,
                        EMBARCTRANSMITFLAG: response.data.transaction.Embarctransmitflag != null && response.data.transaction.Embarctransmitflag != '' ? response.data.transaction.Embarctransmitflag : formFields.EMBARCTRANSMITFLAG,
                        R_GLDEPARTMENT: response.data.transaction.RGldepartment != null && response.data.transaction.RGldepartment != '' ? response.data.transaction.RGldepartment : formFields.R_GLDEPARTMENT,
                        R_CAJOB: response.data.transaction.RCajob != null && response.data.transaction.RCajob != '' ? response.data.transaction.RCajob : formFields.R_CAJOB,
                        R_GLFUND: response.data.transaction.RGlfund != null && response.data.transaction.RGlfund != '' ? response.data.transaction.RGlfund : formFields.R_GLFUND,
                        RFTRANSACTION: response.data.transaction.Rftransaction != null && response.data.transaction.Rftransaction != '' ? response.data.transaction.Rftransaction : formFields.RFTRANSACTION,
                        TRANSCURRENCYTYPE: response.data.transaction.Transcurrencytype != null && response.data.transaction.Transcurrencytype != '' ? response.data.transaction.Transcurrencytype : formFields.TRANSCURRENCYTYPE,
                        R_TRANSCURRENCYCODE: response.data.transaction.RTranscurrencycode != null && response.data.transaction.RTranscurrencycode != '' ? response.data.transaction.RTranscurrencycode : formFields.R_TRANSCURRENCYCODE,
                        PAYCURRENCYTYPE: response.data.transaction.Paycurrencytype != null && response.data.transaction.Paycurrencytype != '' ? response.data.transaction.Paycurrencytype : formFields.PAYCURRENCYTYPE,
                        R_PAYCURRENCYCODE: response.data.transaction.RPaycurrencycode != null && response.data.transaction.RPaycurrencycode != '' ? response.data.transaction.RPaycurrencycode : formFields.R_PAYCURRENCYCODE,
                        RATETIMING: response.data.transaction.Ratetiming != null && response.data.transaction.Ratetiming != '' ? response.data.transaction.Ratetiming : formFields.RATETIMING,
                        PRESETRATE: response.data.transaction.Presetrate != null && response.data.transaction.Presetrate != '' ? response.data.transaction.Presetrate : formFields.PRESETRATE,
                        FMTRUCKREFERENCE: response.data.transaction.Fmtruckreference != null && response.data.transaction.Fmtruckreference != '' ? response.data.transaction.Fmtruckreference : formFields.FMTRUCKREFERENCE,
                        FMDRIVERREFERENCE: response.data.transaction.Fmdriverreference != null && response.data.transaction.Fmdriverreference != '' ? response.data.transaction.Fmdriverreference : formFields.FMDRIVERREFERENCE,
                        R_TRAILER: response.data.transaction.RTrailer != null && response.data.transaction.RTrailer != '' ? response.data.transaction.RTrailer : formFields.R_TRAILER,
                        FMTRAILERRREFERENCE: response.data.transaction.Fmtrailerrreference != null && response.data.transaction.Fmtrailerrreference != '' ? response.data.transaction.Fmtrailerrreference : formFields.FMTRAILERRREFERENCE,
                        PAPINETTRANSMISSIONFLAG: response.data.transaction.Papinettransmissionflag != null && response.data.transaction.Papinettransmissionflag != '' ? response.data.transaction.Papinettransmissionflag : formFields.PAPINETTRANSMISSIONFLAG,
                        R_SMCHARGESPROFILE: response.data.transaction.RSmchargesprofile != null && response.data.transaction.RSmchargesprofile != '' ? response.data.transaction.RSmchargesprofile : formFields.R_SMCHARGESPROFILE,
                        EDITRANSMIT_CUSTOMER: response.data.transaction.EditransmitCustomer != null && response.data.transaction.EditransmitCustomer != '' ? response.data.transaction.EditransmitCustomer : formFields.EDITRANSMIT_CUSTOMER,
                        EDITRANSMIT_CONSIGNEE: response.data.transaction.EditransmitConsignee != null && response.data.transaction.EditransmitConsignee != '' ? response.data.transaction.EditransmitConsignee : formFields.EDITRANSMIT_CONSIGNEE,
                        EDITRANSMIT_SHIPPER: response.data.transaction.EditransmitShipper != null && response.data.transaction.EditransmitShipper != '' ? response.data.transaction.EditransmitShipper : formFields.EDITRANSMIT_SHIPPER,
                        EDITRANSMIT_CARRIER: response.data.transaction.EditransmitCarrier != null && response.data.transaction.EditransmitCarrier != '' ? response.data.transaction.EditransmitCarrier : formFields.EDITRANSMIT_CARRIER,
                        SOURCETABLENAME: response.data.transaction.Sourcetablename != null && response.data.transaction.Sourcetablename != '' ? response.data.transaction.Sourcetablename : formFields.SOURCETABLENAME,
                        R_SOURCEID: response.data.transaction.RSourceid != null && response.data.transaction.RSourceid != '' ? response.data.transaction.RSourceid : formFields.R_SOURCEID,
                        R_REPLENISHMENTBATCH: response.data.transaction.RReplenishmentbatch != null && response.data.transaction.RReplenishmentbatch != '' ? response.data.transaction.RReplenishmentbatch : formFields.R_REPLENISHMENTBATCH,
                        R_LOADBY: response.data.transaction.RLoadby != null && response.data.transaction.RLoadby != '' ? response.data.transaction.RLoadby : formFields.R_LOADBY,
                        R_PICKBY: response.data.transaction.RPickby != null && response.data.transaction.RPickby != '' ? response.data.transaction.RPickby : formFields.R_PICKBY,
                        LOADBYPLANDATE: response.data.transaction.Loadbyplandate != null && response.data.transaction.Loadbyplandate != '' ? response.data.transaction.Loadbyplandate : formFields.LOADBYPLANDATE,
                        PICKBYPLANDATE: response.data.transaction.Pickbyplandate != null && response.data.transaction.Pickbyplandate != '' ? response.data.transaction.Pickbyplandate : formFields.PICKBYPLANDATE,
                        LOADBYHOURS: response.data.transaction.Loadbyhours != null && response.data.transaction.Loadbyhours != '' ? response.data.transaction.Loadbyhours : formFields.LOADBYHOURS,
                        PICKBYHOURS: response.data.transaction.Pickbyhours != null && response.data.transaction.Pickbyhours != '' ? response.data.transaction.Pickbyhours : formFields.PICKBYHOURS,
                        RFGROUP: response.data.transaction.Rfgroup != null && response.data.transaction.Rfgroup != '' ? response.data.transaction.Rfgroup : formFields.RFGROUP,
                        CALCTRANSCHARGES: response.data.transaction.Calctranscharges != null && response.data.transaction.Calctranscharges != '' ? response.data.transaction.Calctranscharges : formFields.CALCTRANSCHARGES,
                        USERDEFINEDCOMMENT_2: response.data.transaction.Userdefinedcomment2 != null && response.data.transaction.Userdefinedcomment2 != '' ? response.data.transaction.Userdefinedcomment2 : formFields.USERDEFINEDCOMMENT_2,
                        USERDEFINEDCOMMENT_3: response.data.transaction.Userdefinedcomment3 != null && response.data.transaction.Userdefinedcomment3 != '' ? response.data.transaction.Userdefinedcomment3 : formFields.USERDEFINEDCOMMENT_3,
                        SHIPMENTPLANNEDDATETIMETO: response.data.transaction.Shipmentplanneddatetimeto != null && response.data.transaction.Shipmentplanneddatetimeto != '' ? response.data.transaction.Shipmentplanneddatetimeto : formFields.SHIPMENTPLANNEDDATETIMETO,
                        SHIPMENTPLANNEDDATETIMEFROM: response.data.transaction.Shipmentplanneddatetimefrom != null && response.data.transaction.Shipmentplanneddatetimefrom != '' ? response.data.transaction.Shipmentplanneddatetimefrom : formFields.SHIPMENTPLANNEDDATETIMEFROM,
                        DELIVEREDDATETIME: response.data.transaction.Delivereddatetime != null && response.data.transaction.Delivereddatetime != '' ? response.data.transaction.Delivereddatetime : formFields.DELIVEREDDATETIME,
                        USERDEFINEDCODE_11: response.data.transaction.Userdefinedcode11 != null && response.data.transaction.Userdefinedcode11 != '' ? response.data.transaction.Userdefinedcode11 : formFields.USERDEFINEDCODE_11,
                        USERDEFINEDCODE_12: response.data.transaction.Userdefinedcode12 != null && response.data.transaction.Userdefinedcode12 != '' ? response.data.transaction.Userdefinedcode12 : formFields.USERDEFINEDCODE_12,
                        USERDEFINEDCODE_13: response.data.transaction.Userdefinedcode13 != null && response.data.transaction.Userdefinedcode13 != '' ? response.data.transaction.Userdefinedcode13 : formFields.USERDEFINEDCODE_13,
                        USERDEFINEDCODE_14: response.data.transaction.Userdefinedcode14 != null && response.data.transaction.Userdefinedcode14 != '' ? response.data.transaction.Userdefinedcode14 : formFields.USERDEFINEDCODE_14,
                        USERDEFINEDCODE_15: response.data.transaction.Userdefinedcode15 != null && response.data.transaction.Userdefinedcode15 != '' ? response.data.transaction.Userdefinedcode15 : formFields.USERDEFINEDCODE_15,
                        USERDEFINEDCODE_16: response.data.transaction.Userdefinedcode16 != null && response.data.transaction.Userdefinedcode16 != '' ? response.data.transaction.Userdefinedcode16 : formFields.USERDEFINEDCODE_16,
                        USERDEFINEDCODE_17: response.data.transaction.Userdefinedcode17 != null && response.data.transaction.Userdefinedcode17 != '' ? response.data.transaction.Userdefinedcode17 : formFields.USERDEFINEDCODE_17,
                        USERDEFINEDCODE_18: response.data.transaction.Userdefinedcode18 != null && response.data.transaction.Userdefinedcode18 != '' ? response.data.transaction.Userdefinedcode18 : formFields.USERDEFINEDCODE_18,
                        USERDEFINEDCODE_19: response.data.transaction.Userdefinedcode19 != null && response.data.transaction.Userdefinedcode19 != '' ? response.data.transaction.Userdefinedcode19 : formFields.USERDEFINEDCODE_19,
                        USERDEFINEDCODE_20: response.data.transaction.Userdefinedcode20 != null && response.data.transaction.Userdefinedcode20 != '' ? response.data.transaction.Userdefinedcode20 : formFields.USERDEFINEDCODE_20,
                        USERDEFINEDDATE_11: response.data.transaction.Userdefineddate11 != null && response.data.transaction.Userdefineddate11 != '' ? response.data.transaction.Userdefineddate11 : formFields.USERDEFINEDDATE_11,
                        USERDEFINEDDATE_12: response.data.transaction.Userdefineddate12 != null && response.data.transaction.Userdefineddate12 != '' ? response.data.transaction.Userdefineddate12 : formFields.USERDEFINEDDATE_12,
                        USERDEFINEDDATE_13: response.data.transaction.Userdefineddate13 != null && response.data.transaction.Userdefineddate13 != '' ? response.data.transaction.Userdefineddate13 : formFields.USERDEFINEDDATE_13,
                        USERDEFINEDDATE_14: response.data.transaction.Userdefineddate14 != null && response.data.transaction.Userdefineddate14 != '' ? response.data.transaction.Userdefineddate14 : formFields.USERDEFINEDDATE_14,
                        USERDEFINEDDATE_15: response.data.transaction.Userdefineddate15 != null && response.data.transaction.Userdefineddate15 != '' ? response.data.transaction.Userdefineddate15 : formFields.USERDEFINEDDATE_15,
                        USERDEFINEDDATE_16: response.data.transaction.Userdefineddate16 != null && response.data.transaction.Userdefineddate16 != '' ? response.data.transaction.Userdefineddate16 : formFields.USERDEFINEDDATE_16,
                        USERDEFINEDDATE_17: response.data.transaction.Userdefineddate17 != null && response.data.transaction.Userdefineddate17 != '' ? response.data.transaction.Userdefineddate17 : formFields.USERDEFINEDDATE_17,
                        USERDEFINEDDATE_18: response.data.transaction.Userdefineddate18 != null && response.data.transaction.Userdefineddate18 != '' ? response.data.transaction.Userdefineddate18 : formFields.USERDEFINEDDATE_18,
                        USERDEFINEDDATE_19: response.data.transaction.Userdefineddate19 != null && response.data.transaction.Userdefineddate19 != '' ? response.data.transaction.Userdefineddate19 : formFields.USERDEFINEDDATE_19,
                        USERDEFINEDDATE_20: response.data.transaction.Userdefineddate20 != null && response.data.transaction.Userdefineddate20 != '' ? response.data.transaction.Userdefineddate20 : formFields.USERDEFINEDDATE_20,
                        USERDEFINEDQUANTITY_11: response.data.transaction.Userdefinedquantity11 != null && response.data.transaction.Userdefinedquantity11 != '' ? response.data.transaction.Userdefinedquantity11 : formFields.USERDEFINEDQUANTITY_11,
                        USERDEFINEDQUANTITY_12: response.data.transaction.Userdefinedquantity12 != null && response.data.transaction.Userdefinedquantity12 != '' ? response.data.transaction.Userdefinedquantity12 : formFields.USERDEFINEDQUANTITY_12,
                        USERDEFINEDQUANTITY_13: response.data.transaction.Userdefinedquantity13 != null && response.data.transaction.Userdefinedquantity13 != '' ? response.data.transaction.Userdefinedquantity13 : formFields.USERDEFINEDQUANTITY_13,
                        USERDEFINEDQUANTITY_14: response.data.transaction.Userdefinedquantity14 != null && response.data.transaction.Userdefinedquantity14 != '' ? response.data.transaction.Userdefinedquantity14 : formFields.USERDEFINEDQUANTITY_14,
                        USERDEFINEDQUANTITY_15: response.data.transaction.Userdefinedquantity15 != null && response.data.transaction.Userdefinedquantity15 != '' ? response.data.transaction.Userdefinedquantity15 : formFields.USERDEFINEDQUANTITY_15,
                        USERDEFINEDQUANTITY_16: response.data.transaction.Userdefinedquantity16 != null && response.data.transaction.Userdefinedquantity16 != '' ? response.data.transaction.Userdefinedquantity16 : formFields.USERDEFINEDQUANTITY_16,
                        USERDEFINEDQUANTITY_17: response.data.transaction.Userdefinedquantity17 != null && response.data.transaction.Userdefinedquantity17 != '' ? response.data.transaction.Userdefinedquantity17 : formFields.USERDEFINEDQUANTITY_17,
                        USERDEFINEDQUANTITY_18: response.data.transaction.Userdefinedquantity18 != null && response.data.transaction.Userdefinedquantity18 != '' ? response.data.transaction.Userdefinedquantity18 : formFields.USERDEFINEDQUANTITY_18,
                        USERDEFINEDQUANTITY_19: response.data.transaction.Userdefinedquantity19 != null && response.data.transaction.Userdefinedquantity19 != '' ? response.data.transaction.Userdefinedquantity19 : formFields.USERDEFINEDQUANTITY_19,
                        USERDEFINEDQUANTITY_20: response.data.transaction.Userdefinedquantity20 != null && response.data.transaction.Userdefinedquantity20 != '' ? response.data.transaction.Userdefinedquantity20 : formFields.USERDEFINEDQUANTITY_20,
                        USERDEFINEDREFERENCE_11: response.data.transaction.Userdefinedreference11 != null && response.data.transaction.Userdefinedreference11 != '' ? response.data.transaction.Userdefinedreference11 : formFields.USERDEFINEDREFERENCE_11,
                        USERDEFINEDREFERENCE_12: response.data.transaction.Userdefinedreference12 != null && response.data.transaction.Userdefinedreference12 != '' ? response.data.transaction.Userdefinedreference12 : formFields.USERDEFINEDREFERENCE_12,
                        USERDEFINEDREFERENCE_13: response.data.transaction.Userdefinedreference13 != null && response.data.transaction.Userdefinedreference13 != '' ? response.data.transaction.Userdefinedreference13 : formFields.USERDEFINEDREFERENCE_13,
                        USERDEFINEDREFERENCE_14: response.data.transaction.Userdefinedreference14 != null && response.data.transaction.Userdefinedreference14 != '' ? response.data.transaction.Userdefinedreference14 : formFields.USERDEFINEDREFERENCE_14,
                        USERDEFINEDREFERENCE_15: response.data.transaction.Userdefinedreference15 != null && response.data.transaction.Userdefinedreference15 != '' ? response.data.transaction.Userdefinedreference15 : formFields.USERDEFINEDREFERENCE_15,
                        USERDEFINEDREFERENCE_16: response.data.transaction.Userdefinedreference16 != null && response.data.transaction.Userdefinedreference16 != '' ? response.data.transaction.Userdefinedreference16 : formFields.USERDEFINEDREFERENCE_16,
                        USERDEFINEDREFERENCE_17: response.data.transaction.Userdefinedreference17 != null && response.data.transaction.Userdefinedreference17 != '' ? response.data.transaction.Userdefinedreference17 : formFields.USERDEFINEDREFERENCE_17,
                        USERDEFINEDREFERENCE_18: response.data.transaction.Userdefinedreference18 != null && response.data.transaction.Userdefinedreference18 != '' ? response.data.transaction.Userdefinedreference18 : formFields.USERDEFINEDREFERENCE_18,
                        USERDEFINEDREFERENCE_19: response.data.transaction.Userdefinedreference19 != null && response.data.transaction.Userdefinedreference19 != '' ? response.data.transaction.Userdefinedreference19 : formFields.USERDEFINEDREFERENCE_19,
                        USERDEFINEDREFERENCE_20: response.data.transaction.Userdefinedreference20 != null && response.data.transaction.Userdefinedreference20 != '' ? response.data.transaction.Userdefinedreference20 : formFields.USERDEFINEDREFERENCE_20,
                        RECSHIPDATETIMEAPPROVALSTATUS: response.data.transaction.Recshipdatetimeapprovalstatus != null && response.data.transaction.Recshipdatetimeapprovalstatus != '' ? response.data.transaction.Recshipdatetimeapprovalstatus : formFields.RECSHIPDATETIMEAPPROVALSTATUS,
                    }));
                }
                
                if (response.data.profile) {
                    
                    profileDataRef.current = response.data.profile;
                    console.log(profileDataRef.current);
                    ApplyProfileSettings(response.data.profile,response.data?.transaction?.Rfgroup,formFields.ROWID);
                }
            }
            else {
                console.error('Failed to get transaction profile data');
            }
        } catch (error) {
            console.error('Error fetching transaction profile data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

 

    // Date Validation Logic - WMTRANSACTIONDP.DATEVALIDATION, the +/- day window around today.
    //
    // Delphi enforces this from the two date editors' OnExit handlers, both keyed on the same profile
    // integer: edtTransactionDateExit (uWMD0002.pas:17593-17622) for the transaction date and
    // edtACTUALRECEIVEDSHIPPEDDATEExit (:18163-18192) for the actual received/shipped date. Those two
    // are the only places the message is built, and nothing in the unit calls either directly - they
    // are wired purely as OnExit in uWMD0002.dfm.
    //
    // TWO TRIGGERS, and they are not symmetric. Verified against WMD0002 in Argos 8.18:
    //
    //   * On opening the screen. Loading the record moves focus through the Trans Date editor, so
    //     edtTransactionDateExit fires before the operator touches anything and the Trans Date dialog
    //     is up as the screen paints. The Recv/Ship editor is not in that path, so its OnExit does not
    //     fire on open - even when its date is equally out of range. This asymmetry is the whole point:
    //     the port used to run BOTH arms on load, and the second dialog, whose text differs only in the
    //     field name, read as the same dialog appearing twice. See the load-time call in
    //     ApplyProfileSettings, which passes TRANSACTIONDATE and nothing else.
    //
    //   * On leaving either date editor after an edit - the trigger the rule exists for. See
    //     applyFieldChange.
    //
    // Reads everything from refs so it stays stable for applyFieldChange's empty-dep useCallback.
    //
    // Corrections carried over from the original port:
    //   * 0 means "rule off". Delphi coerced NULL to 0 then guarded `<> 0` (:17604-17609). Guarding
    //     only on `typeof === 'number'` let 0 through, and `typeof 0 === 'number'` is true - so with
    //     DATEVALIDATION = 0 the window collapsed to today and every historical transaction prompted.
    //   * the comparison is `>=`, not `>`. A date exactly DATEVALIDATION days out trips it (:17611).
    //   * skipped on a committed transaction, matching Delphi's outer `STATUS <> 'Z'` guard
    //     (:17599, :18170), and on a transaction with no profile (same line).
    //
    // Delphi's Recv/Ship arm carries one extra condition, `(Stage = 'C') or
    // (ACTUALRECEIVEDSHIPPEDDATETIME is not null)` (:18179). No separate test here: the only way that
    // second disjunct is false is an empty date, and an empty editor already returns below.
    //
    const checkDateWindow = useCallback(async (fieldName, label, { onceOnly = false } = {}) => {
        if (dateWindowPromptInFlightRef.current) {
            return;
        }
        const profile = profileDataRef.current;
        if (!profile || formFieldsRef.current?.STATUS === TransactionStatus.Committed) {
            return;
        }

        const dateValidationDays = typeof profile.Datevalidation === 'number' ? profile.Datevalidation : 0;
        if (dateValidationDays === 0) {
            return;
        }

        const field = formRefs.current[fieldName];
        if (!field?.instance) {
            return;
        }

        let value = field.instance().option("value");
        if (typeof value === 'string') {
            value = new Date(value);
        }
        if (!(value instanceof Date) || isNaN(value)) {
            return;
        }

        const stripped = new Date(value.toDateString());
        const currentDateStripped = new Date(new Date().toDateString());
        const dayDiff = Math.abs(Math.round((stripped - currentDateStripped) / 86400000));
        if (dayDiff < dateValidationDays) {
            return;
        }

        // onceOnly is for the on-open pass alone, because ApplyProfileSettings runs several times for
        // one record (GetHeaderInfoById calls it, then the load pushes R_PROFILE and TRANSACTIONTYPE
        // into their editors and handleFieldChange defers those back into it) and the operator should
        // be asked once, not once per pass. The has/add pair is synchronous, so nothing can interleave
        // between them. Leaving the field is NOT deduplicated: Delphi asks every time you exit the
        // editor, whether or not you changed the date, and that is the behaviour being matched.
        if (onceOnly) {
            const promptKey = `${fieldName}|${stripped.getTime()}`;
            if (dateWindowPromptsRef.current.has(promptKey)) {
                return;
            }
            dateWindowPromptsRef.current.add(promptKey);
        }

        const message = `The ${label} '${stripped.toLocaleDateString()}' is outside the allowed range defined in the Transaction Profile.\nPermitted Range: ±${dateValidationDays} day(s) from today's date.\nDo you want to continue?`;
        dateWindowPromptInFlightRef.current = true;
        let refocusField = false;
        try {
            // Delphi's "No" returned focus to the field and left the value alone
            // (ab_safesetfocus, :17615) — it did not revert.
            refocusField = !(await confirm(message, "Date Validation"));
        } finally {
            // Both the refocus and the release wait for the dialog to finish closing. DevExtreme
            // restores focus to whatever held it before the dialog as part of that hide, so focusing
            // the field any earlier just gets overridden - and the restore would arrive as a focusout
            // on this same field, re-entering the listener and asking again, in a loop.
            setTimeout(() => {
                if (refocusField) {
                    // Not `field.instance()?.focus()` - this ESLint version reads an optional call as a
                    // plain expression and fails the build on no-unused-expressions.
                    const instance = field.instance();
                    if (instance) {
                        instance.focus();
                    }
                }
                dateWindowPromptInFlightRef.current = false;
            }, DATE_WINDOW_DIALOG_SETTLE_MS);
        }
    }, []);

    /** The editors this rule watches, and the label each prompts under. */
    const DATE_WINDOW_FIELDS = useMemo(() => ({
        TRANSACTIONDATE: "transaction date",
        ACTUALRECEIVEDSHIPPEDDATETIME: "Recv/Ship date",
    }), []);
    /** The one arm Delphi raises as the screen opens, because loading the record moves focus through
     *  this editor and no other. The other arm is field-exit only. */
    const DATE_WINDOW_ON_LOAD_FIELD = "TRANSACTIONDATE";

    // Delphi's OnExit proper: leaving either date editor asks, whether or not the value was touched
    // (uWMD0002.pas:17593, :18163 - both are plain OnExit handlers with no change test). DevExtreme's
    // onValueChanged, which is what the shared Fields.js renderer wires up, only fires when the value
    // actually changes, so tabbing straight through an already out-of-range date said nothing.
    //
    // Delegated from the form root rather than added to Fields.js: that renderer backs every dynamic
    // form in the app, and this rule belongs to WM transactions. One listener on a container that
    // outlives the editors also survives devextreme-react rebuilding their imperative handles, which
    // an onFocusOut option set on the widget would not.
    useEffect(() => {
        const container = formContainerRef.current;
        if (!container) {
            return undefined;
        }

        const handleFocusOut = (event) => {
            for (const [fieldName, label] of Object.entries(DATE_WINDOW_FIELDS)) {
                const element = formRefs.current[fieldName]?.instance?.()?.element?.();
                if (!element || !element.contains(event.target)) {
                    continue;
                }
                // Focus moving inside the same editor - the input to its calendar button - is not an
                // exit. Delphi's OnExit does not fire for that either.
                if (event.relatedTarget && element.contains(event.relatedTarget)) {
                    return;
                }
                checkDateWindow(fieldName, label);
                return;
            }
        };

        container.addEventListener('focusout', handleFocusOut);
        return () => container.removeEventListener('focusout', handleFocusOut);
    }, [checkDateWindow, DATE_WINDOW_FIELDS]);

    function ApplyProfileSettings(profile,RFGroup,rowid) {
        
        if (!profile || !formRefs?.current) {
            return;
        }
        if(RFGroup)
        {
            if(RFGroup == "IN USE" && profile.Rftransaction == 'Y'){
                setDisableGridsForRFTransactions(true);
            }
        }
        // ShowShipper On Receipt Logic
        const shipperField = formRefs.current["R_SHIPPER"];
        const transactionTypeInstance = getFieldInstance("TRANSACTIONTYPE");
        const transactionStatusInstance = getFieldInstance("STATUS");
        // Fall back to form state when the widget is unreachable, so the profile rules are still
        // evaluated against the real values instead of against ''.
        const transactionType = transactionTypeInstance
            ? transactionTypeInstance.option("value")
            : (formFieldsRef.current?.TRANSACTIONTYPE ?? '');
        const transactionStatus = transactionStatusInstance
            ? transactionStatusInstance.option("value")
            : (formFieldsRef.current?.STATUS ?? '');
        
        if(profile?.Transactionprefix && rowid === "00000000-0000-0000-0000-000000000000" 
        && profile.TransnogenerationReceipt != "A"
        && profile.TransnogenerationReceipt != "C" )
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('value', profile?.Transactionprefix);
            }
        }
        if(profile?.Transactionprefix && rowid === "00000000-0000-0000-0000-000000000000" 
        && profile.TransnogenerationShipment != "A"
        && profile.TransnogenerationShipment != "C" )
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('value', profile?.Transactionprefix);
            }
        }
    
        if(profile?.Transactionprefix && rowid === "00000000-0000-0000-0000-000000000000" 
        && profile.TransnogenerationAdjustment != "A"
        && profile.TransnogenerationAdjustment != "C" )
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('value', profile?.Transactionprefix);
            }
        }
    
        if(profile.TransnogenerationReceipt == "A" && transactionType == 'R')
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', true);
            }
        }
        else  if(profile.TransnogenerationReceipt == "C" && transactionType == 'R' && transactionStatus != "Z")
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', false);
            }
        }else  if(profile.TransnogenerationReceipt == "U" && transactionType == 'R' && transactionStatus != "Z")
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', false);
            }
        }else  if(profile.TransnogenerationReceipt == "V" && transactionType == 'R' && transactionStatus != "Z")
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', false);
            }
        }
    
        //////////////////////////////////////////////////////
    
        if(profile.TransnogenerationShipment == "A" && transactionType == 'S')
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', true);
            }
        }
        else  if(profile.TransnogenerationShipment == "C" && transactionType == 'S' && transactionStatus != "Z")
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', false);
            }
        }else  if(profile.TransnogenerationShipment == "U" && transactionType == 'S' && transactionStatus != "Z")
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', false);
            }
        }else  if(profile.TransnogenerationShipment == "V" && transactionType == 'S' && transactionStatus != "Z")
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', false);
            }
        }
    
    
    
        //////////////////////////////////////////////////////
    
        if(profile.TransnogenerationAdjustment == "A" && transactionType == 'A')
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', true);
            }
        }
        else  if(profile.TransnogenerationAdjustment == "C" && transactionType == 'A' && transactionStatus != "Z")
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', false);
            }
        }else  if(profile.TransnogenerationAdjustment == "U" && transactionType == 'A' && transactionStatus != "Z")
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', false);
            }
        }else  if(profile.TransnogenerationAdjustment == "V" && transactionType == 'A' && transactionStatus != "Z")
        {
            if (formRefs.current["TRANSACTIONNUMBER"]) {
                formRefs.current["TRANSACTIONNUMBER"].instance().option('disabled', false);
            }
        }
    
    
    
        ///////////////////////////////////////////////////////////
    
    
    
    
        if (profile.Showshipperonreceipt == 'N' && transactionType == 'R') {
            if (shipperField?.instance) {
                shipperField.instance().option('visible', false);
            }
            if (formRefs.current["divR_SHIPPER"]) {
                formRefs.current["divR_SHIPPER"].style.display = "none";
            }
        } else {
            if (shipperField?.instance) {
                shipperField.instance().option('visible', true);
            }
            if (formRefs.current["divR_SHIPPER"]) {
                formRefs.current["divR_SHIPPER"].style.display = "block";
            }
        }

        // Delphi's on-open prompt. TRANSACTIONDATE only - see the asymmetry note on checkDateWindow.
        // ApplyProfileSettings runs more than once per record (GetHeaderInfoById calls it, then the
        // load pushes R_PROFILE and TRANSACTIONTYPE into their editors and handleFieldChange defers
        // those into applyFieldChange -> here again); checkDateWindow's own dedupe absorbs the repeats.
        checkDateWindow(DATE_WINDOW_ON_LOAD_FIELD, DATE_WINDOW_FIELDS[DATE_WINDOW_ON_LOAD_FIELD], { onceOnly: true });
    }


    // Only receipts and shipments have anything to ask about - lots, locations, and whether to bring
    // the detail lines. uWMD0002.PAS:5462 gates the dialog on exactly these two.
    const isReplicateDialogType = (transactionType) =>
        transactionType === TransactionTypes.Receipt || transactionType === TransactionTypes.Shipment;

    // What Delphi effectively uses when it skips the dialog: the three basis values are cleared and
    // bReplicateDetails is never set, so the copy is header-only.
    const HEADER_ONLY_REPLICATE = {
        headerDetails: false,
        quantityBasis: '',
        locationCodeBasis: '',
        lotCodeBasis: '',
        shipper: null,
        consignee: null,
    };

    // The three answers the WMD0113 Lot combo can give. Anything else - notably the '-1' it leaves
    // when the combo was disabled - means the question was never put to the user.
    const isShipmentLotChoice = (lotCodeBasis) =>
        lotCodeBasis === ReplicateLotBasis.AutoSelectLot
        || lotCodeBasis === ReplicateLotBasis.ExistingLot
        || lotCodeBasis === ReplicateLotBasis.ManualLot;

    // WMD0113 "Replicate Transactions" - turns the current header into a new unsaved record.
    //
    // Delphi does this with ab_ReplicateRecord (uAbQuery.pas:2902), which copies every field except
    // ROWID, followed by the fix-ups in uWMD0002.PAS:5476-5510. Both are reproduced here; the
    // TRANSACTIONNUMBER clear is what stops the copy colliding with the source on save.
    const replicateHeaderFromDialog = (params) => {
        const source = formFieldsRef.current ?? formFields;

        // Any document already marked printed goes back to "to be printed" on the copy; anything else
        // is left alone.
        const reprint = (flag) => (flag === PrintFlags.Printed ? PrintFlags.ToPrint : flag);

        const replicated = {
            ...source,

            // ab_ReplicateRecord copies everything but ROWID; KEYSEQUENCE is an identity the server
            // assigns, and RECORDNO derives from it.
            ROWID: EMPTY_GUID,
            KEYSEQUENCE: 1,
            RECORDNO: '',

            // Only applied when the dialog actually returned one, matching Delphi's <> '' guards.
            R_SHIPPER: params.shipper || source.R_SHIPPER,
            R_CONSIGNEE: params.consignee || source.R_CONSIGNEE,

            // Audit stamps belong to the new record, not the source. Delphi clears these outright,
            // but the DTO binds them as non-nullable DateTime, so they take the same "now" that
            // initialFormFields uses for a new record - the server re-stamps them on insert either way.
            CREATIONDATETIME: new Date(),
            CREATIONUSERID: '',
            LASTUPDATEDATETIME: new Date(),
            LASTUPDATEUSERID: '',

            RECORDTYPE: RecordTypes.Record,

            // A committed transaction cannot be replicated as committed.
            STATUS: source.STATUS === TransactionStatus.Committed ? TransactionStatus.Open : source.STATUS,

            // "Printed" reverts to "to be printed" - the copy has not been printed.
            PRINTRECEIPT: reprint(source.PRINTRECEIPT),
            PRINTBOL: reprint(source.PRINTBOL),
            PRINTPICKINGSLIP: reprint(source.PRINTPICKINGSLIP),
            PRINTSERIALNUMBERMANIFEST: reprint(source.PRINTSERIALNUMBERMANIFEST),
            PRINTRECEIPTPUTAWAY: reprint(source.PRINTRECEIPTPUTAWAY),

            // The copy has not been transmitted either.
            EMBARCTRANSMITFLAG: source.EMBARCTRANSMITFLAG === YesNo.Yes ? YesNo.No : source.EMBARCTRANSMITFLAG,
            EDITRANSMITFLAG: source.EDITRANSMITFLAG === EdiTransmitFlags.Sent ? EdiTransmitFlags.NotSent : source.EDITRANSMITFLAG,

            // Cleared so the profile's numbering rule assigns a fresh one.
            TRANSACTIONNUMBER: '',

            SOURCETABLENAME: ReplicateSourceTableName,

            // Not carried over: a new record has no concurrency token yet.
            ConcurrencyToken: null,
        };

        // /create-transaction and /edit-transaction are separate <Route> elements, so this component
        // is unmounted on the way there and component state does not survive. The copy travels as
        // router state and is applied by the mount effect on the other side.
        history.push('/wm/transactiondataentry/create-transaction', {
            replicatedHeader: replicated,
            // The source identity travels with the choices: the after-save step needs the header to
            // copy from, and the customer to compare against.
            replicateParams: {
                ...params,
                sourceHeaderRowId: source.ROWID,
                sourceCustomerId: source.R_CUSTOMER,
            },
        });
    };

    // Receives the header built by replicateHeaderFromDialog, on the freshly mounted
    // /create-transaction instance.
    useEffect(() => {
        const replicated = location.state?.replicatedHeader;
        if (!replicated) return;

        const params = location.state?.replicateParams;

        // Delphi copies the totals too, but they are derived from details. With none copied yet they
        // would read as a figure the record does not have.
        setSelectedTotals(initialTotals);

        skipDataLoading = true;
        setformFields(replicated);
        skipDataLoading = false;

        setIsFormSubmitted(false);
        replicateParamsRef.current = params ?? null;
        EnableControlsForNewRecord();

        // Header & Details replicates the item rows on save, and those rows belong to the source
        // customer - so the customer is locked to stop them being orphaned (uWMD0002.PAS:5507-5509).
        if (params?.headerDetails) {
            const customer = getFieldInstance("R_CUSTOMER");
            if (customer) {
                customer.option('disabled', true);
            }
        }

        // Consumed once: without this a refresh or a back-navigation would replicate again.
        history.replace(location.pathname, {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Loads the source shipment's lines and opens whichever lot dialog the WMD0113 choice calls for:
    // WMD0115 for Auto Select Lot, WMD0114 for the other two. Both read the same rows - WMD0114 shows
    // the lot columns as well.
    const openShipmentLotDialog = async (armed, newRowId, stage) => {
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/${routes.WM.GetReplicateShipmentItems}`,
                {
                    params: {
                        sourceHeaderRowId: armed.sourceHeaderRowId,
                        quantityBasis: armed.quantityBasis,
                        stage: stage,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            const items = response.data || [];
            if (items.length === 0) {
                alert(MESSAGES.REPLICATE_NO_ITEMS_TO_SHIP, MESSAGES.INFORMATION);
                return;
            }

            autoLotHeaderRef.current = { newRowId, stage, lotCodeBasis: armed.lotCodeBasis };
            setAutoLotItems(items);
            if (armed.lotCodeBasis === ReplicateLotBasis.AutoSelectLot) {
                setShowAutoLotPopup(true);
            } else {
                setShowManualLotPopup(true);
            }
        } catch (error) {
            console.error('Error loading replicate shipment items:', error);
            alert(getApiErrorMessage(error, MESSAGES.REPLICATE_DETAILS_FAILED), MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    };

    // WMD0114 / WMD0115 OK - creates the ticked lines, then reloads so the new details are shown.
    const submitAutoLotDialog = async (lines) => {
        const target = autoLotHeaderRef.current;
        setShowAutoLotPopup(false);
        setShowManualLotPopup(false);
        if (!target) return;

        setLoadPanelVisible(true);
        try {
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.WM.ReplicateShipmentDetails}`,
                {
                    newHeaderRowId: target.newRowId,
                    stage: target.stage,
                    lotCodeBasis: target.lotCodeBasis,
                    lines: lines,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.data?.success) {
                notify({ message: response.data.message, width: 600 }, 'success', 3000);

                // What the stage change did with the quantity it could not allocate - a deficit shipped
                // from a blank lot/sublot/location, or a line capped at what was available. Delphi shows
                // these after both shipment scripts and the move still stands, so this is a dialog
                // alongside the success toast rather than instead of it: a toast alone is missable, and
                // the operator needs to know some lines did not ship what was asked for.
                const warnings = response.data.warnings;
                if (warnings && warnings.length > 0) {
                    await alert(warnings.join("<br/>"), MESSAGES.WARNING);
                }

                history.push(`/wm/transactiondataentry/edit-transaction?id=${target.newRowId}`);
            } else if (response.data?.isInformation) {
                // Nothing was ticked, so nothing was created. Informational, as in Delphi - not a red
                // error alert.
                alert(response.data.message, MESSAGES.INFORMATION);
            } else {
                alert(response.data?.message || MESSAGES.REPLICATE_SHIPMENT_DETAILS_FAILED, MESSAGES.ERROR);
            }
        } catch (error) {
            console.error('Error creating replicated shipment details:', error);
            alert(getApiErrorMessage(error, MESSAGES.REPLICATE_SHIPMENT_DETAILS_FAILED), MESSAGES.ERROR);
        } finally {
            autoLotHeaderRef.current = null;
            setLoadPanelVisible(false);
        }
    };

    // Second half of WMD0113: once the replicated header is saved, copy the source transaction's
    // details onto it. Delphi does this in qeWMTransactionHeaderAfterCommit (uWMD0002.PAS:9519-9572)
    // - after the commit, not when the dialog closes.
    const replicateDetailsAfterSave = async (newRowId) => {
        const armed = replicateParamsRef.current;
        if (!armed?.headerDetails || !newRowId) return;

        // Consumed once. A later save of the same record must not replicate again.
        replicateParamsRef.current = null;

        const current = formFieldsRef.current ?? formFields;

        // Changing the customer orphans the details, so Delphi warns and creates nothing.
        if (current.R_CUSTOMER !== armed.sourceCustomerId) {
            alert(MESSAGES.REPLICATE_CUSTOMER_MISMATCH, MESSAGES.INFORMATION);
            return;
        }

        if (current.TRANSACTIONTYPE === TransactionTypes.Shipment) {
            // Delphi branches on sLotCodeBasis alone, and '-1' matches neither branch - so nothing is
            // created. That is the case where the dialog was answered on a RECEIPT, whose Lot combo is
            // disabled and therefore left unset, and the Type was changed to Shipment afterwards. The
            // user was never asked how to allocate lots, so a lot dialog here would be inventing an
            // answer and building shipment lines out of a receipt's.
            if (!isShipmentLotChoice(armed.lotCodeBasis)) {
                return;
            }

            // Auto Select Lot opens WMD0115; Replicate Existing Lot and Manually Select Lot open
            // WMD0114, which is lot-aware.
            await openShipmentLotDialog(armed, newRowId, current.STAGE);
            return;
        }

        // Tested positively rather than as "not a receipt". Any other type reaches here only if the
        // type was changed after the dialog was answered; there is no detail-replication path for it,
        // and treating it as a shipment would open a lot dialog the server then refuses.
        if (current.TRANSACTIONTYPE !== TransactionTypes.Receipt) {
            return;
        }

        setLoadPanelVisible(true);
        try {
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.WM.ReplicateTransactionDetails}`,
                {
                    sourceHeaderRowId: armed.sourceHeaderRowId,
                    newHeaderRowId: newRowId,
                    quantityBasis: armed.quantityBasis,
                    locationCodeBasis: armed.locationCodeBasis,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.data?.success) {
                notify({ message: response.data.message, width: 600 }, 'success', 3000);
                // Reload the saved record so the copied details, locations and charges are shown.
                history.push(`/wm/transactiondataentry/edit-transaction?id=${newRowId}`);
            } else {
                alert(response.data?.message || MESSAGES.REPLICATE_DETAILS_FAILED, MESSAGES.ERROR);
            }
        } catch (error) {
            console.error('Error replicating transaction details:', error);
            alert(getApiErrorMessage(error, MESSAGES.REPLICATE_DETAILS_FAILED), MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    };

    // WMD0110 Default Shipment Item Details. Delphi opens it from the header's after-commit event when
    // a new real shipment's profile offers default item lines to shipments (uWMD0002.PAS:9484-9516).
    // This gate only spares the request on every other save; the server decides again from the saved
    // header, including the customer check.
    const openDefaultShipmentItems = async (newRowId) => {
        const current = formFieldsRef.current ?? formFields;
        const allowItemDetails = profileDataRef.current?.Allowitemdetails;
        if (!newRowId
            || current.RECORDTYPE !== RecordTypes.Record
            || current.TRANSACTIONTYPE !== TransactionTypes.Shipment
            || (allowItemDetails !== AllowItemDetails.Shipments && allowItemDetails !== AllowItemDetails.Both)) {
            return;
        }

        setLoadPanelVisible(true);
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/${routes.WM.GetDefaultShipmentItems}`,
                {
                    params: { headerRowId: newRowId },
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            const result = response.data;
            if (result?.isInformation) {
                // The customer differs from the profile's default record - Delphi says so and creates nothing.
                alert(result.message, MESSAGES.INFORMATION);
                return;
            }
            if (!result?.isApplicable) return;

            defaultShipmentHeaderRef.current = newRowId;
            setDefaultShipmentItems(result);
            setShowDefaultShipmentItemsPopup(true);
        } catch (error) {
            console.error('Error loading default shipment items:', error);
            alert(getApiErrorMessage(error, MESSAGES.DEFAULT_SHIPMENT_ITEMS_LOAD_FAILED), MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    };

    // Delphi locks Profile / Customer / Transaction Type as soon as the WMD0110 dialog closes, whether
    // the user pressed OK or Cancel (uWMD0002.PAS:9505-9508): the header's lines now follow the profile's
    // defaults, so those three must not change under them.
    const lockDefaultShipmentHeaderFields = () => {
        ["R_PROFILE", "R_CUSTOMER", "TRANSACTIONTYPE"].forEach((name) => {
            if (formRefs.current[name]) {
                formRefs.current[name].instance().option('disabled', true);
            }
        });
    };

    // WMD0110 Cancel / close - nothing is created, but the three fields are locked as on OK.
    const closeDefaultShipmentItems = () => {
        setShowDefaultShipmentItemsPopup(false);
        lockDefaultShipmentHeaderFields();
    };

    // WMD0110 OK - creates the ticked lines and runs the stage change, then reloads the record, which
    // recalculates the totals. The three header fields are locked straight away, so they stay locked when
    // OK creates nothing or fails.
    const submitDefaultShipmentItems = async (lines) => {
        const headerRowId = defaultShipmentHeaderRef.current;
        setShowDefaultShipmentItemsPopup(false);
        lockDefaultShipmentHeaderFields();
        if (!headerRowId) return;

        setLoadPanelVisible(true);
        try {
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.WM.InsertDefaultShipmentDetails}`,
                { headerRowId: headerRowId, lines: lines },
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.data?.success) {
                notify({ message: response.data.message, width: 600 }, 'success', 3000);

                // What the stage change did with quantity it could not allocate. Advisory, as after the
                // replicate dialogs: the lines exist and the allocation stands.
                const warnings = response.data.warnings;
                if (warnings && warnings.length > 0) {
                    await alert(warnings.join("<br/>"), MESSAGES.WARNING);
                }

                history.push(`/wm/transactiondataentry/edit-transaction?id=${headerRowId}`);
            } else if (response.data?.isInformation) {
                // Nothing was ticked, so nothing was created. Informational, as in Delphi.
                alert(response.data.message, MESSAGES.INFORMATION);
            } else {
                alert(response.data?.message || MESSAGES.DEFAULT_SHIPMENT_ITEMS_CREATE_FAILED, MESSAGES.ERROR);
            }
        } catch (error) {
            console.error('Error creating default shipment item details:', error);
            alert(getApiErrorMessage(error, MESSAGES.DEFAULT_SHIPMENT_ITEMS_CREATE_FAILED), MESSAGES.ERROR);
        } finally {
            defaultShipmentHeaderRef.current = null;
            setLoadPanelVisible(false);
        }
    };

    const addNewRecordClick = async () => {
     const isEmptyLocations = await CheckEmptyLocations();
            if (!isEmptyLocations) return;
        const hasNoNegativeInventory = await CheckNegativeInventoryForShipment();
            if (!hasNoNegativeInventory) return;

        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        skipDataLoading = false;
        history.push('/wm/transactiondataentry/create-transaction');
        EnableControlsForNewRecord();
    }
    const CheckEmptyLocations = async () => {
        if (formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000" &&
            profileDataRef.current?.Uselocation !== 'N' && formFields.STAGE === 'C' && (profileDataRef.current?.Allowblanklocations === 'N' || profileDataRef.current?.Allowblanklocations === 'B')) {
            try {
                 setLoadPanelVisible(true);
                const response = await axios.get(`${window._env_.REACT_APP_APIS}/im/Transactionlocation/GetTransactionEmptyLocations?rowid=${formFields.ROWID}`, {
                    method: 'GET',
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                const responseData = response.data;
                    if(responseData.length > 0) {   
                    setEmptyLocations(responseData);
                    return false;
                }
            } catch (error) {
                console.error('Error fetching item detail:', error);
            }
            finally {
                 setTimeout(hideLoadPanel, 1000);
            }
        }
        return true;
    };

    // Delphi ran the shipment negative-inventory check when the operator navigated AWAY from the
    // header record - uWMD0002.pas:5313, gated on BtnPressed in [abAdd, abPrint, abFind, abReplicate,
    // abFirst, abPrior, abNext, abLast, abExit] - and Abort'ed the navigation when it found anything.
    // Back and New are the web equivalents of that gate, which is where CheckEmptyLocations (the
    // blank-location check sitting immediately above this one in Delphi, :5277) is already wired in;
    // this runs after it, in the same order. It previously ran on load instead, so it fired at the
    // wrong moment and opened the grid even on an empty result set.
    //
    // Returns false when the operator has to stay on the record.
    const CheckNegativeInventoryForShipment = async () => {
        const shipmentsOnNegativeAvailable = profileDataRef.current?.ShipmentsonnegAvl;
        const isCheckAvailable = shipmentsOnNegativeAvailable === ShipmentsOnNegativeAvailable.CheckAvailable;
        const isCheckNetAvailable = shipmentsOnNegativeAvailable === ShipmentsOnNegativeAvailable.CheckNetAvailable;

        // Delphi's guard: shipment, stage Ready or Completed, not committed, not AddMode.
        if (!formFields.ROWID || formFields.ROWID === EMPTY_GUID
            || formFields.TRANSACTIONTYPE !== TransactionTypes.Shipment
            || formFields.STATUS === TransactionStatus.Committed
            || (formFields.STAGE !== TransactionStageEnum.ReadyToReceivePickStaged
                && formFields.STAGE !== TransactionStageEnum.Completed)
            || (!isCheckAvailable && !isCheckNetAvailable)) {
            return true;
        }

        try {
            setLoadPanelVisible(true);
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/wm/TransactionDetail/GetTransactionDetailQuantitySummary?headerId=${formFields.ROWID}&useNetAvailable=${isCheckNetAvailable}`,
                {
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                });

            const negativeLocations = response.data?.data || response.data || [];
            if (negativeLocations.length === 0) {
                return true;
            }

            // Only 'N' opened the WMD0119 grid of offending locations
            // (ValidateForNegativeInventoryForShipments, :15646, which shows the form only when the
            // query returns rows and reports the message once it is closed). 'A' has no grid - it is a
            // TOP 1 probe followed by the message (:17147).
            if (isCheckNetAvailable) {
                await alert(MESSAGES.NEGATIVE_NET_AVAILABLE_QUANTITIES_EXIST, MESSAGES.WARNING);
            } else {
                setShowNegativePopup({ visible: true, data: negativeLocations });
            }
            return false;
        } catch (error) {
            // A failed probe must not strand the operator on the record; Delphi only aborted on a
            // positive result.
            console.error('Error checking negative inventory for shipment:', error);
            return true;
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    const GetShipTo = async (customerId, url, name) => {
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${url}?customerId=${customerId}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            const responseData = response.data;
            if (responseData.success) {

                const newOptions = responseData.lookups.map(item => ({
                    id: item.rowid,
                    name: item.code
                }));

                if (formRefs.current[name]) {

                    formRefs.current[name].instance().option('dataSource', newOptions);
                    formRefs.current[name].instance().option('valueExpr', 'id');
                    formRefs.current[name].instance().option('displayExpr', 'name');
                } else {
                    console.log('not found control:');
                }
            } else {
                console.error('Failed to get item detail:');
            }
        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
     
    function GetConsigneeLookupDataSource(profileId,customerId) {
        
        var consigneeDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadParams: {
                    profileId: profileId,
                    customerId: customerId,
                },
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetConsignees`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });

        return consigneeDataSource;

    }
    const applyFieldChange = useCallback((name, value, e) => {
        /*
        if (e.event) {
            var result = confirm("<i>Are you sure?</i>", "Confirm changes");
            result.then((confirmed) => {
                if (confirmed) 
                {
                  // Perform some atction
                }
                else 
                {
                    e.component.option("value", e.previousValue); // revert
                }
            });
        }
        */

        if (name == "R_PROFILE" && !skipDataLoading) {
            // TODO: Apply Placeholder ISPLACEHOLDERRECORD ApplyPlaceholderSettings edtP_ProfileExit
            GetTransactionDataFromProfile(value, data.Receipt.GetTransactionFromProfile);
            //loadLookupFromDataSource("R_CONSIGNEE", GetConsigneeLookupDataSource(value));
        }

        if (name == "TRANSACTIONTYPE" && !skipDataLoading) {
            
            const profile = profileDataRef.current;
            const rfgroup = getFieldInstance("RFGROUP")?.option('value') ?? formFieldsRef.current?.RFGROUP;
            ApplyProfileSettings(profile,rfgroup,formFields.ROWID);
            if (value == "R" || value == "A") {
                if (value == "A") {
                    if (formRefs.current["STATUS"]) {
                        formRefs.current["STATUS"].instance().option('disabled', true);
                    }

                    if (formRefs.current["R_RATESCHEDULE"]) {
                        formRefs.current["R_RATESCHEDULE"].instance().option('disabled', false);
                    }

                    if (formRefs.current["TRANSFERTODISPATCH"]) {
                        formRefs.current["TRANSFERTODISPATCH"].instance().option('disabled', true);
                    }

                    if (formRefs.current["R_FMTRANSACTIONPROFILE"]) {
                        formRefs.current["R_FMTRANSACTIONPROFILE"].instance().option('disabled', true);
                    }

                    setformFields(prevFields => ({
                        ...prevFields,
                        STAGE: "C",
                        R_CONSIGNEE: "",
                        R_RATESCHEDULE: ""
                    }));


                    // ab_EnableControl(edtP_RATESCHEDULE, true);
                }
                else {
                    if (formRefs.current["STAGE"] && formFields.ROWID !== "00000000-0000-0000-0000-000000000000") {
                        formRefs.current["STAGE"].instance().option('disabled', false);
                    }

                    if (formRefs.current["R_RATESCHEDULE"]) {
                        formRefs.current["R_RATESCHEDULE"].instance().option('disabled', false);
                    }

                    if (formRefs.current["TRANSFERTODISPATCH"]) {
                        formRefs.current["TRANSFERTODISPATCH"].instance().option('disabled', false);
                    }

                    if (formRefs.current["R_FMTRANSACTIONPROFILE"]) {
                        formRefs.current["R_FMTRANSACTIONPROFILE"].instance().option('disabled', false);
                    }

                    setformFields(prevFields => ({
                        ...prevFields,
                        R_CONSIGNEE: ""
                    }));
                    // ab_EnableControl(edtP_RATESCHEDULE, True);
                    
                }

                if (formRefs.current["R_CONSIGNEE"]) {
                    formRefs.current["R_CONSIGNEE"].instance().option('visible', false);
                }

                if (formRefs.current["divR_CONSIGNEE"]) {
                    formRefs.current["divR_CONSIGNEE"].style.display = "none";
                }

                if (profile && profile.Showshipperonreceipt == 'N') {
                    if (formRefs.current["R_SHIPPER"]) {
                        formRefs.current["R_SHIPPER"].instance().option('visible', false);
                    }

                    if (formRefs.current["divR_SHIPPER"]) {
                        formRefs.current["divR_SHIPPER"].style.display = "none";
                    }
                }
                else {
                    if (formRefs.current["R_SHIPPER"]) {
                        formRefs.current["R_SHIPPER"].instance().option('visible', true);
                    }

                    if (formRefs.current["divR_SHIPPER"]) {
                        formRefs.current["divR_SHIPPER"].style.display = "block";
                    }
                }

                // disable the freight fields when transaction is not shipment type transaction
                if (formRefs.current["FREIGHTCHARGETYPE"]) {
                    formRefs.current["FREIGHTCHARGETYPE"].instance().option('disabled', true);
                }

                if (formRefs.current["FREIGHTAMOUNT"]) {
                    formRefs.current["FREIGHTAMOUNT"].instance().option('disabled', true);
                }

                if (formRefs.current["R_FREIGHTBILLTO"]) {
                    formRefs.current["R_FREIGHTBILLTO"].instance().option('disabled', true);
                }

                if (formRefs.current["PRINTBOL"]) {
                    formRefs.current["PRINTBOL"].instance().option('disabled', true);
                }

                if (formRefs.current["PRINTPICKINGSLIP"]) {
                    formRefs.current["PRINTPICKINGSLIP"].instance().option('disabled', true);
                }

                if (formRefs.current["PRINTRECEIPT"]) {
                    formRefs.current["PRINTRECEIPT"].instance().option('disabled', false);
                }

                if (formRefs.current["PRINTRECEIPTPUTAWAY"]) {
                    formRefs.current["PRINTRECEIPTPUTAWAY"].instance().option('disabled', false);
                }
            }
            else if (value == 'S') {
                if (formRefs.current["STAGE"] && formFields.ROWID !== "00000000-0000-0000-0000-000000000000") {
                    formRefs.current["STAGE"].instance().option('disabled', false);
                }

                if (formRefs.current["R_SHIPPER"]) {
                    formRefs.current["R_SHIPPER"].instance().option('visible', true);
                }

                if (formRefs.current["divR_SHIPPER"]) {
                    formRefs.current["divR_SHIPPER"].style.display = "block";
                }

                if (formRefs.current["R_CONSIGNEE"]) {
                    formRefs.current["R_CONSIGNEE"].instance().option('visible', true);
                }

                if (formRefs.current["divR_CONSIGNEE"]) {
                    formRefs.current["divR_CONSIGNEE"].style.display = "block";
                }

                if (formRefs.current["FREIGHTCHARGETYPE"]) {
                    formRefs.current["FREIGHTCHARGETYPE"].instance().option('disabled', false);
                }

                if (formRefs.current["PRINTBOL"]) {
                    formRefs.current["PRINTBOL"].instance().option('disabled', false);
                }

                if (formRefs.current["PRINTPICKINGSLIP"]) {
                    formRefs.current["PRINTPICKINGSLIP"].instance().option('disabled', false);
                }

                if (formRefs.current["PRINTRECEIPT"]) {
                    formRefs.current["PRINTRECEIPT"].instance().option('disabled', true);
                }

                if (formRefs.current["PRINTRECEIPTPUTAWAY"]) {
                    formRefs.current["PRINTRECEIPTPUTAWAY"].instance().option('disabled', true);
                }

                if (formRefs.current["TRANSFERTODISPATCH"]) {
                    formRefs.current["TRANSFERTODISPATCH"].instance().option('disabled', false);
                }

                if (formRefs.current["R_FMTRANSACTIONPROFILE"]) {
                    formRefs.current["R_FMTRANSACTIONPROFILE"].instance().option('disabled', false);
                }

            }

        }

        if (name == "STATUS" && !skipDataLoading) {
            if (value == "H") {
                if (formRefs.current["HOLDREASON"]) {
                    formRefs.current["HOLDREASON"].instance().option('disabled', false);
                }
            }
            else {
                if (formRefs.current["HOLDREASON"]) {
                    formRefs.current["HOLDREASON"].instance().option('disabled', true);
                }

                setformFields(prevFields => ({
                    ...prevFields,
                    HOLDREASON: ''
                }));
            }
        }

        if (name == "R_CUSTOMER" && !skipDataLoading) {

            // The header info bar reads CUSTOMER_NAME, which the API fills only on load
            // (GetTransactionByRowId sets it from the customer's IDENTITYID). Nothing loads in add
            // mode, so the bar sat blank with a customer plainly selected until the record had been
            // saved and re-read. Filled from the response below instead - see the CUSTOMER_NAME
            // assignment there.
            //
            // NOT from the editor's displayValue: the profile can set this field programmatically
            // (GetTransactionDataFromProfile), and the R_CUSTOMER lookup resolves its display text
            // asynchronously from a paginated store, so displayValue is still empty at this point.
            // The response's IDENTITYID is also the exact field the server uses, so the bar reads the
            // same in add mode as after a load - displayValue would have shown the lookup's composed
            // "CODE - Description" text instead.
            const previousCustomerName = formFieldsRef.current?.CUSTOMER_NAME ?? '';

            axios.get(`${window._env_.REACT_APP_APIS}/id/Customer/GetCustomers?ROWID=${value}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`,
                    }
                }).then(response => {
                    
                    if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                        var revertValue = !ValidateCustomerCreditStatus(response.data[0]);
                        if(revertValue) //If Customer Validation is failed then just leave after showing the alert
                        {
                            return;
                        }
                        if (!revertValue) {
                            setformFields(prevFields => ({
                                ...prevFields,
                                CUSTOMER_NAME: response.data[0].IDENTITYID ?? ''
                            }));
                            if (response.data[0].IDCUSTOMER.R_RATESCHEDULE != null) {
                                setformFields(prevFields => ({
                                    ...prevFields,
                                    R_RATESCHEDULE: response.data[0].IDCUSTOMER.R_RATESCHEDULE
                                }));
                            }
                            // TODO: { adjust charge grids and currency controls if FX enabled  -- see TfrmWMD0002.edtP_CustomerExit
                            // TODO: { default currency values from the customer table - use query until fields are added to IDM0002 } -- see TfrmWMM0002.qryWMTransactionHeaderP_CUSTOMERChange
                            // TODO: Handle Customer Change Logic for RecordType = 'P'  -- see TfrmWMM0002.qryWMTransactionHeaderP_CUSTOMERChange
                            revertValue = !ValidateCustomerInvoicingSetup(response.data[0]);
                        }

                        if (revertValue) {
                            skipDataLoading = true;
                            e.component.option("value", e.previousValue);
                            skipDataLoading = false;
                            // skipDataLoading suppresses the re-entry that would have refreshed this,
                            // so put the previous customer back on the info bar by hand.
                            setformFields(prevFields => ({ ...prevFields, CUSTOMER_NAME: previousCustomerName }));
                        }
                    }
                    else {
                        alert('Could not get customer', 'Error');
                    }
                })
                .catch(() => {
                    throw 'Customer Get Error';
                });
                const selectedProfile = getFieldInstance("R_PROFILE")?.option('value') ?? formFieldsRef.current?.R_PROFILE;
                
                loadLookupFromDataSource("R_CONSIGNEE", GetConsigneeLookupDataSource(selectedProfile,value));
            // GetShipTo(value, "om/SaleOrder/GetShipTo", "R_SHIPPER");
        }

    }, []);

    const handleFieldChange = useCallback((name, value, e) => {
        // Every branch of applyFieldChange is gated on !skipDataLoading, so bail out early
        // while a programmatic revert / bulk load is in progress.
        if (skipDataLoading) {
            return;
        }
        // A value we pushed ourselves (profile load, GetHeaderInfoById, ...) is written into the
        // editor from devextreme-react's update layout effect, so this fires while React is still
        // committing. In that window every editor's imperative handle has been torn down in the
        // mutation phase and is only re-attached as the layout phase walks the tree, which leaves
        // formRefs.current[x].instance() undefined for every field React has not reached yet.
        // User edits (e.event is set) are safe; run the rest once the commit has settled.
        if (e && !e.event) {
            Promise.resolve()
                .then(() => applyFieldChange(name, value, e))
                .catch((err) => console.error('Error applying field change for', name, err));
            return;
        }
        applyFieldChange(name, value, e);
    }, [applyFieldChange]);

    const ValidateCustomerCreditStatus = (data) => {
        var returnVal = true;
        if (data.IDCUSTOMER.STATUS == 'I') {
            alert('Customer Status Is NOT ACTIVE. Please Check Customer Master For More Information', 'Error');
            return false;
        }
        else if (data.IDCUSTOMER.CREDITSTATUSFLAG == 'P') {
            let result = confirm("Customer Credit Status Is Set To REVIEW PENDING.<br/>Do You Wish To Continue?", "Confirm");
            result.then((dialogResult) => {
                if (!dialogResult) {
                    returnVal = false;
                }
            });
        }
        else if (data.IDCUSTOMER.CREDITSTATUSFLAG == 'R') {
            let result = confirm("Customer Credit Status Is Set To REVIEW REQUIRED.<br/>Do You Wish To Continue?", "Confirm");
            result.then((dialogResult) => {
                if (!dialogResult) {
                    returnVal = false;
                }
            });
        }
        else if (data.IDCUSTOMER.CREDITSTATUSFLAG == 'C') {
            let result = confirm("Customer Credit Status Is Set To RCOD.<br/>Do You Wish To Continue?", "Confirm");
            result.then((dialogResult) => {
                if (!dialogResult) {
                    returnVal = false;
                }
            });
        }
        else if (data.IDCUSTOMER.CREDITSTATUSFLAG == 'H') {
            alert('Customer Credit Status Is Set To HOLD/ORDERS NOT ALLOWED.', 'Error');
            return false;
        }

        return returnVal;
    };

    const ValidateCustomerInvoicingSetup = (data) => {
        
        var returnVal = true;
        const profile = profileDataRef.current
        if (profile && profile.Validateinvoicesetup == 'W' && profile.Validateinvoicesetup == 'A') {
            if (((data.IDCUSTOMER.WMRICCONSOLIDATIONFLAG != 'T') && (data.IDCUSTOMER.WMRTCCONSOLIDATIONFLAG == null || data.IDCUSTOMER.WMRTCFREQUENCY == null)) ||
                ((data.IDCUSTOMER.WMSICCONSOLIDATIONFLAG != 'T') && (data.IDCUSTOMER.WMSTCCONSOLIDATIONFLAG == null || data.IDCUSTOMER.WMSTCFREQUENCY == null)) ||
                ((data.IDCUSTOMER.WMAICCONSOLIDATIONFLAG != 'T') && (data.IDCUSTOMER.WMATCCONSOLIDATIONFLAG == null || data.IDCUSTOMER.WMATCFREQUENCY == null)) ||
                ((data.IDCUSTOMER.WMCICCONSOLIDATIONFLAG != 'T') && (data.IDCUSTOMER.WMCTCCONSOLIDATIONFLAG == null || data.IDCUSTOMER.WMCTCFREQUENCY == null)) ||
                (data.IDCUSTOMER.WMRICCONSOLIDATIONFLAG == null) ||
                (data.IDCUSTOMER.WMRICFREQUENCY == null) ||
                (data.IDCUSTOMER.WMSICCONSOLIDATIONFLAG == null) ||
                (data.IDCUSTOMER.WMSICFREQUENCY == null) ||
                (data.IDCUSTOMER.WMAICCONSOLIDATIONFLAG == null) ||
                (data.IDCUSTOMER.WMAICFREQUENCY == null) ||
                (data.IDCUSTOMER.WMCICCONSOLIDATIONFLAG == null) ||
                (data.IDCUSTOMER.WMCICFREQUENCY == null) ||
                (data.IDCUSTOMER.WMMTCCONSOLIDATIONFLAG == null) ||
                (data.IDCUSTOMER.WMMTCFREQUENCY == null)) {

                if (profile.Validateinvoicesetup == 'W') {
                    let result = confirm("One or More Required Fields in the WM Invoicing Setup Procedure For This Customer is EMPTY.<br/>Please Make Sure That ALL Required Fields on the WM Invoicing Tab in the Customer Master have Values. <br/>Do You Wish To Continue?", "Confirm");
                    result.then((dialogResult) => {
                        if (!dialogResult) {
                            returnVal = false;
                        }
                    });
                }

                if (profile.Validateinvoicesetup == 'A') {
                    alert('One or More Required Fields in the WM Invoicing Setup Procedure For This Customer is EMPTY.<br/>Please Make Sure That ALL Required Fields on the WM Invoicing Tab in the Customer Master have Values.', 'Error');
                    return false;
                }
            }
        }
        return returnVal;
    };

    const handlePrimaryFormLoad = useCallback(() => {
        var transactionTypes = [{ "Rowid": "R", "Code": "Receipt" }, { "Rowid": "S", "Code": "Shipment" }
            , { "Rowid": "A", "Code": "Adjustment" }];
        loadLookupClient("TRANSACTIONTYPE", transactionTypes);
        var profileDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetProfiles`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });

        loadLookupFromDataSource("R_PROFILE", profileDataSource);

        var customerDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCustomers`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });

        loadLookupFromDataSource("R_CUSTOMER", customerDataSource);

        var shipperDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetShippers`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });

        loadLookupFromDataSource("R_SHIPPER", shipperDataSource);

       
       

        var rateScheduleDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetRateSchedules`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });

        loadLookupFromDataSource("R_RATESCHEDULE", rateScheduleDataSource);

        var stages = [{ "Rowid": "P", "Code": "Plan - No Inventory Effect, No Charges" }, { "Rowid": "F", "Code": "Future Order - No Effect On Net Available, No Charges" }
            , { "Rowid": "N", "Code": "Pending - Effects Net Available, No Charges" }, { "Rowid": "R", "Code": "Ready To Receive/Pick/Staged - Effects Available, No Charges" }
            , { "Rowid": "C", "Code": "Completed/Loaded/Put Away/Transferred/Adjusted - Effects Available, Yes, Charges" }];
        loadLookupClient("STAGE", stages);
        var status = [{ "Rowid": "O", "Code": "Open" }, { "Rowid": "H", "Code": "Hold" }, { "Rowid": "L", "Code": "Ready To Commit Later" }
        , { "Rowid": "Z", "Code": "Committed" }];
        loadLookupClient("STATUS", status);

        if (formRefs.current["HOLDREASON"]) {
            formRefs.current["HOLDREASON"].instance().option('disabled', true);
        }

        

    }, []);

    // Awaited, unlike the shape this replaced. It used to fire the request and fall straight through
    // to a finally that started a 1s timer, so the load panel hid one second after the request was
    // SENT rather than after it came back - on anything slower than that the page sat there
    // un-populated with no indicator. The axios rejection also never reached the catch, because
    // nothing was attached to the promise. Every other loader on this page is already async and
    // awaits its work; this was the odd one out.
    const GetHeaderInfoById = async (id) => {
        try {
            setLoadPanelVisible(true);
            await axios.get(`${window._env_.REACT_APP_APIS}/wm/Transaction/GetTransactionByRowId?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res)=>{
                // Everything below writes state and reaches into formRefs, whose widgets are gone once
                // the form unmounts.
                if (!isMountedRef.current) {
                    return;
                }
                const responseData = res.data;
                if (responseData?.ROWID) {
                    skipDataLoading = true;
                    const transactionType = responseData.TRANSACTIONTYPE;
                    const transactionStage = responseData.STAGE;
                    const transactionStatus = responseData.STATUS;
                    if(transactionStatus == "Z"){
                        setIsCommittedTransaction(true);
                       
                    }
                    setIsLineItemExist(responseData.isLineItemExist)
                    if(transactionType == 'R' || transactionType == 'A'){
                        if (formRefs.current["R_CONSIGNEE"]) {
                            formRefs.current["R_CONSIGNEE"].instance().option('visible', false);
                        }
                        if (formRefs.current["divR_CONSIGNEE"]) {
                            formRefs.current["divR_CONSIGNEE"].style.display = "none";
                        }
                    }
                    if (transactionType !== 'A') {
                        if (
                            transactionStage === 'P' ||
                            transactionStage === 'F' ||
                            transactionStage === 'N' ||
                            transactionStage === 'R'
                        ) 
                        {
                            setIsChargesTabVisible(false);  
                        }
                        else 
                        {
                            setIsChargesTabVisible(true);  
                        }
                    } 
                    else 
                    {
                        setIsChargesTabVisible(true);  
                    }
                    setformFields(responseData);
                    skipDataLoading = false;
                    if (responseData.Profile) {
                        
                        if (responseData.Profile?.Allowuservalidation === "D") {
                            if (responseData?.UserValidationMessage) {
                                custom({
                                    title: "Warning",
                                    messageHtml: `<div>${responseData.UserValidationMessage}</div>`,
                                    buttons: [{
                                        text: "OK",
                                        onClick: () => true
                                    }]
                                }).show().then(() => {
                                    if (responseData?.Profile?.Popupmessageuser) {
                                        custom({
                                            title: "User Defined Popup Message",
                                            messageHtml: `<div>${responseData.Profile.Popupmessageuser}</div>`,
                                            width: 500, // 👈 Set your desired width here
                                            buttons: [{
                                                text: "OK",
                                                onClick: () => true
                                            }]
                                        }).show();
                                    }
                                });
                            } else if (responseData?.Profile?.Popupmessageuser) {
                                custom({
                                    title: "User Defined Popup Message",
                                    messageHtml: `<div>${responseData.Profile.Popupmessageuser}</div>`,
                                    width: 500,
                                    buttons: [{
                                        text: "OK",
                                        onClick: () => true
                                    }]
                                }).show();
                            }
                        }
                        profileDataRef.current = responseData.Profile;
                        console.log(profileDataRef.current);
                        loadLookupFromDataSource("R_CONSIGNEE", GetConsigneeLookupDataSource(responseData.Profile?.Rowid,responseData?.R_CUSTOMER));
                        if (formRefs.current && transactionStatus == "Z") {
                            
                            Object.keys(formRefs.current).forEach((key) => {
                                if(responseData.Profile?.Modifycommittedtrans === "Y"){
                                    if (key === "REFERENCE" || key === "COMMENT") return;
                                }else{
                                    setIsFormSubmitted(true);
                                }
                                const instance = formRefs.current[key]?.instance;
                                if (instance && typeof instance.option === 'function') {
                                    instance.option('disabled', true);
                                }
                            });
                        }
                       // loadLookupFromDataSource("R_CONSIGNEE", GetConsigneeLookupDataSource(responseData.Profile?.Rowid));
                        ApplyProfileSettings(responseData.Profile,responseData?.RFGROUP,responseData.ROWID);
                    }
    
                    if (formRefs.current["R_PROFILE"]) {
                        formRefs.current["R_PROFILE"].instance().option('disabled', true);
                    }
                    if (formRefs.current["STAGE"]) {
                        formRefs.current["STAGE"].instance().option('disabled', true);
                    }
                    if (formRefs.current["R_CUSTOMER"]) {
                        formRefs.current["R_CUSTOMER"].instance().option('disabled', true);
                    }
    
                    if (formRefs.current["TRANSACTIONTYPE"]) {
                        formRefs.current["TRANSACTIONTYPE"].instance().option('disabled', true);
                    }
    
    
                }
                else {
                    console.error('Failed to get transaction data');
                }
            });
            
     
        } catch (error) {
            console.error('Error failed to get transaction data:', error);
            alert(getApiErrorMessage(error, MESSAGES.FETCH_ERROR), MESSAGES.ERROR);
        } finally {
            // Immediate, not a timer: the data is in the form by the time we get here.
            if (isMountedRef.current) {
                hideLoadPanel();
            }
        }
    };
    
    
    
    useEffect(() => {
        // Record-scoped: a different transaction gets to ask its own date-window questions.
        dateWindowPromptsRef.current.clear();
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else
        {
            EnableControlsForNewRecord();
        }
    }, [props.id]);
    useEffect(() => {
        if(formFields.Profile)
            profileDataRef.current = formFields.Profile;
    }, [formFields]);

    useEffect(() => {
        changeTotals();
    }, [formFields.ROWID]);
    useEffect(() => {
        if (profileDataRef.current && formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000")
            setActionDropDownItems();
    }, [formFields.ROWID, setupData]);
    useEffect(() => {
        fetchSetupData();
    }, [fetchSetupData]);
    useEffect(() => {
        if (emptyLocations && emptyLocations.length > 0)
            setShowBlankLocations(true);
        else
            setShowBlankLocations(false);
    }, [emptyLocations]);
    const setActionDropDownItems = async () => {
        const isCreateVisible = (formFields.STATUS !== TransactionStatus.Committed && (formFields.TRANSACTIONTYPE === TransactionTypes.Receipt || formFields.TRANSACTIONTYPE === TransactionTypes.Shipment) && formFields.RECORDTYPE !== TransactionStageEnum.Plan);
        const isCommitTransactionEnabled = (formFields.STAGE === TransactionStageEnum.Completed && formFields.STATUS === TransactionStatus.ReadyToCommitLater && profileDataRef?.current?.Uselocation !== LocationStatus.NotAllowed);
        const isRecalculateCharges = (formFields.STAGE === TransactionStageEnum.Completed && formFields.STATUS === TransactionStatus.Open);
        // Check if CREATETRANSACTIONCHARGES is enabled in setup
        const isCreateTransactionChargesEnabled = setupData?.CREATETRANSACTIONCHARGES === 'Y';
        // Apply same conditions as Transaction Charges tab visibility
        // Check TRANSCHARGES setup field (same as IsChargesTabVisible logic)
        const isTransChargesEnabled = setupData?.TRANSCHARGES === 'Y';
        // Check transaction type and stage conditions (same as IsChargesTabVisible)
        const transactionType = formFields.TRANSACTIONTYPE;
        const transactionStage = formFields.STAGE;
        let isChargesTabVisibleByStage = true;
        if (transactionType !== 'A') {
            if (transactionStage === 'P' || transactionStage === 'F' || transactionStage === 'N' || transactionStage === 'R') {
                isChargesTabVisibleByStage = false;
            } else {
                isChargesTabVisibleByStage = true;
            }
        } else {
            isChargesTabVisibleByStage = true; // Always visible for Adjustment transactions
        }
        // Create Transaction Charges should only be enabled if all conditions are met:
        // 1. CREATETRANSACTIONCHARGES === 'Y' in setup
        // 2. TRANSCHARGES === 'Y' in setup (same as Transaction Charges tab)
        // 3. Stage conditions are met (same as Transaction Charges tab)
        const shouldEnableCreateTransactionCharges = isCreateTransactionChargesEnabled && isTransChargesEnabled && isChargesTabVisibleByStage;
        var items = Object.entries(Enum)
            .filter(([key, value]) => {
                if (value === Enum.ShowCrateAllocationForm && !isCreateVisible) return false;
                if(key === Enum.PrintReport1 && (!profileDataRef?.current.NavReport1Status || profileDataRef?.current.NavReport1Status === Statuses.Inactive)) return false;
                if(key === Enum.PrintReport2 && (!profileDataRef?.current.NavReport2Status || profileDataRef?.current.NavReport2Status === Statuses.Inactive)) return false;
                if(key === Enum.PrintReport3 && (!profileDataRef?.current.NavReport3Status || profileDataRef?.current.NavReport3Status === Statuses.Inactive)) return false;
                if(key === Enum.PrintReport4 && (!profileDataRef?.current.NavReport4Status || profileDataRef?.current.NavReport4Status === Statuses.Inactive)) return false;
                if(value === Enum.ExportShipmentData && (formFields.TRANSACTIONTYPE !== TransactionTypes.Shipment || !formFields.Carrier || !formFields.Carrier.INTEGRATIONEXPORTTYPE || formFields.Carrier.INTEGRATIONEXPORTTYPE === null || formFields.Carrier.INTEGRATIONEXPORTTYPE === '' || formFields.Carrier.INTEGRATIONEXPORTTYPE === 'N')) return false;
                // Create Transaction Charges should only be visible if transaction status is Committed
                if(value === Enum.CreateTransactionCharges && formFields.STATUS !== TransactionStatus.Committed) return false;
                // Create Repack Shipments should only be visible if transaction type is Receipt and stage is Ready to Receive/Pick/Staged or Completed
                if(value === Enum.CreateRepackShipments && (formFields.TRANSACTIONTYPE !== TransactionTypes.Receipt || (formFields.STAGE !== TransactionStageEnum.ReadyToReceivePickStaged && formFields.STAGE !== TransactionStageEnum.Completed))) return false;
                if(value === Enum.ShowShippingInformation && formFields.TRANSPORTATIONMODE !==TransportationModes.Rail && (!formFields.R_CUSTOMER || !formFields.R_CARRIER || !formFields.R_CONSIGNEE || !formFields.R_SHIPPER)) return false;
                // Proship Shipment is only visible if transaction type is Shipment and stage is Completed or Ready to Receive/Pick/Staged
                if(value === Enum.ProshipShipment && (formFields.TRANSACTIONTYPE !== TransactionTypes.Shipment || (formFields.STAGE !== TransactionStageEnum.Completed && formFields.STAGE !== TransactionStageEnum.ReadyToReceivePickStaged))) return false;
                return true;
            })
            .map(([key, value]) => {
                if (value === Enum.UpdateStageOperations) {
                    return { id: key, name: value, disabled: true };
                }
                if (value === Enum.GeneralOperations) {
                    return { id: key, name: value, disabled: true };
                }
                if (value === Enum.Replicate) {
                    const isEnabled = formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000";
                    return { id: key, name: value, disabled: !isEnabled };
                }
                if (value === Enum.ReplicateTransactions) {
                    // Replicating the details needs a saved header to copy from.
                    const isEnabled = formFields.ROWID && formFields.ROWID !== EMPTY_GUID;
                    return { id: key, name: value, disabled: !isEnabled };
                }
                if (value === Enum.CaptureSignature) {
                    // Enable only if transaction exists (ROWID is not empty)
                    const isEnabled = formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000";
                    return { id: key, name: value, disabled: !isEnabled };
                }
                if (value === Enum.ShowSignature) {
                    const isEnabled = formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000";
                    return { id: key, name: value, disabled: !isEnabled };
                }
                if (value === Enum.TransactionSignatures) {
                    const isEnabled = formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000";
                    return { id: key, name: value, disabled: !isEnabled };
                }
                if (value === Enum.ItemOrTransactionChargesBillTo) {
                    if (formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000" && formFields.TRANSACTIONTYPE === TransactionTypes.Shipment) {
                        return { id: key, name: value, disabled: false };
                    }
                    else
                    {
                        return { id: key, name: value, disabled: true };
                    }
                }
                if (value === Enum.CommitTransaction) {
                    return { id: key, name: value, disabled: !isCommitTransactionEnabled };
                }
                if (value === Enum.RecaluclateCharges) {
                    return { id: key, name: value, disabled: !isRecalculateCharges };
                }
                if (value === Enum.CreateTransactionCharges) {
                    // Since visibility is handled in filter, just return the item as enabled
                    return { id: key, name: value, disabled: false };
                }
                if (value === Enum.Reports) {
                    return { id: key, name: value, disabled: true };
                }
                if (key === Enum.PrintReport1) {
                        return { id: key, name: profileDataRef?.current.NavReport1Text};
                }
                if (key === Enum.PrintReport2) {
                        return { id: key, name: profileDataRef?.current.NavReport2Text };
                }
                if (key === Enum.PrintReport3) {
                        return { id: key, name: profileDataRef?.current.NavReport3Text };
                }
                if (key === Enum.PrintReport4) {
                        return { id: key, name: profileDataRef?.current.NavReport4Text };
                }
                if (value === Enum.ApplyCustomLogic) {
                    return { id: key, name: value, disabled: true };
                }
                return { id: key, name: value };
            });
            await setCustomLogicActionItems(items);
            setdDropDownItems(items);
    }
    const setCustomLogicActionItems = async (items) => {
            try {
                const extraItemsString = await fetchExtraActionItems("LIST"); // Fetch from API
                // Convert comma separated string to array of objects, ignoring empty strings
                const extraItems = Array.isArray(extraItemsString)
                    ? extraItemsString
                    : (typeof extraItemsString === 'string'
                        ? extraItemsString.split(',').map(item => item.trim()).filter(Boolean).map(name => ({ id: name+"-CustomLogic", name }))
                        : []);
                // Find the index of ApplyCustomLogic item
                const aclIndex = items.findIndex(
                    (item) => item.name === Enum.ApplyCustomLogic
                );
                if (aclIndex !== -1 && Array.isArray(extraItems) && extraItems.length > 0) {
                    // Insert the fetched items after ApplyCustomLogic
                    items.splice(aclIndex + 1, 0, ...extraItems);
                }
            } catch (e) {
                console.error(MESSAGES.FETCH_ERROR, e);
            }
    }
    const fetchExtraActionItems = async (options) => {
        try {
            setLoadPanelVisible(true);
        const response = await axios.get(
            `${window._env_.REACT_APP_APIS}/${data.WM.CallGenerateCratesStoredProcedure}`,
            {
                params: {
                    transactionHeaderId: formFields.ROWID,
                    options: options
                },
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }
        );
        return response.data;
        } catch (error) {
            console.error(MESSAGES.FETCH_ERROR, error);
        } finally {
            setLoadPanelVisible(false);
        }
    }
    
    const printReport = async (reportName, reportType, reportFormat) => {

        let fullName = "";
        let macroName = "";
        let ignoreCompany = false;

        if (reportType === ReportTypes.DotnetReport) {
            fullName = `Argos.Report.WM.${reportName}, Argos.Report.WM`;
        }
        if (reportType === ReportTypes.ArtReport) {
            fullName = "Argos.Report.AB.ABR0001, Argos.Report.AB";
        }
        if (reportType === ReportTypes.DefaultReport) {
            fullName = reportName;
        }
            var whereInfo = new Object();
              whereInfo.FieldType = ReportFieldTypes.String;
              whereInfo.FieldName = "ROWID";
              whereInfo.Operation = ReportFilterOperator.Equal;
              whereInfo.Origin = "WMTransactionHeader.ROWID";
              whereInfo.From = formFields.ROWID;
              const FilterWhereInfoList = [];
              FilterWhereInfoList.push(whereInfo);
        const reportPayload = {
            name: reportName,
            fullName: fullName,
            formatName: reportFormat,
            macroName: macroName,
            fileFormat: "PDF",
            ignoreCompany: ignoreCompany,
            parameterList: [],
            queryParameters: [],
            whereInfoList: [],
            filterWhereInfoList: FilterWhereInfoList ,
            subreportList: []
        };

        try {
            setLoadPanelVisible(true);
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${data.reports.GenerateReport}`,
                reportPayload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    }
                }
            );

            if (res.data?.isSuccess) {
                await downloadReportFile(res.data.fileName, accessToken);
            } else {
                alert(MESSAGES.ERROR_GENERATING_REPORT + res.data.errorMessage);
            }

        } catch (err) {
            alert(MESSAGES.ERROR_GENERATING_REPORT);
        }
        finally {
            setLoadPanelVisible(false);
        }
    };

    const exportShipmentData = async () => {

       
        try {
            setLoadPanelVisible(true);
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/wm/TransactionHeaderOperations/ExportShipmentData`,
                formFields.ROWID,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    }
                }
            );

            if (res.data?.success) 
            {
                alert(MESSAGES.EXPORT_SHIPMENT_DATA_SUCCESS, MESSAGES.INFORMATION);
            } 
            else 
            {
                alert(MESSAGES.ERROR_EXPORT_SHIPMENT_DATA + res.data.message, MESSAGES.ERROR);
            }

        } 
        catch (err) 
        {
            alert(MESSAGES.ERROR_EXPORT_SHIPMENT_DATA, MESSAGES.ERROR);
        }
        finally {
            setLoadPanelVisible(false);
        }
    };

    const goBack = async () => {
        const isEmptyLocations = await CheckEmptyLocations();
            if (!isEmptyLocations) return;
        const hasNoNegativeInventory = await CheckNegativeInventoryForShipment();
            if (!hasNoNegativeInventory) return;
        if(props.recordType){
            history.goBack();
        }else{
            history.push("/wm/transactiondataentry");
        }
    };

    // Through getFieldInstance, per its own warning: a truthy formRefs entry is not proof the widget
    // is reachable. addNewRecordClick calls this straight after history.push, and when that push
    // changes route the old tree is already unmounted - `.instance()` then returns undefined and the
    // `.option(...)` threw. The fresh instance mounted by the create-transaction route runs this
    // itself (see the props.id effect), so doing nothing here in that case is right.
    const EnableControlsForNewRecord = () => {
        ["R_PROFILE", "R_CUSTOMER", "TRANSACTIONTYPE"].forEach((name) => {
            // Not `getFieldInstance(name)?.option(...)` - this ESLint reads an optional call as a bare
            // expression and fails the build on no-unused-expressions.
            const instance = getFieldInstance(name);
            if (instance) {
                instance.option('disabled', false);
            }
        });
    }
    const onItemClick = async (e) => {
        
        let value = e.itemData?.id;
        let name = e.itemData?.name;
        if(value=='ShowCustomerCredit'){
            setShowCustomerCreditForm(true);
            return;
        }
        else if(value=='ShowSummaryForm'){
            setShowSummaryForm(true);
            return;
        } else if(value=='ShowCrateAllocationForm'){
            setShowCrateAllocationForm(true);
            return;
        }
        else if (name === Enum.CommitTransaction) {
            let response = await CommitWMTransactions();
            if (response && response.resultdata?.outError === Options.Yes) {
                let showErrors = await confirm(MESSAGES.COMMIT_TRANSACTION_ERROR_CONFIRM, MESSAGES.ERROR);
                if (showErrors) {
                    showTransactionCommitErrors();
                }
            }
            else if (response && response.resultdata?.recordsCommitted > 0) {
                let message= MESSAGES.COMMIT_TRANSACTION_SUCCESS;
                message=message.replace("{0}",response.resultdata?.batchKey);
                message=message.replace("{1}",response.resultdata?.recordsCommitted);
                alert(message,MESSAGES.PROCESS_COMPLETE);
            }
            else {
                alert(MESSAGES.NO_RECORD_FOUND_RANGE, MESSAGES.PROCESS_COMPLETE);
            }
            return;
        }
        else if(name==Enum.RecaluclateCharges){
            await reCalCulateCharges();
            return;
        }
        else if(name==Enum.GenerateItemTasksRecords){
            setShowGenerateItemTasksRecordsPopup(true);
            return;
        }else if(name==Enum.ShowFmTransactionDetail){
            setShowFMTransHeader(true);
            return;
        }
        else if (name==Enum.ShowContacts){
            setShowContactsPopup(true);
            return;
        }
         else if (name==Enum.ItemOrTransactionChargesBillTo){
            setShowBilltoChargesPopup(true);
            return;
        }
        else if (name === Enum.Replicate){
            setShowReplicatePopup(true);
            return;
        }
        else if (name === Enum.ReplicateTransactions){
            // The same leave-record guards New and Back run. abReplicate sits in every one of these
            // button sets in Delphi (uWMD0002.PAS:5285, 5313-5380) and a failure aborts the replicate,
            // so the record cannot be copied while it still has blank locations at Completed, or a
            // shipment the availability rules would refuse.
            const isEmptyLocations = await CheckEmptyLocations();
            if (!isEmptyLocations) return;
            const hasNoNegativeInventory = await CheckNegativeInventoryForShipment();
            if (!hasNoNegativeInventory) return;

            // The dialog is for receipts and shipments only (uWMD0002.PAS:5462). Every other type -
            // Adjustment, Storage, Miscellaneous - still replicates, but as a plain header copy with
            // no options to ask about: Delphi skips the dialog and falls straight through to
            // ab_ReplicateRecord. Opening it for those types is what sent an Adjustment down the
            // shipment path and left OK failing on a transaction the server then refused.
            if (isReplicateDialogType(formFields.TRANSACTIONTYPE)) {
                setShowReplicateTransactionsPopup(true);
            } else {
                replicateHeaderFromDialog(HEADER_ONLY_REPLICATE);
            }
            return;
        }
        else if (name === Enum.CaptureSignature){
            setShowSignatureCapturePopup(true);
            return;
        }
        else if (name === Enum.ShowSignature){
            setShowSignaturePopup(true);
            return;
        }
        else if (name === Enum.TransactionSignatures){
            setShowTransactionSignaturesPopup(true);
            return;
        }
        else if(name==Enum.Adjust_Available_Unavailable_Status){
            setShowAdjustAvailableUnavailableStatusPopup({id:formFields.ROWID,visible:true});
            return;
        }
        else if(name === Enum.CreateRepackShipments){
            setShowCreateRepackShipmentsPopup(true);
            return;
        }
        else if(name === Enum.ShowRepackShipmentRecord){
            handleShowRepackShipmentRecord();
            return;   // every sibling branch returns; the missing return here is what let this fall through
        }
        else if (name==Enum.ShowInvoices){
            setShowInvoicesPopup(true);
            return;
        }
        else if (name === Enum.CreateTransactionCharges){
            setShowCreateTransactionChargesPopup(true);
            return;
        }
        else if (name === Enum.ExportShipmentData) {
            exportShipmentData();
            return
        }

        // Only run the stage-change flow when `value` is actually a stage code.
        //
        // The else-if chain above is broken by this block: any Options entry not matched before it
        // falls straight in, and the ones handled AFTER it (ShowShippingInformation, ProshipShipment)
        // plus ShowRepackShipmentRecord (which has no early return) all landed here. That posted
        // MoveStage(currentStage, 'ProshipShipment') and wrote the action name into
        // WMTRANSACTIONHEADER.STAGE. The API now rejects a stageTo outside PFNRC, so the write is
        // already blocked server-side — this stops the client making the nonsense call at all.
        //
        // Gating here rather than reordering the branches: moving handlers across an else-if chain
        // this long is far easier to get wrong than one predicate.
        if (Object.values(TransactionStageEnum).includes(value)) {
            let stageName = e.itemData?.name || "";
            const rowId = formFields.ROWID;
    
            // Remove "Move To " prefix from stageName
            stageName = stageName.replace(/^Move To\s*/, "");
            const currentStage = formFields.STAGE;
            if (currentStage === value) {
                alert("The transaction is already at the " + stageName + " stage.", "Information");
                return;
            }
            if (isLineItemExistRef.current != null && isLineItemExistRef.current != false) {
                if (isLineItemExistRef.current === true && (value === 'P' || value === 'F' || value === 'N')) {
                    const message = `
                        Transaction STAGE will be CHANGED to <strong>Pending, Future or Plan Stage</strong>.<br><br>
                        All Transaction LOCATION records will be Created as <strong>BLANK Location Records</strong>.<br><br>
                        Do You Wish To Update Detail Records For New Stage?
                    `;
                    const result = confirm(message, "Confirm");
                    result.then((dialogResult) => {
                        if (dialogResult) {
                            ValidateTransactionBeforeStageChange(currentStage, value);
                        }
                    });
                }
                if (isLineItemExistRef.current === true && (value === 'C' || value === 'R')) {
                    const message = `Transaction STAGE will be CHANGED to. Do You Wish To Update Detail Records For New Stage?`;
                    const result = confirm(message, "Confirm");
                    result.then((dialogResult) => {
                        if (dialogResult) {
                            ValidateTransactionBeforeStageChange(currentStage, value, itemRateScheduleSideTrip(value));
                        }
                    });
                }
            }
            else
            {
                ValidateTransactionBeforeStageChange(currentStage, value, itemRateScheduleSideTrip(value));
            }
        }
        if (value === Enum.PrintReport1) {
            printReport(profileDataRef?.current.NavReport1Name, profileDataRef?.current.NavReport1Type, profileDataRef?.current.NavReport1Format);
        }
        else if (value === Enum.PrintReport2) {
            printReport(profileDataRef?.current.NavReport2Name, profileDataRef?.current.NavReport2Type, profileDataRef?.current.NavReport2Format);
        }
        else if (value === Enum.PrintReport3) {
            printReport(profileDataRef?.current.NavReport3Name, profileDataRef?.current.NavReport3Type, profileDataRef?.current.NavReport3Format);
        }
        else if (value === Enum.PrintReport4) {
            printReport(profileDataRef?.current.NavReport4Name, profileDataRef?.current.NavReport4Type, profileDataRef?.current.NavReport4Format);
        }
        else if (value === name+"-CustomLogic") {
            await fetchExtraActionItems(name[0]);
            notify(
                {
                    message: MESSAGES.CUSTOM_LOGIC_APPLIED_SUCCESS,
                    width: 300,
                },
                'success',
                3000,
            );
            return;
        }
        else if (name === Enum.ShowShippingInformation){
            GetShippingInfo(formFields.R_CUSTOMER, formFields.R_SHIPPER, formFields.R_CONSIGNEE,formFields.R_CARRIER);
        }
        else if (name === Enum.ProshipShipment){
            try {
                const response = await axios.get(
                    `${window._env_.REACT_APP_APIS}/wm/TransactionHeaderOperations/GetProShipShipment`,
                    {
                        params: { customerId: formFields.R_CUSTOMER },
                        headers: {
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        }
                    }
                );
                const exePath = response?.data?.proShipExitPath || response?.data?.ProShipExitPath;
                if (!exePath || String(exePath).trim() === '') {
                    alert("Can't find the ProShip executable. Please check WM setup.", "Warning");
                    return;
                }
                setShowProShipShipmentPopup(true);
            } catch (err) {
                console.error('Error checking ProShip executable:', err);
                alert("Can't find the ProShip executable. Please check WM setup.", "Warning");
            }
        }
    };
    const reCalCulateCharges = async () => {
        try {
            setLoadPanelVisible(true);
            const apiUrl = `${window._env_.REACT_APP_APIS}/${data.Transaction.RecalculateCharges}?headerId=${formFields.ROWID}`;
            const response = await axios.get(apiUrl, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });
            if (response) {
                notify(
                    {
                        message: MESSAGES.CHARGES_RECALCULATED_SUCCESS,
                        width: 300,
                    },
                    'success',
                    3000,
                );
            } else {
                console.error(response.data.message);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoadPanelVisible(false);
        }
    }
    const CommitWMTransactions = async () => {
        try {
            setLoadPanelVisible(true);
            const executionType = "Now";
            const delayOption = Generic.DelayOption;
            const comment =Generic.FromReadyToCommit;
            const filterWhereInfoList = [];
            filterWhereInfoList.push({
                fieldName: "ROWID",
                from: formFields.ROWID,
                operation: ReportFilterOperator.Equal,
                origin: "WMTRANSACTIONHEADER.ROWID",
                visible: true
            });
            let payload = { filterWhereInfoList: filterWhereInfoList, comment: comment, executionType: executionType, delayInMilliSeconds: delayOption };

            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${data.Transaction.CommitTransactions}`,
                JSON.stringify(payload),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            return res.data;
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoadPanelVisible(false);
        }
    };
   const showTransactionCommitErrors = async (e) => {
        const data = await GetABErrorswData();
        if(data && data.length > 0){
          setTransactionCommitErrors(data);
          setShowCommitErrorsPopup(true);
        }
    }
    const GetABErrorswData = async () => {
    try {
      setLoadPanelVisible(true);
      const res = await axios.post(
        `${window._env_.REACT_APP_APIS}/${data.OM.GetABErrorsHeaders}`,
        JSON.stringify(Generic.WebWMCommitTransaction),
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return res.data; 
    } catch (error) {
      throw error;
    }
    finally {
      setLoadPanelVisible(false);
    }
  };
    const handleTransferToFM = async () => {
        
  const transactionType = formFields.TRANSACTIONTYPE; 
  const transferToDispatch = formFields.TRANSFERTODISPATCH; 
  const isDispatchType = ['Y', 'D', 'B', 'S'].includes(transferToDispatch);
  const fromStage=profileDataRef?.current?.FromstageFmtransfer;
  const isValidTransfer = validateTransferToFM(formFields.STAGE, fromStage);

  if (!isValidTransfer || !isDispatchType || !['S', 'R'].includes(transactionType)) return true;

  if (!formFields.R_FMTRANSACTIONPROFILE) {
    if (transferToDispatch === 'Y') {
      alert('FM Freight Bill Profile Cannot Be Blank In Order To Transfer This Record To FM.\nSee Transportation Tab For More Information',"Warning");
    } else {
      alert('FM Dispatch Object Profile Cannot Be Blank In Order To Transfer This Record To FM.\nSee Transportation Tab For More Information',"Warning");
    }
    return false;
  }

  if (!formFields.R_SHIPPER) {
    alert('Shipper Cannot Be Blank In Order To Transfer This Record To FM.\nSee Transportation Tab For More Information',"Warning");
    return false;
  }

  if (!formFields.R_CONSIGNEE && transactionType === 'S') {
    alert('Consignee Cannot Be Blank In Order To Transfer This Record To FM.\nSee Transportation Tab For More Information',"Warning");
    return false;
  }

  if (!formFields.R_TRANSPORTCARRIER) {
    alert('Transport Carrier Cannot Be Blank In Order To Transfer This Record To FM.\nSee Transportation Tab For More Information',"Warning");
    return false;
  }
  return true;

};
function validateTransferToFM(stage, fromStageTransferCode) {
  switch (fromStageTransferCode) {
    case 'P': return true;
    case 'F': return ['F', 'N', 'R', 'C'].includes(stage);
    case 'N': return ['N', 'R', 'C'].includes(stage);
    case 'R': return ['R', 'C'].includes(stage);
    case 'C': return stage === 'C';
    default: return false;
  }
}
    const DeleteClick = async () => {
        
        let result = confirm("<i>Are your sure you want to delete this record?</i>", "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                try 
                {
                    const res = await axios.post(`${window._env_.REACT_APP_APIS}/${'wm/Transaction/ValidateTransactionBeforeDelete'}`, formFields.ROWID, {
                        headers: {
                            'Content-Type': 'application/json',
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        },
                    });
                    /////////////
                    if (res.data.issuccess) {
                        ////delete transaction
                        DeleteTransaction();
                    }
                    else if (res.data.iswarning) {
                        let result = confirm("<i>" + res.data.message + "</i>", "Confirm");
                        result.then(async (dialogResult) => {
                            if (dialogResult) {
                                DeleteTransaction();
                            }
                            else {
                                setIsFormSubmitted(false);
                                setLoadPanelVisible(false);
                            }
                        });
                    }
                    else {
                        alert(res.data.message, "Warning");
                        setIsFormSubmitted(false);
                        setLoadPanelVisible(false);
                    }
                    ///////////////
                } 
                catch (error) 
                {
                    
                    setLoadPanelVisible(false);

                    if(error.response.data.ERRORS && error.response.data.ERRORS.length > 0)
                    {
                        const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                        custom({
                            title: "Errors",
                            messageHtml: errorHtml,
                            buttons: [{ text: "OK", onClick: () => { } }]
                        }).show();
                    }
                    else
                    {
                        notify(
                            {
                                message: "Could not delete item. An error occurred",
                                width: 100,
                            },
                            'error',
                            3000,
                        );
                    }
                } 
            }
        })
    }

    const DeleteTransaction = async () => {
        
        setLoadPanelVisible(true);
        try 
        {
            const res = await axios.post(`${window._env_.REACT_APP_APIS}/${'wm/Transaction/DeleteTransaction'}`, formFields.ROWID, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (res.data.issuccess) {
                notify(
                    {
                        message: "Transaction Deleted",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setLoadPanelVisible(false);
                history.push('/wm/transactiondataentry');
            }
            else {
                alert(res.data.message, "Error");
                setIsFormSubmitted(false);
                setLoadPanelVisible(false);
            }
        } 
        catch (error) 
        {
            setLoadPanelVisible(false);
            setIsFormSubmitted(false);
            // A version conflict is already handled globally by the axios interceptor.
            if (error?.[CONCURRENCY_HANDLED])
            {
                return;
            }
            // The branch that used to be here read `error.response.data.ERRORS`, which this endpoint never
            // produces — ERRORS belongs to APIResult (ID/IM/OM), whereas the delete endpoints return
            // CreateUpateApiResponse with lowercase `errors`. It was also unguarded, so a network failure
            // threw a TypeError on `error.response` instead of showing the user anything.
            notify(
                {
                    message: formatErrorList(error?.response?.data?.errors, ERROR_SEVERITY.ERROR)
                        || getApiErrorMessage(error, "Could not delete Transaction. An error occurred"),
                    width: 100,
                },
                'error',
                3000,
            );
        }
    }

    // ACCESSRATESCHEDULE = 'Y' moving to Completed opens WMD0054 (Select Item Rate Schedule).
    //
    // In Delphi this was a SIDE-TRIP, never a gate: edtStageChange had already set the stage to 'C' on
    // the record, and the dialog was opened from the *else* branch of the TransactionIsValid check
    // (uWMD0002.pas:6541-6557). Only the failure branch reverted the stage. SelectItemRateSchedule
    // (:10365-10419) itself never touched the stage — on OK in mode 'A' it did nothing beyond letting
    // WMD0054 update the item/lot rate schedules, and on Cancel it did nothing at all. Either way the
    // transaction still completed.
    //
    // The web port had inverted it into a gate — the dialog was shown *instead of* the stage change —
    // and the only code in the dialog that called back to move the stage (handleGenerateClick) was
    // never bound to a button, so with this profile flag set the stage could never reach Completed.
    // Now the stage moves first and the dialog opens afterwards, only once the move has succeeded,
    // which is where Delphi opened it.
    const itemRateScheduleSideTrip = (stageTo) => {
        const accessRateSchedule = profileDataRef?.current?.Accessrateschedule;
        if (stageTo !== TransactionStage.Completed || accessRateSchedule !== Options.Yes) {
            return undefined;
        }
        return () => setShowItemRateScheduleDialog(true);
    };

    const ValidateTransactionBeforeStageChange = async (stageFrom,stageTo,onStageMoved) => {
        
        setLoadPanelVisible(true);
                try 
                {
                    const requestBody = {
                        rowId: formFields.ROWID,
                        stageFrom: stageFrom,
                        stageTo: stageTo
                    };
                    
                    const res = await axios.post(`${window._env_.REACT_APP_APIS}/${'wm/TransactionDataProfile/ValidateTransactionBeforeStageChange'}`, requestBody, {
                        headers: {
                            'Content-Type': 'application/json',
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        },
                    });
                    /////////////
                    if (res.data.issuccess) {
                        ////MoveStage  
                        MoveStage(stageFrom,stageTo,onStageMoved);
                    }
                    else if (res.data.iswarning) {
                        let result = confirm("<i>" + res.data.message + "</i>", "Confirm");
                        result.then(async (dialogResult) => {
                            if (dialogResult) {
                                MoveStage(stageFrom,stageTo,onStageMoved);
                            }
                            else {
                                setIsFormSubmitted(false);
                                setLoadPanelVisible(false);
                            }
                        });
                    }
                    else {
                        alert(res.data.message, "Warning");
                        setIsFormSubmitted(false);
                        setLoadPanelVisible(false);
                    }
                    ///////////////
                } 
                catch (error) 
                {
                    
                    setLoadPanelVisible(false);

                    if(error.response.data.ERRORS && error.response.data.ERRORS.length > 0)
                    {
                        const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                        custom({
                            title: "Errors",
                            messageHtml: errorHtml,
                            buttons: [{ text: "OK", onClick: () => { } }]
                        }).show();
                    }
                    else
                    {
                        notify(
                            {
                                message: "Could not delete item. An error occurred",
                                width: 100,
                            },
                            'error',
                            3000,
                        );
                    }
                } 
    }
    // Reloads every grid on the Details tab. Each ref is guarded because the sub-lot and location grids
    // live inside the Details tab's own child TabPanel and are only mounted while that tab is showing -
    // `current` is null otherwise. Same `?.instance` idiom the tab itself uses.
    const refreshDetailTabGrids = () => {
        if (detailsTabGrid.current?.instance) {
            detailsTabGrid.current.instance().refresh();
        }
        if (subLotdataGrid.current?.instance) {
            subLotdataGrid.current.instance().refresh();
        }
        if (locationDataGrid.current?.instance) {
            locationDataGrid.current.instance().refresh();
        }
    };

const MoveStage = async (stageFrom,stageTo,onStageMoved) => {
        setLoadPanelVisible(true);
        try
        {
            const requestBody = {
                rowId: formFields.ROWID,
                stageFrom: stageFrom,
                stageTo: stageTo
            };
            
            const res = await axios.post(`${window._env_.REACT_APP_APIS}/${'wm/TransactionDataProfile/MoveStage'}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (res.data.issuccess) {
                notify(
                    {
                        message: "The stage has been moved successfully.",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setLoadPanelVisible(false);
                GetHeaderInfoById(formFields.ROWID);

                // GetHeaderInfoById reloads the header only. SPWM_STAGECHANGE also rewrites the DETAIL and
                // SUB-DETAIL quantities and weights, reallocates IMTRANSACTIONLOCATION, and - now that the
                // profile's allocation methods actually reach it - can insert whole detail and sub-detail
                // rows for auto lot / sub-lot selection. So every grid on the Details tab is stale the
                // moment a stage move succeeds, and the operator would otherwise be looking at pre-move
                // quantities until they navigated away and back.
                //
                // Ahead of the notes dialog below on purpose: that dialog is awaited and modal, so the
                // reloads happen while it is being read and the grids are current by the time it closes.
                refreshDetailTabGrids();

                // Informational notes on a move that SUCCEEDED. Two kinds arrive on this one channel:
                // the blank-allocation notes from SPWM_STAGECHANGE's four OUTPUT flags (a deficit
                // shipped from a blank lot/sublot/location, or a line capped at what was available),
                // and the four shipment quantity rules Delphi only evaluated on navigating away from
                // the header, each suffixed "(WEB ONLY)".
                //
                // Both are severity WARNING, never ERROR - severity is the discriminator here, not
                // whether errors[] is empty. An OK dialog, not a Confirm: neither kind blocks the
                // move, and the stage has already been updated by the time this runs. That is what
                // Delphi did for the allocation set (mtWarning / [mbOK] while the stage change stood -
                // ShowQuantityNotAvailableMessageFromStageChange, uWMD0002.pas:14585-14644) and it is
                // also what Delphi effectively did for the other four, which never stopped a stage
                // change at all.
                //
                // Awaited so it stays modal ahead of any post-move side-trip below, as it was in
                // Delphi. formatErrorList is the shared renderer for this contract - it filters on
                // severity and joins with <br/>, so there is no bespoke map/join here.
                const stageChangeNotes = formatErrorList(res.data.errors, ERROR_SEVERITY.WARNING);
                if (stageChangeNotes) {
                    await alert(
                        `${MESSAGES.STAGE_CHANGE_NOTES}<br/><br/>${stageChangeNotes}`,
                        MESSAGES.WARNING
                    );
                }

                // Post-move side-trips, e.g. the Item Rate Schedule dialog. Called only on a confirmed
                // successful move — see itemRateScheduleSideTrip for why this is not a gate.
                if (typeof onStageMoved === 'function') {
                    onStageMoved();
                }
            }
            else {
                alert(res.data.message, "Error");
                setIsFormSubmitted(false);
                setLoadPanelVisible(false);
            }
        } 
        catch (error) 
        {
            setLoadPanelVisible(false);
            setIsFormSubmitted(false);
            // A version conflict is already handled globally by the axios interceptor.
            if (error?.[CONCURRENCY_HANDLED])
            {
                return;
            }
            // The branch that used to be here read `error.response.data.ERRORS`, which this endpoint never
            // produces — ERRORS belongs to APIResult (ID/IM/OM), whereas the delete endpoints return
            // CreateUpateApiResponse with lowercase `errors`. It was also unguarded, so a network failure
            // threw a TypeError on `error.response` instead of showing the user anything.
            notify(
                {
                    message: formatErrorList(error?.response?.data?.errors, ERROR_SEVERITY.ERROR)
                        || getApiErrorMessage(error, "Could not delete Transaction. An error occurred"),
                    width: 100,
                },
                'error',
                3000,
            );
        }
    }

const GetShippingInfo = async (customer, shipper, consignee, carrier) => {
    
    try {
        setLoadPanelVisible(true);
        const payload = {
            customer,
            shipper,
            consignee,
            carrier
        };

        const response = await axios.post(
            `${window._env_.REACT_APP_APIS}/wm/Transaction/GetShippingInfo`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken
                }
            }
        );
        setShippingFormData({
            ...response.data,
            Customer: customer,
            Shipper: shipper,
            Consignee: consignee,
            Carrier: carrier
        });

        setShowShippingForm(true);
    } catch (error) {
        console.error('Error fetching shipping info:', error);
    }
    finally {
        setLoadPanelVisible(false);
    }
};
// Place this inside your React component, before the return statement

// Place this inside your component, before the return statement

const isTabBottomItemDetailVisible = useMemo(() => {
    const Allowitemdetails = profileDataRef?.current?.Allowitemdetails;
    const TransactionType = formFields.TRANSACTIONTYPE;
    const RCustomer = formFields.R_CUSTOMER;
    if(formFields.RECORDTYPE !== TransactionStageEnum.Plan){
        return false;
    }
    return (
        (Allowitemdetails === AllowItemDetails.Receipts && TransactionType === TransactionTypes.Receipt && !!RCustomer) ||
        (Allowitemdetails === AllowItemDetails.Shipments && TransactionType === TransactionTypes.Shipment && !!RCustomer) ||
        (Allowitemdetails === AllowItemDetails.Both && (TransactionType === TransactionTypes.Receipt || TransactionType === TransactionTypes.Shipment) && !!RCustomer)
    );
}, [profileDataRef.current, formFields.TRANSACTIONTYPE, formFields.R_CUSTOMER]);
const renderItem = (itemData) => {
    if (itemData.name === Enum.ApplyCustomLogic || itemData.name === Enum.Reports || itemData.name === Enum.UpdateStageOperations || itemData.name === Enum.GeneralOperations) {
      return <div style={{ fontWeight: 'bold', borderBottom: '1px solid #ccc' }}>
            {itemData.name}
    </div>;
    }
    return <>{itemData.name}</>;
  };
    return (
        <div ref={formContainerRef} style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div className="row dataEnteryMainPage" style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <div className="col-md-12 main-page" style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <div id="accordion" style={{ flex: '0 0 auto', minHeight: 0 }}>
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px',
                                                // Both margins zeroed, as on the Sales Order screen.
                                                // .title h6 in App.scss overrides only margin-top, so the
                                                // heading kept the browser's default bottom margin - and a
                                                // bottom margin bigger than the top one rides the text up
                                                // off the centre line the info bar beside it sits on.
                                                marginTop: '0px',
                                                marginBottom: 0
                                            }}
                                        >
                                            WM Enter Transaction
                                        </h6>
                                    </div>
                                </Item>
                                {/* Primary already shows all of this on the form, so the bar would just
                                    repeat it there - same rule as the Sales Order screen. */}
                                {selectedTabIndex !== 0 && (
                                    <Item location="before">
                                        <EntityInfoBar
                                            fields={[
                                                { label: 'Trans #', value: formFields.TRANSACTIONNUMBER },
                                                { label: 'Customer', value: formFields.CUSTOMER_NAME },
                                                { label: 'Trans Date', value: formFields.TRANSACTIONDATE, format: 'date' },
                                                { label: 'Stage', value: WM_STAGE_TEXT[formFields.STAGE] || formFields.STAGE },
                                            ]}
                                        />
                                    </Item>
                                )}
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                <Item location="after">
                                <DropDownButton
                                    text="Operations"
                                    icon="preferences"
                                    dropDownOptions={buttonDropDownOptions}
                                    items={dropDownItems}
                                    onItemClick={onItemClick}
                                    displayExpr="name"
                                    keyExpr="id"
                                    disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"} 
                                    itemRender={renderItem}
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" />
                                </Item>
                            </Toolbar>
                            <div className="AccordionItemBody" style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                <TabPanel className="TabpanelContainer" style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column' }}
                                    onSelectionChanged={(e) => setSelectedTabIndex(e.component.option('selectedIndex'))}>
                                    <TabItem title="Primary">
                                        <FormField
                                            currrentUser={currentUser}
                                            layoutId='b0866bc0-0acb-4b14-a624-ae3620f86f13'
                                            layoutName='WMTransactionDataEntryPrimayForm'
                                            defaultFormSchema={PrimaryLayout}
                                            formFields={formFields}
                                            setformFields={setformFields}
                                            handleFieldValueChange={handleFieldChange}
                                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                            formRefs={formRefs}
                                            onFormLoad={handlePrimaryFormLoad}
                                        />
                                        <div style={{ display: 'flex', border: '0px solid black', marginTop: '12px' }}>
                                            <div style={{ flex: 1, padding: '2px', marginLeft: '15px', width: '10vw',borderTopLeftRadius:'12px', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Record #:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {formFields.RECORDNO}
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Total Lines:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {selectedTotals.items}
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Ordered:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {selectedTotals.ordered}
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Actual:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', marginRight: '15px', width: '10vw',borderTopRightRadius:'12px', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {selectedTotals.actual}
                                            </div>

                                        </div>
                                        <div style={{ display: 'flex', border: '0px solid black', marginBottom: '12px' }}>
                                            <div style={{ flex: 1, padding: '2px', marginLeft: '15px', width: '10vw',borderBottomLeftRadius:'12px', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Net Weight:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {selectedTotals.netWeight}
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Gross Weight:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {selectedTotals.grossWeight}
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                                Amount:
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                {selectedTotals.amount}
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                                            </div>
                                            <div style={{ flex: 1, padding: '2px', marginRight: '15px', width: '10vw',borderBottomRightRadius:'12px', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                                                &nbsp;
                                            </div>
                                        </div>
                                    </TabItem>
                                    <TabItem title="Details"disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'}>
                                        <DetailsTab IsChargesTabVisible={IsChargesTabVisible}  formFields={formFields} detailGrid={detailsTabGrid} detailTransactionChargesGrid={detailTransactionChargesTabGrid} canceledItemsTabGrid={canceledItemsTabGrid}  subLotdataGridRef={subLotdataGrid}  locationDataGridRef={locationDataGrid} changeTotals={changeTotals} setIsLineItemExist={setIsLineItemExist} profile={profileDataRef.current} disableGridsForRFTransactions={disableGridsForRFTransactions} isCommittedTransaction={isCommittedTransaction} />
                                    </TabItem>
                                    <TabItem title="Additional">
                                        <AdditionalTab formFields={formFields} setformFields={setformFields}  isCommittedTransaction={isCommittedTransaction}>
                                        </AdditionalTab>
                                    </TabItem>
                                    <TabItem title="Scheduling">
                                        <SchedulingTab formFields={formFields} setformFields={setformFields}  isCommittedTransaction={isCommittedTransaction}>
                                        </SchedulingTab>
                                    </TabItem>
                                    <TabItem title="Transportation">
                                        <TransportationTab formFields={formFields} setformFields={setformFields} formRefs={formRefs} GetShippingInfo={GetShippingInfo}
                                          isCommittedTransaction={isCommittedTransaction}>
                                        </TransportationTab>
                                        
                                    </TabItem>
                                    <TabItem title="Pallet Tracking"   disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'}>
                                        <PalletTrackingTab formFields={formFields} setformFields={setformFields} headerId={formFields.ROWID} />
                                    </TabItem>
                                    <TabItem title="Transaction Charges"  visible={IsChargesTabVisible}  disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'}>
                                        <TransactionChargesTab formFields={formFields} setformFields={setformFields} headerId={formFields.ROWID} transactionChargesGrid={transactionChargesTabGrid} />
                                    </TabItem>
                                    <TabItem title="User Defined">
                                        <UserDefinedTab formFields={formFields} setformFields={setformFields} />
                                    </TabItem>
                                    <TabItem title="Labor Tracking" disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'} >
                                        <LaborTrackingTab sourceId={formFields.ROWID} rCustomer={formFields.R_CUSTOMER}  isCommittedTransaction={isCommittedTransaction}/>
                                    </TabItem>
                                    <TabItem title="RF Audit Msgs" disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'} >
                                        <RFAuditGrid transNumber={formFields.TRANSACTIONNUMBER} />
                                    </TabItem>
                                    <TabItem title="API Msgs"disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'} >
                                        <APIMessagesTab sourceId={formFields.ROWID}/>
                                    </TabItem>
                                    <TabItem title="Inspections" disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'} >
                                        <InspectionTab sourceId={formFields.ROWID}/>
                                    </TabItem>
                                    <TabItem title="Cancelled Items" disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'} >
                                        <CancelledDetailsTab sourceId={formFields.ROWID} canceledItemsTabGrid={canceledItemsTabGrid}/>
                                    </TabItem>
                                      <TabItem title="Item/Lot" visible={isTabBottomItemDetailVisible} >
                                    </TabItem>
                                </TabPanel>
                            </div>
                        </form>
                    </div>
                    <PopupShippingForm isOpen={showShippingForm} onClose={() => setShowShippingForm(false)} formData={shippingFormData}  setFormData={setShippingFormData}   />
                </div>
            </div>

            {showCustomerCreditForm && (
                <Popup
                    visible={showCustomerCreditForm}
                    onHiding={() => setShowCustomerCreditForm(false)}
                    width="60vw"
                    height="40vw"
                    title="Customer Credit Status"
                    showCloseButton={true}
                >
                    <CustomerCredit customerId={formFields.R_CUSTOMER}/>
                </Popup>
            )}
               {showSummaryForm && (
                <Popup
                    visible={showSummaryForm}
                    onHiding={() => setShowSummaryForm(false)}
                    width="60vw"
                    height="40vw"
                    title="Customer Summary Screen"
                    showCloseButton={true}
                >
                    <div style={{ height: "100%", overflow: "auto" }}>
                    <SummaryTab customerId={formFields.R_CUSTOMER}/>
                    </div>
                </Popup>
            )}
            {showCrateAllocationForm && (
                <Popup
                    visible={showCrateAllocationForm}
                    onHiding={() => setShowCrateAllocationForm(false)}
                    width="60vw"
                    height="98vh"
                    title="Crates Management Screen"
                    showCloseButton={true}
                >
                    <div style={{ height: "100%", overflow: "auto" }}>
                    <ShowCrateAllocationForm headerId={formFields.ROWID}/>
                    </div>
                </Popup>
            )}
            {showBlankLocations && (
                <Popup
                    visible={showBlankLocations}
                    onHiding={() => setShowBlankLocations(false)}
                    width="60vw"
                    height="40vw"
                    title="Display Blank Locations Information"
                    showCloseButton={true}
                >
                    <div style={{ height: "100%", overflow: "auto" }}>
                    <BlankLocationsGrid dataSource={emptyLocations}/>
                    </div>
                </Popup>
            )}
              {showItemRateScheduleDialog && (
                <Popup
                    visible={showItemRateScheduleDialog}
                    onHiding={() => setShowItemRateScheduleDialog(false)}
                    width="60vw"
                    height="98vh"
                    title="Select Item Rate Schedule"
                    showCloseButton={true}
                >
                    <div style={{ height: "100%", overflow: "auto" }}>
                    {/* No stage props: by the time this dialog opens the stage has already moved.
                        See itemRateScheduleSideTrip. */}
                    <ItemRateScheduleDialog headerId={formFields.ROWID}
                     customerId={formFields.R_CUSTOMER}
                        setShowItemRateScheduleDialog={setShowItemRateScheduleDialog}
                    />
                    </div>
                </Popup>
            )}
            {showCommitErrorsPopup && (
                <Popup
                    visible={showCommitErrorsPopup}
                    onHiding={() => setShowCommitErrorsPopup(false)}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showCloseButton={true}
                    showTitle={true}
                    title={"Print Errors"}
                    container=".dx-viewport"
                    closeOnOutsideClick={true}
                >
                    <ScrollView width="100%" height="100%">
                        <CommitTransactionsPrintErrors dataSource={transactionCommitErrors} reportname={Generic.ABR0003} reportformat={Generic.StandardAbecas} />
                    </ScrollView>
                </Popup>
            )}
            {showGenerateItemTasksRecordsPopup && (
                <Popup
                    visible={showGenerateItemTasksRecordsPopup}
                    onHiding={() => setShowGenerateItemTasksRecordsPopup(false)}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showCloseButton={true}
                    showTitle={true}
                    title={""}
                    closeOnOutsideClick={true}
                    width='64vw'
                    height='62vh'
                >
                    <GenerateItemTaskForm  transactionType={formFields.TRANSACTIONTYPE} putAwayBy = {formFields.R_PUTAWAYBY} unLoadBy={formFields.R_UNLOADPICKBY} stagingWarehouse={formFields.R_STAGINGWAREHOUSE}
                        stagingArea={formFields.R_STAGINGAREA}
                        RCaactivityPutawayby={profileDataRef.current?.RCaactivityPutawayby}
                        RCaactivityUnloadby={profileDataRef.current?.RCaactivityUnloadby}
                        RCaactivityLoadby={profileDataRef.current?.RCaactivityLoadby}
                        RCaactivityPickby={profileDataRef.current?.RCaactivityPickby}
                        TransactionHeaderRowId={formFields.ROWID}
                        setShowGenerateItemTasksRecordsPopup={setShowGenerateItemTasksRecordsPopup}
                    />
                </Popup>
            )}
            {showContactsPopup&& (
                <Popup
                    visible={showContactsPopup}
                    onHiding={() => setShowContactsPopup(false)}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showCloseButton={true}
                    showTitle={true}
                    title={"Contacts"}
                    closeOnOutsideClick={true}
                    width='64vw'
                    height='62vh'
                >
                    <Contacts CustomerRowId={formFields.R_CUSTOMER} ShipperRowId={formFields.R_SHIPPER} ConsigneeRowId={formFields.R_CONSIGNEE} />
                </Popup>
            )}
            {showFMTransHeader && (
                <Popup
                    visible={showFMTransHeader}
                    onHiding={() => setShowFMTransHeader(false)}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showCloseButton={true}
                    showTitle={true}
                    title="Show FM Details"
                    closeOnOutsideClick={true}
                    width='44vw'
                    height='25vh'
                    
                >
                        <FMTransHeader  transactionType={formFields.TRANSACTIONTYPE} putAwayBy = {formFields.R_PUTAWAYBY} unLoadBy={formFields.R_UNLOADPICKBY} stagingWarehouse={formFields.R_STAGINGWAREHOUSE}
                        stagingArea={formFields.R_STAGINGAREA}
                        RCaactivityPutawayby={profileDataRef.current?.RCaactivityPutawayby}
                        RCaactivityUnloadby={profileDataRef.current?.RCaactivityUnloadby}
                        RCaactivityLoadby={profileDataRef.current?.RCaactivityLoadby}
                        RCaactivityPickby={profileDataRef.current?.RCaactivityPickby}
                        TransactionHeaderRowId={formFields.ROWID}
                        setShowFMTransHeader={setShowFMTransHeader}/>
                     
                </Popup>
            )}
            {showBilltoChargesPopup && (
                <Popup
                    visible={showBilltoChargesPopup}
                    onHiding={() => setShowBilltoChargesPopup(false)}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showCloseButton={true}
                    showTitle={true}
                    title={"Bill-To Charges"}
                    closeOnOutsideClick={true}
                    width='20vw'
                    height='30vh'
                >
                    <BillToCharges ClosePopup={() => setShowBilltoChargesPopup(false)} Success={() => {
                        if (transactionChargesTabGrid &&
                            transactionChargesTabGrid.current &&
                            transactionChargesTabGrid.current.instance &&
                            typeof transactionChargesTabGrid.current.instance().refresh === 'function') 
                        {
                            transactionChargesTabGrid.current.instance().refresh();
                        }

                        if (detailTransactionChargesTabGrid &&
                            detailTransactionChargesTabGrid.current &&
                            detailTransactionChargesTabGrid.current.instance &&
                            typeof detailTransactionChargesTabGrid.current.instance().refresh === 'function') 
                        {
                            detailTransactionChargesTabGrid.current.instance().refresh();
                        }

                    }}  TransactionHeaderRowId={formFields.ROWID}                     />
                </Popup>
            )}
            <SignatureCapture
                visible={showSignatureCapturePopup}
                onClose={() => setShowSignatureCapturePopup(false)}
                transactionHeaderRowId={formFields.ROWID}
                accessToken={accessToken}
                onSuccess={() => {
                    // Refresh any necessary data after signature is saved
                    notify({
                        message: 'Signature captured successfully.',
                        width: 300,
                    }, 'success', 3000);
                }}
            />
            <ShowSignature
                visible={showSignaturePopup}
                onClose={() => setShowSignaturePopup(false)}
                transactionHeaderRowId={formFields.ROWID}
                accessToken={accessToken}
            />
            <TransactionSignatures
                visible={showTransactionSignaturesPopup}
                onClose={() => setShowTransactionSignaturesPopup(false)}
                transactionHeaderRowId={formFields.ROWID}
                transactionNumber={formFields.TRANSACTIONNUMBER}
                accessToken={accessToken}
                onRecapture={() => {
                    setShowTransactionSignaturesPopup(false);
                    setShowSignatureCapturePopup(true);
                }}
            />
            <ReplicateShipmentAutoLot
                visible={showAutoLotPopup}
                items={autoLotItems}
                onClose={() => setShowAutoLotPopup(false)}
                onOk={submitAutoLotDialog}
            />
            <ReplicateShipmentManualLot
                visible={showManualLotPopup}
                items={autoLotItems}
                onClose={() => setShowManualLotPopup(false)}
                onOk={submitAutoLotDialog}
            />
            <DefaultShipmentItems
                visible={showDefaultShipmentItemsPopup}
                defaults={defaultShipmentItems}
                onClose={closeDefaultShipmentItems}
                onOk={submitDefaultShipmentItems}
            />
            <ReplicateTransactions
                visible={showReplicateTransactionsPopup}
                onClose={() => setShowReplicateTransactionsPopup(false)}
                transactionType={formFields.TRANSACTIONTYPE}
                shipperId={formFields.R_SHIPPER}
                consigneeId={formFields.R_CONSIGNEE}
                lotMethodShipments={profileDataRef.current?.LotmethodShipments}
                profileId={formFields.R_PROFILE}
                customerId={formFields.R_CUSTOMER}
                accessToken={accessToken}
                onOk={(params) => {
                    setShowReplicateTransactionsPopup(false);
                    // WMD0002 keeps the choices on the data module and acts on them only after the
                    // replicated header is saved (qeWMTransactionHeaderAfterCommit), so they are
                    // parked here rather than applied now. replicateDetailsAfterSave picks them up
                    // and routes to the receipt copy or to WMD0114 / WMD0115.
                    replicateParamsRef.current = params;
                    replicateHeaderFromDialog(params);
                }}
            />
            <Replicate
                visible={showReplicatePopup}
                onClose={() => setShowReplicatePopup(false)}
                onOk={async (params) => {
                    setShowReplicatePopup(false);
                    setLoadPanelVisible(true);
                    try {
                        const response = await axios.post(
                            `${window._env_.REACT_APP_APIS}/wm/TransactionHeaderOperations/Replicate`,
                            {
                                transactionHeaderRowId: formFields.ROWID,
                                replicationCount: params.replicationCount,
                                locateFirst: params.locateFirst,
                                shipperBolNo: params.shipperBol
                            },
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    access_token: accessToken,
                                    Authorization: `Bearer ${accessToken}`
                                }
                            }
                        );
                        if (response.data?.success) {
                            notify("Transaction replicated successfully.", "success", 3000);
                            if (response.data.newRowId) {
                                history.push(`/wm/transactiondataentry/edit-transaction?id=${response.data.newRowId}`);
                            }
                        } else {
                            alert(response.data?.message || "Replication failed.", "Error");
                        }
                    } catch (error) {
                        alert(error?.response?.data?.message || error.message || "An error occurred.", "Error");
                    } finally {
                        setLoadPanelVisible(false);
                    }
                }}
            />
            {showCreateRepackShipmentsPopup && (
                <Popup
                    visible={showCreateRepackShipmentsPopup}
                    onHiding={() => setShowCreateRepackShipmentsPopup(false)}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showCloseButton={true}
                    showTitle={true}
                    title="Create Repack Shipments"
                    closeOnOutsideClick={true}
                    width='80vw'
                    height='90vh'
                >
                    <CreateRepackShipments 
                        ClosePopup={() => setShowCreateRepackShipmentsPopup(false)} 
                        TransactionHeaderRowId={formFields.ROWID}
                        Success={() => {
                            // Refresh grids if needed
                            if (detailTransactionChargesTabGrid &&
                                detailTransactionChargesTabGrid.current &&
                                detailTransactionChargesTabGrid.current.instance &&
                                typeof detailTransactionChargesTabGrid.current.instance().refresh === 'function') 
                            {
                                detailTransactionChargesTabGrid.current.instance().refresh();
                            }
                        }}
                    />
                </Popup>
            )}
            {showCreateTransactionChargesPopup && (
                <Popup
                    visible={showCreateTransactionChargesPopup}
                    onHiding={() => setShowCreateTransactionChargesPopup(false)}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showCloseButton={true}
                    showTitle={true}
                    title="Create Transaction Charges"
                    closeOnOutsideClick={true}
                    width='60vw'
                    height='90vh'
                >
                    <CreateTransactionCharges
                        ClosePopup={() => setShowCreateTransactionChargesPopup(false)}
                        TransactionHeaderRowId={formFields.ROWID}
                        Success={() => {
                            // Refresh grids if needed
                            if (detailTransactionChargesTabGrid &&
                                detailTransactionChargesTabGrid.current &&
                                detailTransactionChargesTabGrid.current.instance &&
                                typeof detailTransactionChargesTabGrid.current.instance().refresh === 'function')
                            {
                                detailTransactionChargesTabGrid.current.instance().refresh();
                            }
                        }}
                    />
                </Popup>
            )}
            <ProShipShipment
                visible={showProShipShipmentPopup}
                onClose={() => setShowProShipShipmentPopup(false)}
                customerId={formFields.R_CUSTOMER}
                headerId={formFields.ROWID}
            />
              {showInvoicesPopup&& (
                <Popup
                    visible={showInvoicesPopup}
                    onHiding={() => setShowInvoicesPopup(false)}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showCloseButton={true}
                    showTitle={true}
                    title={"Invoices"}
                    closeOnOutsideClick={true}
                    width='74vw'
                    height='72vh'
                >
                    <Invoices WMTransactionHeaderRowId={formFields.ROWID} />
                </Popup>
            )}
            <AdjustAvailableUnAvailableStatusMainPopup
                showPopup={ShowAdjustAvailableUnavailableStatusPopup}
                setShowPopup={setShowAdjustAvailableUnavailableStatusPopup}
                title="Adjust Available Unavailable Status"
            />
            <ShowNegativeValueForShipment
                visible={showNegativePopup.visible}
                onHiding={() => {
                    // Delphi showed WMD0119 modally and reported the message once it closed
                    // (uWMD0002.pas:15660 then :5322); the navigation was already cancelled by then.
                    setShowNegativePopup({ visible: false, data: [] });
                    alert(MESSAGES.NEGATIVE_AVAILABLE_QUANTITIES_EXIST, MESSAGES.WARNING);
                }}
                dataSource={showNegativePopup.data}
                transactionNumber={formFields.TRANSACTIONNUMBER}
            />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(WMTransactionDataEntryForm);
